var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _g2, _rect7, _path10, _path11, _path12, _g3, _path13, _ellipse, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g6, _path33, _path34, _path35, _g7, _path36, _path37, _path38, _g8, _path39, _path40, _path41, _g9, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _ellipse2, _path49, _path50, _g10, _path51, _path52, _path53, _g11, _path54, _ellipse3, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 197,
    viewBox: "0 0 262 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.176 30.1847C171.176 23.4148 176.664 17.9267 183.434 17.9267C190.204 17.9267 195.692 23.4148 195.692 30.1847C195.692 36.9547 190.204 42.4428 183.434 42.4428C176.664 42.4428 171.176 36.9547 171.176 30.1847ZM179.965 31.6216C180.546 33.0247 181.915 33.9395 183.434 33.9395C184.43 33.9395 185.385 33.5439 186.089 32.8397C186.793 32.1356 187.189 31.1806 187.189 30.1847C187.189 28.6661 186.274 27.297 184.871 26.7158C183.468 26.1347 181.853 26.4559 180.779 27.5297C179.705 28.6036 179.384 30.2186 179.965 31.6216Z",
    fill: "#CDE2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4092 114.962C48.4092 108.192 53.8973 102.704 60.6673 102.704C67.4372 102.704 72.9254 108.192 72.9254 114.962C72.9254 121.732 67.4372 127.22 60.6673 127.22C53.8973 127.22 48.4092 121.732 48.4092 114.962ZM57.1986 116.399C57.7798 117.802 59.1489 118.717 60.6675 118.717C61.6633 118.717 62.6184 118.321 63.3225 117.617C64.0267 116.913 64.4222 115.958 64.4222 114.962C64.4222 113.443 63.5074 112.074 62.1044 111.493C60.7013 110.912 59.0864 111.233 58.0125 112.307C56.9387 113.381 56.6174 114.996 57.1986 116.399Z",
    fill: "#CDE2FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.245 116.827C228.245 113.438 230.992 110.691 234.381 110.691C236.008 110.691 237.569 111.338 238.719 112.488C239.87 113.639 240.516 115.2 240.516 116.827C240.516 120.216 237.769 122.963 234.381 122.963C230.992 122.963 228.245 120.216 228.245 116.827ZM232.644 117.546C232.935 118.249 233.621 118.706 234.381 118.706C234.879 118.706 235.357 118.508 235.71 118.156C236.062 117.803 236.26 117.325 236.26 116.827C236.26 116.067 235.802 115.382 235.1 115.091C234.398 114.8 233.589 114.961 233.052 115.498C232.514 116.036 232.354 116.844 232.644 117.546Z",
    fill: "#CDE2FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.619,
    cy: 48.1574,
    r: 3.24052,
    fill: "#AED3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.2679,
    cy: 135.574,
    r: 3.24052,
    fill: "#AED3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8162 46.5332H34.112V43.8291C34.112 42.8526 33.3204 42.0609 32.3439 42.0609C31.3674 42.0609 30.5758 42.8526 30.5758 43.8291V46.5332H27.8716C26.8951 46.5332 26.1035 47.3249 26.1035 48.3014C26.1035 49.2779 26.8951 50.0695 27.8716 50.0695H30.5758V52.7737C30.5758 53.7502 31.3674 54.5418 32.3439 54.5418C33.3204 54.5418 34.112 53.7502 34.112 52.7737V50.0695H36.8162C37.7927 50.0695 38.5843 49.2779 38.5843 48.3014C38.5843 47.3249 37.7927 46.5332 36.8162 46.5332Z",
    fill: "#0084F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.733 112.359H129.029V109.655C129.029 108.678 128.237 107.887 127.261 107.887C126.284 107.887 125.493 108.678 125.493 109.655V112.359H122.789C121.812 112.359 121.021 113.151 121.021 114.127C121.021 115.104 121.812 115.895 122.789 115.895H125.493V118.6C125.493 119.576 126.284 120.368 127.261 120.368C128.237 120.368 129.029 119.576 129.029 118.6V115.895H131.733C132.202 115.895 132.652 115.709 132.983 115.377C133.315 115.046 133.501 114.596 133.501 114.127C133.501 113.151 132.71 112.359 131.733 112.359Z",
    fill: "#D9E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 64.375H141.516V61.6709C141.516 60.6944 140.725 59.9028 139.748 59.9028C138.772 59.9028 137.98 60.6944 137.98 61.6709V64.3751H135.276C134.299 64.3751 133.508 65.1667 133.508 66.1432C133.508 67.1197 134.299 67.9113 135.276 67.9113H137.98V70.6155C137.98 71.592 138.772 72.3836 139.748 72.3836C140.725 72.3836 141.516 71.592 141.516 70.6155V67.9113H144.221C145.197 67.9113 145.989 67.1197 145.989 66.1432C145.989 65.6742 145.802 65.2245 145.471 64.8929C145.139 64.5613 144.689 64.375 144.221 64.375Z",
    fill: "#0084F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4028 143.684L45.8503 143.132L46.4028 142.579C46.6023 142.38 46.6023 142.056 46.4028 141.857C46.2033 141.657 45.8798 141.657 45.6803 141.857L45.1278 142.409L44.5753 141.857C44.3758 141.657 44.0523 141.657 43.8528 141.857C43.6532 142.056 43.6532 142.38 43.8528 142.579L44.4053 143.132L43.8528 143.684C43.6532 143.884 43.6532 144.207 43.8528 144.407C44.0523 144.606 44.3758 144.606 44.5753 144.407L45.1278 143.854L45.6803 144.407C45.8798 144.606 46.2033 144.606 46.4028 144.407C46.6023 144.207 46.6023 143.884 46.4028 143.684Z",
    fill: "#0084F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.641 36.8767C113.642 36.5615 113.449 36.2783 113.155 36.1643C110.609 35.202 108.6 33.1926 107.638 30.6471C107.524 30.3532 107.24 30.1598 106.925 30.1606C106.61 30.1598 106.327 30.3532 106.213 30.6471C105.25 33.1926 103.241 35.202 100.696 36.1643C100.402 36.2783 100.208 36.5615 100.209 36.8767C100.208 37.192 100.402 37.4752 100.696 37.5892C103.241 38.5514 105.25 40.5608 106.213 43.1063C106.327 43.4002 106.61 43.5936 106.925 43.5929C107.24 43.5936 107.524 43.4002 107.638 43.1063C108.6 40.5608 110.609 38.5514 113.155 37.5892C113.449 37.4752 113.642 37.192 113.641 36.8767Z",
    fill: "#D9E9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.231 76.0835C231.232 75.7682 231.039 75.485 230.745 75.371C228.199 74.4088 226.19 72.3994 225.227 69.8539C225.113 69.56 224.83 69.3666 224.515 69.3673C224.2 69.3666 223.917 69.56 223.803 69.8539C222.84 72.3994 220.831 74.4088 218.285 75.371C217.991 75.485 217.798 75.7682 217.799 76.0835C217.798 76.3987 217.991 76.6819 218.285 76.796C220.831 77.7582 222.84 79.7676 223.803 82.3131C223.917 82.607 224.2 82.8004 224.515 82.7996C224.83 82.8004 225.113 82.607 225.227 82.3131C226.19 79.7676 228.199 77.7582 230.745 76.796C231.039 76.6819 231.232 76.3987 231.231 76.0835Z",
    fill: "#D9E9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 262,
    height: 197
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 196.5,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_6810)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3662,
    y: 72.1011,
    width: 124.754,
    height: 87.9506,
    rx: 3.58834,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 72,
    width: 126,
    height: 89
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3652,
    y: 72.1011,
    width: 124.754,
    height: 87.9506,
    rx: 3.58834,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9046 142.143C68.7849 148.753 97.9672 156.729 165.08 154.883C194.027 154.087 101.807 179.146 101.807 179.146L85.4239 162.267",
    fill: "#004389"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3662,
    y: 72.1011,
    width: 124.754,
    height: 87.9506,
    rx: 3.58834,
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.791,
    y: 79.1756,
    width: 113.904,
    height: 71.2407,
    rx: 3.2693,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 79,
    width: 115,
    height: 72
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92.79,
    y: 79.1756,
    width: 113.904,
    height: 71.2407,
    rx: 3.2693,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.221 99.6631C120.77 109.556 121.036 119.459 121.019 129.373",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.707 120.791C114.976 120.463 122.246 120.135 129.499 119.55C140.466 118.666 151.41 117.195 162.413 117.227",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.268 114.484L164.471 117.172C164.582 117.265 164.704 117.389 164.674 117.531C164.649 117.608 164.6 117.676 164.536 117.725C163.827 118.381 163.06 118.973 162.246 119.492",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42 122.273C120.46 117.282 122.693 112.376 125.118 107.556C125.789 106.222 126.685 104.737 128.157 104.52C129.434 104.332 130.616 105.197 131.539 106.103C134.288 108.803 136.188 112.265 137.616 115.852C138.671 118.501 139.569 121.368 141.673 123.285C141.892 123.485 142.175 123.685 142.461 123.606C142.64 123.556 142.771 123.407 142.889 123.263C144.76 120.962 145.764 118.091 146.733 115.283L149.375 107.63C149.425 107.487 149.481 107.334 149.607 107.25C149.747 107.156 149.934 107.176 150.095 107.223C150.913 107.464 151.426 108.255 151.853 108.996C153.621 112.061 155.168 115.247 156.484 118.532",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.541 98.2579L170.616 97.816",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36 101.519C167.779 101.315 169.177 100.989 170.539 100.545",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.01 98.7006C175.381 98.3001 176.711 97.767 177.979 97.109",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 100.704C176.556 100.395 177.465 100.2 178.388 100.123C177.972 101.026 177.431 101.866 176.783 102.619C176.691 102.726 176.61 102.918 176.736 102.98C176.787 102.998 176.842 102.997 176.892 102.979L177.744 102.77C177.842 102.746 177.953 102.724 178.035 102.782C178.079 102.816 178.112 102.862 178.131 102.915C178.381 103.498 177.939 104.129 177.524 104.608C176.874 105.359 176.204 106.127 175.329 106.594",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.075 94.8794C176.457 95.6991 176.515 96.6328 176.237 97.4935",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.844 99.0011C181.095 98.6762 181.529 98.553 181.913 98.6972C182.298 98.8413 182.544 99.2193 182.52 99.6294C182.508 99.853 182.418 100.085 182.501 100.293C182.61 100.565 182.978 100.647 183.249 100.542C183.521 100.436 183.718 100.199 183.902 99.9722",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.934 97.154C182.18 99.0048 181.382 100.836 180.538 102.648",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.125 126.573L157.12 129.54C158.307 128.633 159.608 127.505 159.604 126.008C159.646 127.518 159.686 129.045 159.386 130.525C159.086 132.006 158.41 133.459 157.245 134.413C157.105 134.541 156.938 134.636 156.756 134.691C156.059 134.858 155.524 133.995 154.814 133.896",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.694 129.964L164.937 129.607",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.126 129.914C169.53 129.312 168.757 128.422 168.062 128.621C167.366 128.82 167.077 129.761 167.399 130.413C167.527 130.672 167.752 130.907 168.038 130.944C168.527 131.009 168.896 130.495 169.029 130.018C169.162 129.541 169.199 129.001 169.54 128.643C169.659 129.335 169.972 129.978 170.443 130.499",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.347 127.636C171.741 128.466 171.929 129.379 171.895 130.297C171.814 129.176 172.355 128.101 173.304 127.498",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.936 127.403C175.362 127.702 174.861 128.281 174.917 128.928C174.974 129.575 175.837 130.072 176.313 129.633",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.068 127.381C177.533 127.502 176.897 127.72 176.786 128.26C176.685 128.749 177.13 129.216 177.617 129.324C178.103 129.432 178.605 129.281 179.08 129.132",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4 128.005C180.368 128.251 180.518 128.485 180.755 128.558C181.426 128.03 181.753 127.176 181.605 126.335C181.599 126.252 181.559 126.176 181.495 126.123C181.423 126.078 181.33 126.097 181.249 126.12C180.388 126.367 179.628 126.883 179.083 127.594",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.691 123.905C184.239 125.42 184.046 127.001 184.12 128.58C184.137 128.931 184.177 129.307 184.406 129.572C184.634 129.838 185.118 129.901 185.31 129.607",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.732 126.793C188.099 126.332 188.96 126.463 189.174 127.013C189.274 127.267 189.247 127.56 189.363 127.808C189.583 128.278 190.245 128.382 190.713 128.161C191.181 127.941 191.498 127.496 191.794 127.069",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.024 124.948C189.746 126.207 188.677 127.66 187.856 129.255",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2568 152.086C212.119 151.887 224.936 106.442 224.936 106.442L218.536 165.599L83.3765 171.094",
    fill: "#004389"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92.791,
    y: 79.1756,
    width: 113.904,
    height: 71.2407,
    rx: 3.2693,
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0791 154.883H222.552V156.225C222.552 159.562 219.847 162.267 216.511 162.267H78.1206C74.784 162.267 72.0791 159.562 72.0791 156.225V154.883L72.0791 154.883Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 154,
    width: 151,
    height: 9
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0801 154.883H222.553V156.225C222.553 159.562 219.848 162.267 216.512 162.267H78.1216C74.785 162.267 72.0801 159.562 72.0801 156.225V154.883L72.0801 154.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5_6810)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 150,
    width: 126,
    height: 33
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.785 150.416C227.497 164.32 101.297 165.599 101.297 165.599L197.456 182.583L220.33 167.921",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.604 159.784C176.449 159.783 176.308 159.876 176.248 160.02C176.187 160.164 176.22 160.329 176.33 160.44C176.44 160.55 176.605 160.584 176.749 160.524C176.893 160.465 176.987 160.324 176.987 160.168C176.988 159.956 176.816 159.784 176.604 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.744 159.784C178.588 159.783 178.447 159.876 178.387 160.02C178.327 160.164 178.36 160.329 178.469 160.44C178.579 160.55 178.745 160.584 178.889 160.524C179.033 160.465 179.127 160.324 179.127 160.168C179.127 159.956 178.956 159.784 178.744 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.884 159.784C180.728 159.783 180.587 159.876 180.527 160.02C180.467 160.164 180.499 160.329 180.609 160.44C180.719 160.55 180.885 160.584 181.029 160.524C181.173 160.465 181.267 160.324 181.267 160.168C181.267 160.067 181.227 159.969 181.155 159.897C181.083 159.825 180.986 159.784 180.884 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.023 159.784C182.868 159.783 182.727 159.876 182.667 160.02C182.606 160.164 182.639 160.329 182.749 160.44C182.859 160.55 183.024 160.584 183.168 160.524C183.312 160.465 183.406 160.324 183.406 160.168C183.407 160.067 183.366 159.969 183.294 159.897C183.223 159.825 183.125 159.784 183.023 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.162 159.784C185.006 159.783 184.865 159.876 184.805 160.02C184.745 160.164 184.778 160.329 184.887 160.44C184.997 160.55 185.163 160.584 185.307 160.524C185.451 160.465 185.545 160.324 185.545 160.168C185.545 159.956 185.374 159.784 185.162 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.302 159.784C187.146 159.783 187.005 159.876 186.945 160.02C186.885 160.164 186.917 160.329 187.027 160.44C187.137 160.55 187.303 160.584 187.447 160.524C187.591 160.465 187.685 160.324 187.685 160.168C187.685 160.067 187.645 159.969 187.573 159.897C187.501 159.825 187.403 159.784 187.302 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.441 159.784C189.286 159.783 189.145 159.876 189.085 160.02C189.024 160.164 189.057 160.329 189.167 160.44C189.277 160.55 189.442 160.584 189.586 160.524C189.73 160.465 189.824 160.324 189.824 160.168C189.824 160.067 189.784 159.969 189.712 159.897C189.641 159.825 189.543 159.784 189.441 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.581 159.784C191.425 159.783 191.284 159.876 191.224 160.02C191.164 160.164 191.196 160.329 191.306 160.44C191.416 160.55 191.582 160.584 191.726 160.524C191.87 160.465 191.964 160.324 191.964 160.168C191.964 159.956 191.793 159.784 191.581 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.721 159.784C193.565 159.783 193.424 159.876 193.364 160.02C193.304 160.164 193.336 160.329 193.446 160.44C193.556 160.55 193.722 160.584 193.866 160.524C194.01 160.465 194.104 160.324 194.104 160.168C194.104 160.067 194.064 159.969 193.992 159.897C193.92 159.825 193.823 159.784 193.721 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.859 159.784C195.703 159.783 195.563 159.876 195.502 160.02C195.442 160.164 195.475 160.329 195.585 160.44C195.695 160.55 195.86 160.584 196.004 160.524C196.148 160.465 196.242 160.324 196.242 160.168C196.242 160.067 196.202 159.969 196.13 159.897C196.059 159.825 195.961 159.784 195.859 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.999 159.784C197.843 159.783 197.702 159.876 197.642 160.02C197.582 160.164 197.614 160.329 197.724 160.44C197.834 160.55 198 160.584 198.144 160.524C198.288 160.465 198.382 160.324 198.382 160.168C198.382 160.067 198.342 159.969 198.27 159.897C198.198 159.825 198.101 159.784 197.999 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.139 159.784C199.983 159.783 199.842 159.876 199.782 160.02C199.722 160.164 199.754 160.329 199.864 160.44C199.974 160.55 200.14 160.584 200.284 160.524C200.428 160.465 200.522 160.324 200.522 160.168C200.522 159.956 200.351 159.784 200.139 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.278 159.784C202.122 159.783 201.982 159.876 201.921 160.02C201.861 160.164 201.894 160.329 202.004 160.44C202.114 160.55 202.279 160.584 202.423 160.524C202.567 160.465 202.661 160.324 202.661 160.168C202.661 160.067 202.621 159.969 202.549 159.897C202.478 159.825 202.38 159.784 202.278 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.418 159.784C204.262 159.783 204.121 159.876 204.061 160.02C204.001 160.164 204.033 160.329 204.143 160.44C204.253 160.55 204.419 160.584 204.563 160.524C204.707 160.465 204.801 160.324 204.801 160.168C204.801 160.067 204.761 159.969 204.689 159.897C204.617 159.825 204.52 159.784 204.418 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.558 159.784C206.402 159.783 206.261 159.876 206.201 160.02C206.141 160.164 206.173 160.329 206.283 160.44C206.393 160.55 206.559 160.584 206.703 160.524C206.847 160.465 206.94 160.324 206.94 160.168C206.941 159.956 206.77 159.784 206.558 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.697 159.784C208.541 159.783 208.401 159.876 208.34 160.02C208.28 160.164 208.313 160.329 208.423 160.44C208.533 160.55 208.698 160.584 208.842 160.524C208.986 160.465 209.08 160.324 209.08 160.168C209.08 160.067 209.04 159.969 208.968 159.897C208.897 159.825 208.799 159.784 208.697 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.837 159.784C210.681 159.783 210.54 159.876 210.48 160.02C210.42 160.164 210.452 160.329 210.562 160.44C210.672 160.55 210.838 160.584 210.982 160.524C211.126 160.465 211.22 160.324 211.22 160.168C211.22 159.956 211.049 159.784 210.837 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.976 159.784C212.821 159.783 212.68 159.876 212.62 160.02C212.56 160.164 212.592 160.329 212.702 160.44C212.812 160.55 212.977 160.584 213.121 160.524C213.265 160.465 213.359 160.324 213.359 160.168C213.36 160.067 213.319 159.969 213.248 159.897C213.176 159.825 213.078 159.784 212.976 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 159.784C214.96 159.783 214.82 159.876 214.759 160.02C214.699 160.164 214.732 160.329 214.842 160.44C214.951 160.55 215.117 160.584 215.261 160.524C215.405 160.465 215.499 160.324 215.499 160.168C215.5 159.956 215.328 159.784 215.116 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.256 159.784C217.1 159.783 216.959 159.876 216.899 160.02C216.839 160.164 216.871 160.329 216.981 160.44C217.091 160.55 217.257 160.584 217.401 160.524C217.545 160.465 217.639 160.324 217.639 160.168C217.639 159.956 217.468 159.784 217.256 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.394 159.784C219.239 159.783 219.098 159.876 219.038 160.02C218.978 160.164 219.01 160.329 219.12 160.44C219.23 160.55 219.395 160.584 219.539 160.524C219.683 160.465 219.777 160.324 219.777 160.168C219.778 160.067 219.737 159.969 219.666 159.897C219.594 159.825 219.496 159.784 219.394 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.534 159.784C221.378 159.783 221.237 159.876 221.177 160.02C221.117 160.164 221.15 160.329 221.26 160.44C221.369 160.55 221.535 160.584 221.679 160.524C221.823 160.465 221.917 160.324 221.917 160.168C221.917 159.956 221.746 159.784 221.534 159.784Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.605,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.744 155.712C178.588 155.711 178.447 155.804 178.387 155.948C178.327 156.091 178.36 156.257 178.469 156.368C178.579 156.478 178.745 156.512 178.889 156.452C179.033 156.393 179.127 156.252 179.127 156.096C179.128 155.884 178.956 155.712 178.744 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.884 155.712C180.728 155.711 180.587 155.804 180.527 155.948C180.467 156.092 180.499 156.257 180.609 156.368C180.719 156.478 180.885 156.512 181.029 156.452C181.173 156.393 181.267 156.252 181.267 156.096C181.267 155.995 181.227 155.897 181.155 155.825C181.083 155.753 180.986 155.712 180.884 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.023,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.162 155.712C185.006 155.711 184.865 155.804 184.805 155.948C184.745 156.091 184.778 156.257 184.887 156.368C184.997 156.478 185.163 156.512 185.307 156.452C185.451 156.393 185.545 156.252 185.545 156.096C185.546 155.884 185.374 155.712 185.162 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.302,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.442,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.581,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.721 155.712C193.565 155.711 193.424 155.804 193.364 155.948C193.304 156.091 193.336 156.257 193.446 156.368C193.556 156.478 193.722 156.512 193.866 156.452C194.01 156.393 194.104 156.252 194.104 156.096C194.104 155.995 194.064 155.897 193.992 155.825C193.92 155.753 193.823 155.712 193.721 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.859 155.712C195.704 155.711 195.563 155.804 195.502 155.948C195.442 156.092 195.475 156.257 195.585 156.368C195.695 156.478 195.86 156.512 196.004 156.452C196.148 156.393 196.242 156.252 196.242 156.096C196.243 155.995 196.202 155.897 196.13 155.825C196.059 155.753 195.961 155.712 195.859 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.999,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.139 155.712C199.983 155.711 199.842 155.804 199.782 155.948C199.722 156.091 199.754 156.257 199.864 156.368C199.974 156.478 200.14 156.512 200.284 156.452C200.428 156.393 200.522 156.252 200.522 156.096C200.522 155.884 200.351 155.712 200.139 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.278,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.418,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.558,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.697,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.837,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.977 155.712C212.821 155.711 212.68 155.804 212.62 155.948C212.56 156.092 212.592 156.257 212.702 156.368C212.812 156.478 212.977 156.512 213.121 156.452C213.265 156.393 213.359 156.252 213.359 156.096C213.36 155.995 213.319 155.897 213.248 155.825C213.176 155.753 213.078 155.712 212.977 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 155.712C214.96 155.711 214.82 155.804 214.759 155.948C214.699 156.091 214.732 156.257 214.842 156.368C214.951 156.478 215.117 156.512 215.261 156.452C215.405 156.393 215.499 156.252 215.499 156.096C215.5 155.884 215.328 155.712 215.116 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.255 155.712C217.099 155.711 216.958 155.804 216.898 155.948C216.838 156.091 216.87 156.257 216.98 156.368C217.09 156.478 217.256 156.512 217.4 156.452C217.544 156.393 217.638 156.252 217.638 156.096C217.638 155.884 217.467 155.712 217.255 155.712Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.395,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.534,
    cy: 156.096,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.605,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.744 157.748C178.588 157.747 178.447 157.84 178.387 157.984C178.327 158.127 178.36 158.293 178.469 158.404C178.579 158.514 178.745 158.548 178.889 158.488C179.033 158.429 179.127 158.288 179.127 158.132C179.128 157.92 178.956 157.748 178.744 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.884 157.748C180.728 157.747 180.587 157.84 180.527 157.984C180.467 158.128 180.499 158.293 180.609 158.404C180.719 158.514 180.885 158.548 181.029 158.488C181.173 158.429 181.267 158.288 181.267 158.132C181.267 158.031 181.227 157.933 181.155 157.861C181.083 157.789 180.986 157.748 180.884 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.023,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.162 157.748C185.006 157.747 184.865 157.84 184.805 157.984C184.745 158.127 184.778 158.293 184.887 158.404C184.997 158.514 185.163 158.548 185.307 158.488C185.451 158.429 185.545 158.288 185.545 158.132C185.545 157.92 185.374 157.748 185.162 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.302,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.442,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.581,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.721 157.748C193.565 157.747 193.424 157.84 193.364 157.984C193.304 158.127 193.336 158.293 193.446 158.404C193.556 158.514 193.722 158.548 193.866 158.488C194.01 158.429 194.104 158.288 194.104 158.132C194.104 157.92 193.933 157.748 193.721 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.859 157.748C195.704 157.747 195.563 157.84 195.502 157.984C195.442 158.128 195.475 158.293 195.585 158.404C195.695 158.514 195.86 158.548 196.004 158.488C196.148 158.429 196.242 158.288 196.242 158.132C196.243 158.031 196.202 157.933 196.13 157.861C196.059 157.789 195.961 157.748 195.859 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.999,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.139 157.748C199.983 157.747 199.842 157.84 199.782 157.984C199.722 158.127 199.754 158.293 199.864 158.404C199.974 158.514 200.14 158.548 200.284 158.488C200.428 158.429 200.522 158.288 200.522 158.132C200.522 157.92 200.351 157.748 200.139 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.278,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.418,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.558,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.697,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.837,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.977 157.748C212.821 157.747 212.68 157.84 212.62 157.984C212.56 158.128 212.592 158.293 212.702 158.404C212.812 158.514 212.977 158.548 213.121 158.488C213.265 158.429 213.359 158.288 213.359 158.132C213.36 158.031 213.319 157.933 213.248 157.861C213.176 157.789 213.078 157.748 212.977 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 157.748C214.96 157.747 214.82 157.84 214.759 157.984C214.699 158.127 214.732 158.293 214.842 158.404C214.951 158.514 215.117 158.548 215.261 158.488C215.405 158.429 215.499 158.288 215.499 158.132C215.5 157.92 215.328 157.748 215.116 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.255 157.748C217.099 157.747 216.958 157.84 216.898 157.984C216.838 158.127 216.87 158.293 216.98 158.404C217.09 158.514 217.256 158.548 217.4 158.488C217.544 158.429 217.638 158.288 217.638 158.132C217.638 157.92 217.467 157.748 217.255 157.748Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.395,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.534,
    cy: 158.132,
    rx: 0.38292,
    ry: 0.384793,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.604 161.82C176.449 161.819 176.308 161.912 176.248 162.056C176.187 162.2 176.22 162.365 176.33 162.476C176.44 162.586 176.605 162.62 176.749 162.56C176.893 162.501 176.987 162.36 176.987 162.204C176.988 161.992 176.816 161.82 176.604 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.744 161.82C178.588 161.819 178.447 161.912 178.387 162.056C178.327 162.2 178.36 162.365 178.469 162.476C178.579 162.586 178.745 162.62 178.889 162.56C179.033 162.501 179.127 162.36 179.127 162.204C179.127 161.992 178.956 161.82 178.744 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.884 161.82C180.728 161.819 180.587 161.912 180.527 162.056C180.467 162.2 180.499 162.365 180.609 162.476C180.719 162.586 180.885 162.62 181.029 162.56C181.173 162.501 181.267 162.36 181.267 162.204C181.267 162.103 181.227 162.005 181.155 161.933C181.083 161.861 180.985 161.82 180.884 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.023 161.82C182.868 161.819 182.727 161.912 182.667 162.056C182.606 162.2 182.639 162.365 182.749 162.476C182.859 162.586 183.024 162.62 183.168 162.56C183.312 162.501 183.406 162.36 183.406 162.204C183.407 161.992 183.235 161.82 183.023 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.162 161.82C185.006 161.819 184.865 161.912 184.805 162.056C184.745 162.2 184.778 162.365 184.887 162.476C184.997 162.586 185.163 162.62 185.307 162.56C185.451 162.501 185.545 162.36 185.545 162.204C185.545 161.992 185.374 161.82 185.162 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.302 161.82C187.146 161.819 187.005 161.912 186.945 162.056C186.885 162.2 186.917 162.365 187.027 162.476C187.137 162.586 187.303 162.62 187.447 162.56C187.591 162.501 187.685 162.36 187.685 162.204C187.685 161.992 187.514 161.82 187.302 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.441 161.82C189.285 161.819 189.145 161.912 189.085 162.056C189.024 162.2 189.057 162.365 189.167 162.476C189.277 162.586 189.442 162.62 189.586 162.56C189.73 162.501 189.824 162.36 189.824 162.204C189.825 161.992 189.653 161.82 189.441 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.581 161.82C191.425 161.819 191.284 161.912 191.224 162.056C191.164 162.2 191.197 162.365 191.306 162.476C191.416 162.586 191.582 162.62 191.726 162.56C191.87 162.501 191.964 162.36 191.964 162.204C191.964 161.992 191.793 161.82 191.581 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.721 161.82C193.565 161.819 193.424 161.912 193.364 162.056C193.304 162.2 193.336 162.365 193.446 162.476C193.556 162.586 193.722 162.62 193.866 162.56C194.01 162.501 194.104 162.36 194.104 162.204C194.104 162.103 194.064 162.005 193.992 161.933C193.92 161.861 193.822 161.82 193.721 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.859 161.82C195.703 161.819 195.563 161.912 195.502 162.056C195.442 162.2 195.475 162.365 195.585 162.476C195.695 162.586 195.86 162.62 196.004 162.56C196.148 162.501 196.242 162.36 196.242 162.204C196.242 162.103 196.202 162.005 196.13 161.933C196.059 161.861 195.961 161.82 195.859 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.999 161.82C197.843 161.819 197.702 161.912 197.642 162.056C197.582 162.2 197.614 162.365 197.724 162.476C197.834 162.586 198 162.62 198.144 162.56C198.288 162.501 198.382 162.36 198.382 162.204C198.382 161.992 198.211 161.82 197.999 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.139 161.82C199.983 161.819 199.842 161.912 199.782 162.056C199.722 162.2 199.754 162.365 199.864 162.476C199.974 162.586 200.14 162.62 200.284 162.56C200.428 162.501 200.521 162.36 200.521 162.204C200.522 161.992 200.351 161.82 200.139 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.278 161.82C202.122 161.819 201.982 161.912 201.921 162.056C201.861 162.2 201.894 162.365 202.004 162.476C202.114 162.586 202.279 162.62 202.423 162.56C202.567 162.501 202.661 162.36 202.661 162.204C202.662 161.992 202.49 161.82 202.278 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.418 161.82C204.262 161.819 204.121 161.912 204.061 162.056C204.001 162.2 204.033 162.365 204.143 162.476C204.253 162.586 204.419 162.62 204.563 162.56C204.707 162.501 204.801 162.36 204.801 162.204C204.801 161.992 204.63 161.82 204.418 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.557 161.82C206.402 161.819 206.261 161.912 206.201 162.056C206.141 162.2 206.173 162.365 206.283 162.476C206.393 162.586 206.559 162.62 206.703 162.56C206.847 162.501 206.94 162.36 206.94 162.204C206.941 161.992 206.769 161.82 206.557 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.697 161.82C208.541 161.819 208.4 161.912 208.34 162.056C208.28 162.2 208.313 162.365 208.423 162.476C208.533 162.586 208.698 162.62 208.842 162.56C208.986 162.501 209.08 162.36 209.08 162.204C209.081 161.992 208.909 161.82 208.697 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.837 161.82C210.681 161.819 210.54 161.912 210.48 162.056C210.42 162.2 210.452 162.365 210.562 162.476C210.672 162.586 210.838 162.62 210.982 162.56C211.126 162.501 211.22 162.36 211.22 162.204C211.22 161.992 211.049 161.82 210.837 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.976 161.82C212.821 161.819 212.68 161.912 212.62 162.056C212.56 162.2 212.592 162.365 212.702 162.476C212.812 162.586 212.977 162.62 213.121 162.56C213.265 162.501 213.359 162.36 213.359 162.204C213.36 162.103 213.319 162.005 213.248 161.933C213.176 161.861 213.078 161.82 212.976 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 161.82C214.96 161.819 214.819 161.912 214.759 162.056C214.699 162.2 214.732 162.365 214.842 162.476C214.951 162.586 215.117 162.62 215.261 162.56C215.405 162.501 215.499 162.36 215.499 162.204C215.499 161.992 215.328 161.82 215.116 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.256 161.82C217.1 161.819 216.959 161.912 216.899 162.056C216.839 162.2 216.871 162.365 216.981 162.476C217.091 162.586 217.257 162.62 217.401 162.56C217.545 162.501 217.639 162.36 217.639 162.204C217.639 161.992 217.468 161.82 217.256 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.395 161.82C219.24 161.819 219.099 161.912 219.039 162.056C218.978 162.2 219.011 162.365 219.121 162.476C219.231 162.586 219.396 162.62 219.54 162.56C219.684 162.501 219.778 162.36 219.778 162.204C219.779 161.992 219.607 161.82 219.395 161.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.534 161.82C221.378 161.819 221.237 161.912 221.177 162.056C221.117 162.2 221.15 162.365 221.26 162.476C221.369 162.586 221.535 162.62 221.679 162.56C221.823 162.501 221.917 162.36 221.917 162.204C221.917 161.992 221.746 161.82 221.534 161.82Z",
    fill: "#0084F0"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0791 154.883H222.552V156.225C222.552 159.562 219.847 162.267 216.511 162.267H78.1206C74.784 162.267 72.0791 159.562 72.0791 156.225V154.883L72.0791 154.883Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.743,
    cy: 76.0392,
    rx: 1.10221,
    ry: 1.10759,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.404 154.883H165.081V155.944C165.081 157.397 163.903 158.575 162.45 158.575H137.036C135.582 158.575 134.404 157.397 134.404 155.944V154.883H134.404Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.415 91.0082L104.367 93.5805",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.998 141.928C194.392 143.387 192.476 144.465 190.394 145.079",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.892 46.9755L221.737 46.9212L198.895 41.5417C198.674 41.4904 198.449 41.4618 198.223 41.4564H198.091C197.865 41.458 197.639 41.4867 197.419 41.5417L174.577 46.9212L174.422 46.9755C171.054 48.1554 168.791 51.5942 168.791 55.5377V81.8681C168.791 86.4945 170.39 90.9424 173.542 95.08C175.936 98.216 179.235 101.181 183.337 103.882C186.906 106.227 190.467 107.958 192.823 108.99C193.897 109.464 194.947 109.891 195.952 110.271C197.226 110.752 197.566 110.877 198.192 110.877C198.668 110.875 199.138 110.766 199.567 110.558C201.22 109.968 207.067 107.764 212.977 103.875C217.087 101.174 220.377 98.2161 222.772 95.072C225.924 90.9349 227.523 86.4945 227.523 81.8601V55.5377C227.523 51.5942 225.26 48.1554 221.892 46.9755H221.892Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M225.924 39.5459L225.743 39.4824L199.02 33.1889C198.762 33.1289 198.499 33.0954 198.234 33.0891H198.08C197.815 33.091 197.551 33.1245 197.294 33.1889L170.571 39.4824L170.39 39.5459C166.45 40.9263 163.802 44.9494 163.802 49.5629V80.3669C163.802 85.7794 165.672 90.983 169.36 95.8235C172.161 99.4924 176.02 102.961 180.819 106.122C184.994 108.864 189.16 110.889 191.917 112.097C193.173 112.651 194.402 113.151 195.577 113.596C197.068 114.159 197.466 114.304 198.198 114.304C198.755 114.302 199.305 114.175 199.806 113.932C201.74 113.241 208.581 110.662 215.495 106.113C220.303 102.952 224.153 99.4924 226.954 95.8142C230.642 90.9742 232.512 85.7794 232.512 80.3576V49.5629C232.512 44.9494 229.865 40.9263 225.924 39.5459H225.924Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.924 42.0158L225.743 41.9523L199.02 35.6589C198.762 35.5988 198.499 35.5654 198.234 35.5591H198.08C197.815 35.561 197.551 35.5945 197.294 35.6589L170.571 41.9524L170.39 42.0158C166.45 43.3962 163.802 47.4194 163.802 52.0328V82.8368C163.802 88.2494 165.672 93.453 169.36 98.2935C172.161 101.962 176.02 105.431 180.819 108.592C184.994 111.334 189.16 113.359 191.917 114.567C193.173 115.121 194.402 115.621 195.577 116.066C197.068 116.629 197.466 116.774 198.198 116.774C198.755 116.772 199.305 116.645 199.806 116.402C201.74 115.711 208.581 113.132 215.495 108.583C220.303 105.422 224.153 101.962 226.954 98.2841C230.642 93.4441 232.512 88.2493 232.512 82.8274V52.0328C232.512 47.4193 229.865 43.3962 225.924 42.0158H225.924Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 35,
    width: 70,
    height: 82
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.924 42.0158L225.743 41.9523L199.02 35.6589C198.762 35.5988 198.499 35.5654 198.234 35.5591H198.08C197.815 35.561 197.551 35.5945 197.294 35.6589L170.571 41.9524L170.39 42.0158C166.45 43.3962 163.802 47.4194 163.802 52.0328V82.8368C163.802 88.2494 165.672 93.453 169.36 98.2935C172.161 101.962 176.02 105.431 180.819 108.592C184.994 111.334 189.16 113.359 191.917 114.567C193.173 115.121 194.402 115.621 195.577 116.066C197.068 116.629 197.466 116.774 198.198 116.774C198.755 116.772 199.305 116.645 199.806 116.402C201.74 115.711 208.581 113.132 215.495 108.583C220.303 105.422 224.153 101.962 226.954 98.2841C230.642 93.4441 232.512 88.2493 232.512 82.8274V52.0328C232.512 47.4193 229.865 43.3962 225.924 42.0158H225.924Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.744 72.2217C169.715 101.52 195.495 117.265 207.299 119.16C219.102 121.056 192.008 126.986 192.008 126.986L149.623 98.3635L152.306 78.4641",
    fill: "#004389"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.924 42.0158L225.743 41.9523L199.02 35.6589C198.762 35.5988 198.499 35.5654 198.234 35.5591H198.08C197.815 35.561 197.551 35.5945 197.294 35.6589L170.571 41.9524L170.39 42.0158C166.45 43.3962 163.802 47.4194 163.802 52.0328V82.8368C163.802 88.2494 165.672 93.453 169.36 98.2935C172.161 101.962 176.02 105.431 180.819 108.592C184.994 111.334 189.16 113.359 191.917 114.567C193.173 115.121 194.402 115.621 195.577 116.066C197.068 116.629 197.466 116.774 198.198 116.774C198.755 116.772 199.305 116.645 199.806 116.402C201.74 115.711 208.581 113.132 215.495 108.583C220.303 105.422 224.153 101.962 226.954 98.2841C230.642 93.4441 232.512 88.2493 232.512 82.8274V52.0328C232.512 47.4193 229.865 43.3962 225.924 42.0158H225.924Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M221.892 46.9755L221.737 46.9212L198.895 41.5417C198.674 41.4904 198.449 41.4618 198.223 41.4564H198.091C197.865 41.458 197.639 41.4867 197.419 41.5417L174.577 46.9212L174.422 46.9755C171.054 48.1554 168.791 51.5942 168.791 55.5377V81.8681C168.791 86.4945 170.39 90.9424 173.542 95.08C175.936 98.216 179.235 101.181 183.337 103.882C186.906 106.227 190.467 107.958 192.823 108.99C193.897 109.464 194.947 109.891 195.952 110.271C197.226 110.752 197.566 110.877 198.192 110.877C198.668 110.875 199.138 110.766 199.567 110.558C201.22 109.968 207.067 107.764 212.977 103.875C217.087 101.174 220.377 98.2161 222.772 95.072C225.924 90.9349 227.523 86.4945 227.523 81.8601V55.5377C227.523 51.5942 225.26 48.1554 221.892 46.9755H221.892Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 41,
    width: 60,
    height: 70
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.892 46.9755L221.737 46.9212L198.895 41.5417C198.674 41.4904 198.449 41.4618 198.223 41.4564H198.091C197.865 41.458 197.639 41.4867 197.419 41.5417L174.577 46.9212L174.422 46.9755C171.054 48.1554 168.791 51.5942 168.791 55.5377V81.8681C168.791 86.4945 170.39 90.9424 173.542 95.08C175.936 98.216 179.235 101.181 183.337 103.882C186.906 106.227 190.467 107.958 192.823 108.99C193.897 109.464 194.947 109.891 195.952 110.271C197.226 110.752 197.566 110.877 198.192 110.877C198.668 110.875 199.138 110.766 199.567 110.558C201.22 109.968 207.067 107.764 212.977 103.875C217.087 101.174 220.377 98.2161 222.772 95.072C225.924 90.9349 227.523 86.4945 227.523 81.8601V55.5377C227.523 51.5942 225.26 48.1554 221.892 46.9755H221.892Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5_6810)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 65,
    width: 50,
    height: 41
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.574 82.4718L193.327 87.9587L213.595 105.726L242.219 90.9673L213.875 65.3368L198.755 75.0599",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.944 82.5973C195.841 82.5968 195.749 82.6582 195.709 82.7528C195.67 82.8474 195.691 82.9566 195.763 83.0293C195.836 83.102 195.945 83.1238 196.039 83.0847C196.134 83.0456 196.196 82.9531 196.196 82.8506C196.196 82.711 196.084 82.5976 195.944 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 82.5973C197.25 82.5968 197.157 82.6582 197.117 82.7528C197.078 82.8474 197.099 82.9565 197.171 83.0292C197.244 83.1019 197.353 83.1238 197.448 83.0847C197.542 83.0456 197.604 82.9531 197.604 82.8506C197.605 82.711 197.492 82.5977 197.352 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 82.5973C198.659 82.5968 198.566 82.6582 198.526 82.7528C198.487 82.8474 198.508 82.9566 198.581 83.0293C198.653 83.102 198.762 83.1238 198.857 83.0847C198.952 83.0456 199.013 82.9531 199.013 82.8506C199.014 82.7836 198.987 82.7192 198.94 82.6717C198.893 82.6242 198.828 82.5975 198.761 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 82.5973C200.067 82.5968 199.974 82.6582 199.935 82.7528C199.895 82.8474 199.916 82.9566 199.989 83.0293C200.061 83.102 200.17 83.1238 200.265 83.0847C200.36 83.0456 200.422 82.9531 200.422 82.8506C200.422 82.7836 200.395 82.7192 200.348 82.6717C200.301 82.6242 200.237 82.5975 200.17 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 82.5973C201.475 82.5968 201.383 82.6582 201.343 82.7528C201.303 82.8474 201.325 82.9565 201.397 83.0292C201.469 83.1019 201.578 83.1238 201.673 83.0847C201.768 83.0456 201.83 82.9531 201.83 82.8506C201.83 82.711 201.717 82.5977 201.578 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 82.5973C202.883 82.5968 202.791 82.6582 202.751 82.7528C202.711 82.8474 202.733 82.9566 202.805 83.0293C202.878 83.102 202.987 83.1238 203.081 83.0847C203.176 83.0456 203.238 82.9531 203.238 82.8506C203.238 82.7836 203.212 82.7192 203.164 82.6717C203.117 82.6242 203.053 82.5975 202.986 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 82.5973C204.292 82.5968 204.199 82.6582 204.159 82.7528C204.12 82.8474 204.141 82.9566 204.213 83.0293C204.286 83.102 204.395 83.1238 204.49 83.0847C204.584 83.0456 204.646 82.9531 204.646 82.8506C204.646 82.7836 204.62 82.7192 204.573 82.6717C204.525 82.6242 204.461 82.5975 204.394 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 82.5973C205.701 82.5968 205.608 82.6582 205.568 82.7528C205.529 82.8474 205.55 82.9566 205.623 83.0293C205.695 83.102 205.804 83.1238 205.899 83.0847C205.994 83.0456 206.055 82.9531 206.055 82.8506C206.056 82.711 205.943 82.5976 205.803 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 82.5973C207.109 82.5968 207.016 82.6582 206.977 82.7528C206.937 82.8474 206.958 82.9565 207.031 83.0292C207.103 83.1019 207.212 83.1238 207.307 83.0847C207.402 83.0456 207.464 82.9531 207.464 82.8506C207.464 82.7836 207.437 82.7192 207.39 82.6717C207.343 82.6242 207.279 82.5975 207.212 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 82.5973C208.517 82.5968 208.424 82.6582 208.385 82.7528C208.345 82.8474 208.367 82.9566 208.439 83.0293C208.511 83.102 208.62 83.1238 208.715 83.0847C208.81 83.0456 208.872 82.9531 208.872 82.8506C208.872 82.7836 208.846 82.7192 208.798 82.6717C208.751 82.6242 208.687 82.5975 208.62 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 82.5973C209.925 82.5968 209.833 82.6582 209.793 82.7528C209.753 82.8474 209.775 82.9566 209.847 83.0293C209.92 83.102 210.029 83.1238 210.123 83.0847C210.218 83.0456 210.28 82.9531 210.28 82.8506C210.28 82.7836 210.254 82.7192 210.206 82.6717C210.159 82.6242 210.095 82.5975 210.028 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 82.5973C211.334 82.5968 211.241 82.6582 211.201 82.7528C211.162 82.8474 211.183 82.9565 211.255 83.0292C211.328 83.1019 211.437 83.1238 211.532 83.0847C211.626 83.0456 211.688 82.9531 211.688 82.8506C211.689 82.711 211.576 82.5977 211.436 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 82.5973C212.742 82.5968 212.649 82.6582 212.609 82.7528C212.57 82.8474 212.591 82.9566 212.664 83.0293C212.736 83.102 212.845 83.1238 212.94 83.0847C213.035 83.0456 213.096 82.9531 213.096 82.8506C213.097 82.7836 213.07 82.7192 213.023 82.6717C212.976 82.6242 212.911 82.5975 212.844 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 82.5973C214.151 82.5968 214.058 82.6582 214.019 82.7528C213.979 82.8474 214 82.9566 214.073 83.0293C214.145 83.102 214.254 83.1238 214.349 83.0847C214.444 83.0456 214.506 82.9531 214.506 82.8506C214.506 82.7836 214.479 82.7192 214.432 82.6717C214.385 82.6242 214.321 82.5975 214.254 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 82.5973C215.559 82.5968 215.466 82.6582 215.427 82.7528C215.387 82.8474 215.409 82.9566 215.481 83.0293C215.553 83.102 215.662 83.1238 215.757 83.0847C215.852 83.0456 215.914 82.9531 215.914 82.8506C215.914 82.711 215.801 82.5976 215.662 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 82.5973C216.967 82.5968 216.875 82.6582 216.835 82.7528C216.795 82.8474 216.817 82.9566 216.889 83.0293C216.962 83.102 217.071 83.1238 217.165 83.0847C217.26 83.0456 217.322 82.9531 217.322 82.8506C217.322 82.7836 217.296 82.7192 217.248 82.6717C217.201 82.6242 217.137 82.5975 217.07 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 82.5973C218.377 82.5968 218.284 82.6582 218.244 82.7528C218.205 82.8474 218.226 82.9566 218.298 83.0293C218.371 83.102 218.48 83.1238 218.575 83.0847C218.669 83.0456 218.731 82.9531 218.731 82.8506C218.732 82.711 218.619 82.5976 218.479 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 82.5973C219.784 82.5968 219.691 82.6582 219.651 82.7528C219.612 82.8474 219.633 82.9566 219.706 83.0293C219.778 83.102 219.887 83.1238 219.982 83.0847C220.077 83.0456 220.138 82.9531 220.138 82.8506C220.139 82.7836 220.112 82.7192 220.065 82.6717C220.018 82.6242 219.953 82.5975 219.886 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 82.5973C221.193 82.5968 221.1 82.6582 221.061 82.7528C221.021 82.8474 221.042 82.9565 221.115 83.0292C221.187 83.1019 221.296 83.1238 221.391 83.0847C221.486 83.0456 221.548 82.9531 221.548 82.8506C221.548 82.711 221.435 82.5977 221.296 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 82.5973C222.601 82.5968 222.508 82.6582 222.469 82.7528C222.429 82.8474 222.451 82.9565 222.523 83.0292C222.595 83.1019 222.704 83.1238 222.799 83.0847C222.894 83.0456 222.956 82.9531 222.956 82.8506C222.956 82.711 222.843 82.5977 222.704 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 82.5973C224.009 82.5968 223.917 82.6582 223.877 82.7528C223.837 82.8474 223.859 82.9566 223.931 83.0293C224.004 83.102 224.113 83.1238 224.207 83.0847C224.302 83.0456 224.364 82.9531 224.364 82.8506C224.364 82.711 224.251 82.5976 224.112 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 82.5973C225.419 82.5968 225.326 82.6582 225.286 82.7528C225.247 82.8474 225.268 82.9566 225.34 83.0293C225.413 83.102 225.522 83.1238 225.617 83.0847C225.711 83.0456 225.773 82.9531 225.773 82.8506C225.773 82.711 225.661 82.5977 225.521 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 82.5973C226.827 82.5968 226.734 82.6582 226.694 82.7528C226.655 82.8474 226.676 82.9566 226.749 83.0293C226.821 83.102 226.93 83.1238 227.025 83.0847C227.12 83.0456 227.181 82.9531 227.181 82.8506C227.182 82.711 227.069 82.5977 226.929 82.5973Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 85.2779C197.25 85.2774 197.157 85.3387 197.117 85.4333C197.078 85.528 197.099 85.6371 197.171 85.7098C197.244 85.7825 197.353 85.8044 197.448 85.7653C197.542 85.7261 197.604 85.6337 197.604 85.5311C197.605 85.3916 197.492 85.2782 197.352 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 85.2779C198.659 85.2774 198.566 85.3388 198.526 85.4334C198.487 85.528 198.508 85.6371 198.581 85.7098C198.653 85.7825 198.762 85.8044 198.857 85.7653C198.952 85.7261 199.013 85.6337 199.013 85.5311C199.014 85.4641 198.987 85.3998 198.94 85.3523C198.893 85.3048 198.828 85.278 198.761 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 85.2779C201.475 85.2774 201.382 85.3387 201.343 85.4333C201.303 85.528 201.325 85.6371 201.397 85.7098C201.469 85.7825 201.578 85.8044 201.673 85.7653C201.768 85.7261 201.83 85.6337 201.83 85.5311C201.83 85.3916 201.717 85.2782 201.578 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 85.2779C207.109 85.2774 207.016 85.3387 206.977 85.4333C206.937 85.528 206.958 85.6371 207.031 85.7098C207.103 85.7825 207.212 85.8044 207.307 85.7653C207.402 85.7261 207.464 85.6337 207.464 85.5311C207.464 85.4641 207.437 85.3998 207.39 85.3523C207.343 85.3048 207.279 85.278 207.212 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 85.2779C208.517 85.2774 208.424 85.3388 208.385 85.4334C208.345 85.528 208.367 85.6371 208.439 85.7098C208.511 85.7825 208.62 85.8044 208.715 85.7653C208.81 85.7261 208.872 85.6337 208.872 85.5311C208.872 85.4641 208.845 85.3998 208.798 85.3523C208.751 85.3048 208.687 85.278 208.62 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 85.2779C211.334 85.2774 211.241 85.3387 211.201 85.4333C211.162 85.528 211.183 85.6371 211.255 85.7098C211.328 85.7825 211.437 85.8044 211.532 85.7653C211.626 85.7261 211.688 85.6337 211.688 85.5311C211.689 85.3916 211.576 85.2782 211.436 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 85.2779C219.784 85.2774 219.691 85.3388 219.651 85.4334C219.612 85.528 219.633 85.6371 219.706 85.7098C219.778 85.7825 219.887 85.8044 219.982 85.7653C220.077 85.7261 220.138 85.6337 220.138 85.5311C220.139 85.4641 220.112 85.3998 220.065 85.3523C220.018 85.3048 219.953 85.278 219.886 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 85.2779C221.193 85.2774 221.1 85.3387 221.061 85.4333C221.021 85.528 221.042 85.6371 221.115 85.7098C221.187 85.7825 221.296 85.8044 221.391 85.7653C221.486 85.7261 221.548 85.6337 221.548 85.5311C221.548 85.3916 221.435 85.2782 221.296 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 85.2779C222.601 85.2774 222.508 85.3387 222.469 85.4333C222.429 85.528 222.451 85.6371 222.523 85.7098C222.595 85.7825 222.704 85.8044 222.799 85.7653C222.894 85.7261 222.956 85.6337 222.956 85.5311C222.956 85.3916 222.843 85.2782 222.704 85.2779Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 85.5312,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 86.6181C197.25 86.6176 197.157 86.679 197.117 86.7736C197.078 86.8682 197.099 86.9774 197.171 87.0501C197.244 87.1228 197.353 87.1447 197.448 87.1055C197.542 87.0664 197.604 86.974 197.604 86.8714C197.605 86.7319 197.492 86.6185 197.352 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 86.6181C198.659 86.6177 198.566 86.6791 198.526 86.7737C198.487 86.8683 198.508 86.9774 198.581 87.0501C198.653 87.1228 198.762 87.1447 198.857 87.1055C198.952 87.0664 199.013 86.974 199.013 86.8714C199.014 86.8044 198.987 86.7401 198.94 86.6926C198.893 86.6451 198.828 86.6183 198.761 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 86.6181C201.475 86.6176 201.382 86.679 201.343 86.7736C201.303 86.8682 201.325 86.9774 201.397 87.0501C201.469 87.1228 201.578 87.1447 201.673 87.1055C201.768 87.0664 201.83 86.974 201.83 86.8714C201.83 86.7319 201.717 86.6185 201.578 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 86.6181C207.109 86.6176 207.016 86.679 206.977 86.7736C206.937 86.8682 206.958 86.9774 207.031 87.0501C207.103 87.1228 207.212 87.1447 207.307 87.1055C207.402 87.0664 207.464 86.974 207.464 86.8714C207.464 86.8044 207.437 86.7401 207.39 86.6926C207.343 86.6451 207.279 86.6183 207.212 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 86.6181C208.517 86.6177 208.424 86.6791 208.385 86.7737C208.345 86.8683 208.367 86.9774 208.439 87.0501C208.511 87.1228 208.62 87.1447 208.715 87.1055C208.81 87.0664 208.872 86.974 208.872 86.8714C208.872 86.8044 208.845 86.7401 208.798 86.6926C208.751 86.6451 208.687 86.6183 208.62 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 86.6181C211.334 86.6176 211.241 86.679 211.201 86.7736C211.162 86.8682 211.183 86.9774 211.255 87.0501C211.328 87.1228 211.437 87.1447 211.532 87.1055C211.626 87.0664 211.688 86.974 211.688 86.8714C211.689 86.7319 211.576 86.6185 211.436 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 86.6181C219.784 86.6177 219.691 86.6791 219.651 86.7737C219.612 86.8683 219.633 86.9774 219.706 87.0501C219.778 87.1228 219.887 87.1447 219.982 87.1055C220.077 87.0664 220.138 86.974 220.138 86.8714C220.139 86.8044 220.112 86.7401 220.065 86.6926C220.018 86.6451 219.953 86.6183 219.886 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 86.6181C221.193 86.6176 221.1 86.679 221.061 86.7736C221.021 86.8682 221.042 86.9774 221.115 87.0501C221.187 87.1228 221.296 87.1447 221.391 87.1055C221.486 87.0664 221.548 86.974 221.548 86.8714C221.548 86.7319 221.435 86.6185 221.296 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 86.6181C222.601 86.6176 222.508 86.679 222.469 86.7736C222.429 86.8682 222.451 86.9774 222.523 87.0501C222.595 87.1228 222.704 87.1447 222.799 87.1055C222.894 87.0664 222.956 86.974 222.956 86.8714C222.956 86.7319 222.843 86.6185 222.704 86.6181Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 86.8714,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 79.9167C197.25 79.9162 197.157 79.9776 197.117 80.0722C197.078 80.1668 197.099 80.276 197.171 80.3487C197.244 80.4214 197.353 80.4433 197.448 80.4042C197.542 80.365 197.604 80.2726 197.604 80.17C197.605 80.0305 197.492 79.9171 197.352 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 79.9167C198.659 79.9162 198.566 79.9776 198.526 80.0722C198.487 80.1668 198.508 80.276 198.581 80.3487C198.653 80.4214 198.762 80.4433 198.857 80.4042C198.952 80.365 199.013 80.2726 199.013 80.17C199.014 80.103 198.987 80.0387 198.94 79.9912C198.893 79.9437 198.828 79.9169 198.761 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 79.9167C201.475 79.9162 201.383 79.9776 201.343 80.0722C201.303 80.1668 201.325 80.276 201.397 80.3487C201.469 80.4214 201.578 80.4433 201.673 80.4042C201.768 80.365 201.83 80.2726 201.83 80.17C201.83 80.0305 201.717 79.9171 201.578 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 79.9167C207.109 79.9162 207.016 79.9776 206.977 80.0722C206.937 80.1668 206.958 80.276 207.031 80.3487C207.103 80.4214 207.212 80.4433 207.307 80.4042C207.402 80.365 207.464 80.2726 207.464 80.17C207.464 80.103 207.437 80.0387 207.39 79.9912C207.343 79.9437 207.279 79.9169 207.212 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 79.9167C208.517 79.9162 208.424 79.9776 208.385 80.0722C208.345 80.1668 208.367 80.276 208.439 80.3487C208.511 80.4214 208.62 80.4433 208.715 80.4042C208.81 80.365 208.872 80.2726 208.872 80.17C208.872 80.103 208.846 80.0387 208.798 79.9912C208.751 79.9437 208.687 79.9169 208.62 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 79.9167C211.334 79.9162 211.241 79.9776 211.201 80.0722C211.162 80.1668 211.183 80.276 211.255 80.3487C211.328 80.4214 211.437 80.4433 211.532 80.4042C211.626 80.365 211.688 80.2726 211.688 80.17C211.689 80.0305 211.576 79.9171 211.436 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 79.9167C219.784 79.9162 219.691 79.9776 219.651 80.0722C219.612 80.1668 219.633 80.276 219.706 80.3487C219.778 80.4214 219.887 80.4433 219.982 80.4042C220.077 80.365 220.138 80.2726 220.138 80.17C220.139 80.103 220.112 80.0387 220.065 79.9912C220.018 79.9437 219.953 79.9169 219.886 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 79.9167C221.193 79.9162 221.1 79.9776 221.061 80.0722C221.021 80.1668 221.042 80.276 221.115 80.3487C221.187 80.4214 221.296 80.4433 221.391 80.4042C221.486 80.365 221.548 80.2726 221.548 80.17C221.548 80.0305 221.435 79.9171 221.296 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 79.9167C222.601 79.9162 222.508 79.9776 222.469 80.0722C222.429 80.1668 222.451 80.276 222.523 80.3487C222.595 80.4214 222.704 80.4433 222.799 80.4042C222.894 80.365 222.956 80.2726 222.956 80.17C222.956 80.0305 222.843 79.9171 222.704 79.9167Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 80.17,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 81.257C197.25 81.2565 197.157 81.3179 197.117 81.4125C197.078 81.5071 197.099 81.6162 197.171 81.689C197.244 81.7617 197.353 81.7836 197.448 81.7445C197.542 81.7053 197.604 81.6129 197.604 81.5103C197.605 81.3708 197.492 81.2574 197.352 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 81.257C198.659 81.2565 198.566 81.3179 198.526 81.4125C198.487 81.5071 198.508 81.6163 198.581 81.689C198.653 81.7617 198.762 81.7836 198.857 81.7444C198.952 81.7053 199.013 81.6129 199.013 81.5103C199.014 81.4433 198.987 81.3789 198.94 81.3314C198.893 81.2839 198.828 81.2572 198.761 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 81.257C201.475 81.2565 201.383 81.3179 201.343 81.4125C201.303 81.5071 201.325 81.6162 201.397 81.689C201.469 81.7617 201.578 81.7836 201.673 81.7445C201.768 81.7053 201.83 81.6129 201.83 81.5103C201.83 81.3708 201.717 81.2574 201.578 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 81.257C207.109 81.2565 207.016 81.3179 206.977 81.4125C206.937 81.5071 206.958 81.6162 207.031 81.689C207.103 81.7617 207.212 81.7836 207.307 81.7445C207.402 81.7053 207.464 81.6129 207.464 81.5103C207.464 81.4433 207.437 81.379 207.39 81.3315C207.343 81.284 207.279 81.2572 207.212 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 81.257C208.517 81.2565 208.424 81.3179 208.385 81.4125C208.345 81.5071 208.367 81.6163 208.439 81.689C208.511 81.7617 208.62 81.7836 208.715 81.7444C208.81 81.7053 208.872 81.6129 208.872 81.5103C208.872 81.4433 208.846 81.3789 208.798 81.3314C208.751 81.2839 208.687 81.2572 208.62 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 81.257C211.334 81.2565 211.241 81.3179 211.201 81.4125C211.162 81.5071 211.183 81.6162 211.255 81.689C211.328 81.7617 211.437 81.7836 211.532 81.7445C211.626 81.7053 211.688 81.6129 211.688 81.5103C211.689 81.3708 211.576 81.2574 211.436 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 81.257C219.784 81.2565 219.691 81.3179 219.651 81.4125C219.612 81.5071 219.633 81.6163 219.706 81.689C219.778 81.7617 219.887 81.7836 219.982 81.7444C220.077 81.7053 220.138 81.6129 220.138 81.5103C220.139 81.4433 220.112 81.3789 220.065 81.3314C220.018 81.2839 219.953 81.2572 219.886 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 81.257C221.193 81.2565 221.1 81.3179 221.061 81.4125C221.021 81.5071 221.042 81.6162 221.115 81.689C221.187 81.7617 221.296 81.7836 221.391 81.7445C221.486 81.7053 221.548 81.6129 221.548 81.5103C221.548 81.3708 221.435 81.2574 221.296 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 81.257C222.601 81.2565 222.508 81.3179 222.469 81.4125C222.429 81.5071 222.451 81.6162 222.523 81.689C222.595 81.7617 222.704 81.7836 222.799 81.7445C222.894 81.7053 222.956 81.6129 222.956 81.5103C222.956 81.3708 222.843 81.2574 222.704 81.257Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 81.5103,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 83.9376C195.841 83.9371 195.749 83.9985 195.709 84.0931C195.67 84.1877 195.691 84.2969 195.763 84.3696C195.836 84.4422 195.945 84.4641 196.039 84.425C196.134 84.3858 196.196 84.2934 196.196 84.1908C196.196 84.0513 196.083 83.9379 195.944 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 83.9376C197.25 83.9371 197.157 83.9985 197.117 84.0931C197.078 84.1877 197.099 84.2968 197.171 84.3695C197.244 84.4422 197.353 84.4641 197.448 84.425C197.542 84.3858 197.604 84.2934 197.604 84.1908C197.605 84.0513 197.492 83.938 197.352 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 83.9376C198.659 83.9371 198.566 83.9985 198.526 84.0931C198.487 84.1877 198.508 84.2969 198.581 84.3696C198.653 84.4422 198.762 84.4641 198.857 84.425C198.952 84.3858 199.013 84.2934 199.013 84.1908C199.014 84.1238 198.987 84.0595 198.94 84.012C198.893 83.9645 198.828 83.9378 198.761 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 83.9376C200.067 83.9371 199.974 83.9985 199.935 84.0931C199.895 84.1877 199.916 84.2969 199.989 84.3696C200.061 84.4422 200.17 84.4641 200.265 84.425C200.36 84.3858 200.422 84.2934 200.422 84.1908C200.422 84.1238 200.395 84.0595 200.348 84.012C200.301 83.9645 200.237 83.9378 200.17 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 83.9376C201.475 83.9371 201.382 83.9985 201.343 84.0931C201.303 84.1877 201.325 84.2968 201.397 84.3695C201.469 84.4422 201.578 84.4641 201.673 84.425C201.768 84.3858 201.83 84.2934 201.83 84.1908C201.83 84.0513 201.717 83.938 201.578 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 83.9376C202.883 83.9371 202.791 83.9985 202.751 84.0931C202.711 84.1877 202.733 84.2969 202.805 84.3696C202.878 84.4422 202.987 84.4641 203.081 84.425C203.176 84.3858 203.238 84.2934 203.238 84.1908C203.238 84.1238 203.212 84.0595 203.164 84.012C203.117 83.9645 203.053 83.9378 202.986 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 83.9376C204.292 83.9371 204.199 83.9985 204.159 84.0931C204.12 84.1877 204.141 84.2969 204.213 84.3696C204.286 84.4422 204.395 84.4641 204.49 84.425C204.584 84.3858 204.646 84.2934 204.646 84.1908C204.646 84.1238 204.62 84.0595 204.573 84.012C204.525 83.9645 204.461 83.9378 204.394 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 83.9376C205.701 83.9371 205.608 83.9985 205.568 84.0931C205.529 84.1877 205.55 84.2969 205.623 84.3696C205.695 84.4422 205.804 84.4641 205.899 84.425C205.994 84.3858 206.055 84.2934 206.055 84.1908C206.056 84.0513 205.943 83.9379 205.803 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 83.9376C207.109 83.9371 207.016 83.9985 206.977 84.0931C206.937 84.1877 206.958 84.2968 207.031 84.3695C207.103 84.4422 207.212 84.4641 207.307 84.425C207.402 84.3858 207.464 84.2934 207.464 84.1908C207.464 84.1238 207.437 84.0595 207.39 84.012C207.343 83.9645 207.279 83.9378 207.212 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 83.9376C208.517 83.9371 208.424 83.9985 208.385 84.0931C208.345 84.1877 208.367 84.2969 208.439 84.3696C208.511 84.4422 208.62 84.4641 208.715 84.425C208.81 84.3858 208.872 84.2934 208.872 84.1908C208.872 84.1238 208.845 84.0595 208.798 84.012C208.751 83.9645 208.687 83.9378 208.62 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 83.9376C209.925 83.9371 209.833 83.9985 209.793 84.0931C209.753 84.1877 209.775 84.2969 209.847 84.3696C209.92 84.4422 210.029 84.4641 210.123 84.425C210.218 84.3858 210.28 84.2934 210.28 84.1908C210.28 84.1238 210.254 84.0595 210.206 84.012C210.159 83.9645 210.095 83.9378 210.028 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 83.9376C211.334 83.9371 211.241 83.9985 211.201 84.0931C211.162 84.1877 211.183 84.2968 211.255 84.3695C211.328 84.4422 211.437 84.4641 211.532 84.425C211.626 84.3858 211.688 84.2934 211.688 84.1908C211.689 84.0513 211.576 83.938 211.436 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 83.9376C212.742 83.9371 212.649 83.9985 212.609 84.0931C212.57 84.1877 212.591 84.2969 212.664 84.3696C212.736 84.4422 212.845 84.4641 212.94 84.425C213.035 84.3858 213.096 84.2934 213.096 84.1908C213.097 84.1238 213.07 84.0595 213.023 84.012C212.976 83.9645 212.911 83.9378 212.844 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 83.9376C214.151 83.9371 214.058 83.9985 214.019 84.0931C213.979 84.1877 214 84.2969 214.073 84.3696C214.145 84.4422 214.254 84.4641 214.349 84.425C214.444 84.3858 214.506 84.2934 214.506 84.1908C214.506 84.1238 214.479 84.0595 214.432 84.012C214.385 83.9645 214.321 83.9378 214.254 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 83.9376C215.559 83.9371 215.466 83.9985 215.427 84.0931C215.387 84.1877 215.409 84.2969 215.481 84.3696C215.553 84.4422 215.662 84.4641 215.757 84.425C215.852 84.3858 215.914 84.2934 215.914 84.1908C215.914 84.0513 215.801 83.9379 215.662 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 83.9376C216.967 83.9371 216.875 83.9985 216.835 84.0931C216.795 84.1877 216.817 84.2969 216.889 84.3696C216.962 84.4422 217.071 84.4641 217.165 84.425C217.26 84.3858 217.322 84.2934 217.322 84.1908C217.322 84.1238 217.296 84.0595 217.248 84.012C217.201 83.9645 217.137 83.9378 217.07 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 83.9376C218.377 83.9371 218.284 83.9985 218.244 84.0931C218.205 84.1877 218.226 84.2969 218.298 84.3696C218.371 84.4422 218.48 84.4641 218.575 84.425C218.669 84.3858 218.731 84.2934 218.731 84.1908C218.731 84.0513 218.619 83.9379 218.479 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 83.9376C219.784 83.9371 219.691 83.9985 219.651 84.0931C219.612 84.1877 219.633 84.2969 219.706 84.3696C219.778 84.4422 219.887 84.4641 219.982 84.425C220.077 84.3858 220.138 84.2934 220.138 84.1908C220.139 84.1238 220.112 84.0595 220.065 84.012C220.018 83.9645 219.953 83.9378 219.886 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 83.9376C221.193 83.9371 221.1 83.9985 221.061 84.0931C221.021 84.1877 221.042 84.2968 221.115 84.3695C221.187 84.4422 221.296 84.4641 221.391 84.425C221.486 84.3858 221.548 84.2934 221.548 84.1908C221.548 84.0513 221.435 83.938 221.296 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 83.9376C222.601 83.9371 222.508 83.9985 222.469 84.0931C222.429 84.1877 222.451 84.2968 222.523 84.3695C222.595 84.4422 222.704 84.4641 222.799 84.425C222.894 84.3858 222.956 84.2934 222.956 84.1908C222.956 84.0513 222.843 83.938 222.704 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 83.9376C224.009 83.9371 223.917 83.9985 223.877 84.0931C223.837 84.1877 223.859 84.2969 223.931 84.3696C224.004 84.4422 224.113 84.4641 224.207 84.425C224.302 84.3858 224.364 84.2934 224.364 84.1908C224.364 84.1238 224.338 84.0595 224.29 84.012C224.243 83.9645 224.179 83.9378 224.112 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 83.9376C225.419 83.9371 225.326 83.9985 225.286 84.0931C225.247 84.1877 225.268 84.2969 225.34 84.3696C225.413 84.4422 225.522 84.4641 225.617 84.425C225.711 84.3858 225.773 84.2934 225.773 84.1908C225.773 84.0513 225.661 83.9379 225.521 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 83.9376C226.827 83.9371 226.734 83.9985 226.694 84.0931C226.655 84.1877 226.676 84.2969 226.749 84.3696C226.821 84.4422 226.93 84.4641 227.025 84.425C227.12 84.3858 227.181 84.2934 227.181 84.1908C227.182 84.0513 227.069 83.9379 226.929 83.9376Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 87.9584C195.841 87.9579 195.749 88.0193 195.709 88.1139C195.67 88.2085 195.691 88.3177 195.763 88.3904C195.836 88.4631 195.945 88.485 196.039 88.4458C196.134 88.4067 196.196 88.3143 196.196 88.2117C196.196 88.0722 196.084 87.9588 195.944 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 87.9584C197.25 87.9579 197.157 88.0193 197.117 88.1139C197.078 88.2085 197.099 88.3176 197.171 88.3903C197.244 88.4631 197.353 88.485 197.448 88.4458C197.542 88.4067 197.604 88.3143 197.604 88.2117C197.605 88.0722 197.492 87.9588 197.352 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 87.9584C198.659 87.9579 198.566 88.0193 198.526 88.1139C198.487 88.2085 198.508 88.3177 198.581 88.3904C198.653 88.4631 198.762 88.485 198.857 88.4458C198.952 88.4067 199.013 88.3143 199.013 88.2117C199.014 88.1447 198.987 88.0804 198.94 88.0329C198.893 87.9853 198.828 87.9586 198.761 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 87.9584C200.067 87.9579 199.974 88.0193 199.935 88.1139C199.895 88.2085 199.916 88.3177 199.989 88.3904C200.061 88.4631 200.17 88.485 200.265 88.4458C200.36 88.4067 200.422 88.3143 200.422 88.2117C200.422 88.1447 200.395 88.0804 200.348 88.0329C200.301 87.9853 200.237 87.9586 200.17 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 87.9584C201.475 87.9579 201.383 88.0193 201.343 88.1139C201.303 88.2085 201.325 88.3176 201.397 88.3903C201.469 88.4631 201.578 88.485 201.673 88.4458C201.768 88.4067 201.83 88.3143 201.83 88.2117C201.83 88.0722 201.717 87.9588 201.578 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 87.9584C202.883 87.9579 202.791 88.0193 202.751 88.1139C202.711 88.2085 202.733 88.3177 202.805 88.3904C202.878 88.4631 202.987 88.485 203.081 88.4458C203.176 88.4067 203.238 88.3143 203.238 88.2117C203.238 88.1447 203.212 88.0804 203.164 88.0329C203.117 87.9853 203.053 87.9586 202.986 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 87.9584C204.292 87.9579 204.199 88.0193 204.159 88.1139C204.12 88.2085 204.141 88.3177 204.213 88.3904C204.286 88.4631 204.395 88.485 204.49 88.4458C204.584 88.4067 204.646 88.3143 204.646 88.2117C204.646 88.1447 204.62 88.0804 204.573 88.0329C204.525 87.9853 204.461 87.9586 204.394 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 87.9584C205.701 87.9579 205.608 88.0193 205.568 88.1139C205.529 88.2085 205.55 88.3177 205.623 88.3904C205.695 88.4631 205.804 88.485 205.899 88.4458C205.994 88.4067 206.055 88.3143 206.055 88.2117C206.056 88.0722 205.943 87.9588 205.803 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 87.9584C207.109 87.9579 207.016 88.0193 206.977 88.1139C206.937 88.2085 206.958 88.3176 207.031 88.3903C207.103 88.4631 207.212 88.485 207.307 88.4458C207.402 88.4067 207.464 88.3143 207.464 88.2117C207.464 88.1447 207.437 88.0804 207.39 88.0329C207.343 87.9854 207.279 87.9586 207.212 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 87.9584C208.517 87.9579 208.424 88.0193 208.385 88.1139C208.345 88.2085 208.367 88.3177 208.439 88.3904C208.511 88.4631 208.62 88.485 208.715 88.4458C208.81 88.4067 208.872 88.3143 208.872 88.2117C208.872 88.1447 208.846 88.0804 208.798 88.0329C208.751 87.9853 208.687 87.9586 208.62 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 87.9584C209.925 87.9579 209.833 88.0193 209.793 88.1139C209.753 88.2085 209.775 88.3177 209.847 88.3904C209.92 88.4631 210.029 88.485 210.123 88.4458C210.218 88.4067 210.28 88.3143 210.28 88.2117C210.28 88.1447 210.254 88.0804 210.206 88.0329C210.159 87.9853 210.095 87.9586 210.028 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 87.9584C211.334 87.9579 211.241 88.0193 211.201 88.1139C211.162 88.2085 211.183 88.3176 211.255 88.3903C211.328 88.4631 211.437 88.485 211.532 88.4458C211.626 88.4067 211.688 88.3143 211.688 88.2117C211.689 88.0722 211.576 87.9588 211.436 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 87.9584C212.742 87.9579 212.649 88.0193 212.609 88.1139C212.57 88.2085 212.591 88.3177 212.664 88.3904C212.736 88.4631 212.845 88.485 212.94 88.4458C213.035 88.4067 213.096 88.3143 213.096 88.2117C213.097 88.1447 213.07 88.0804 213.023 88.0329C212.976 87.9853 212.911 87.9586 212.844 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 87.9584C214.151 87.9579 214.058 88.0193 214.019 88.1139C213.979 88.2085 214 88.3177 214.073 88.3904C214.145 88.4631 214.254 88.485 214.349 88.4458C214.444 88.4067 214.506 88.3143 214.506 88.2117C214.506 88.1447 214.479 88.0804 214.432 88.0329C214.385 87.9853 214.321 87.9586 214.254 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 87.9584C215.559 87.9579 215.466 88.0193 215.427 88.1139C215.387 88.2085 215.409 88.3177 215.481 88.3904C215.553 88.4631 215.662 88.485 215.757 88.4458C215.852 88.4067 215.914 88.3143 215.914 88.2117C215.914 88.0722 215.801 87.9588 215.662 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 87.9584C216.967 87.9579 216.875 88.0193 216.835 88.1139C216.795 88.2085 216.817 88.3177 216.889 88.3904C216.962 88.4631 217.071 88.485 217.165 88.4458C217.26 88.4067 217.322 88.3143 217.322 88.2117C217.322 88.1447 217.296 88.0804 217.248 88.0329C217.201 87.9853 217.137 87.9586 217.07 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 87.9584C218.377 87.9579 218.284 88.0193 218.244 88.1139C218.205 88.2085 218.226 88.3177 218.298 88.3904C218.371 88.4631 218.48 88.485 218.575 88.4458C218.669 88.4067 218.731 88.3143 218.731 88.2117C218.732 88.0722 218.619 87.9588 218.479 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 87.9584C219.784 87.9579 219.691 88.0193 219.651 88.1139C219.612 88.2085 219.633 88.3177 219.706 88.3904C219.778 88.4631 219.887 88.485 219.982 88.4458C220.077 88.4067 220.138 88.3143 220.138 88.2117C220.139 88.1447 220.112 88.0804 220.065 88.0329C220.018 87.9853 219.953 87.9586 219.886 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 87.9584C221.193 87.9579 221.1 88.0193 221.061 88.1139C221.021 88.2085 221.042 88.3176 221.115 88.3903C221.187 88.4631 221.296 88.485 221.391 88.4458C221.486 88.4067 221.548 88.3143 221.548 88.2117C221.548 88.0722 221.435 87.9588 221.296 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 87.9584C222.601 87.9579 222.508 88.0193 222.469 88.1139C222.429 88.2085 222.451 88.3176 222.523 88.3903C222.595 88.4631 222.704 88.485 222.799 88.4458C222.894 88.4067 222.956 88.3143 222.956 88.2117C222.956 88.0722 222.843 87.9588 222.704 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 87.9584C224.009 87.9579 223.917 88.0193 223.877 88.1139C223.837 88.2085 223.859 88.3177 223.931 88.3904C224.004 88.4631 224.113 88.485 224.207 88.4458C224.302 88.4067 224.364 88.3143 224.364 88.2117C224.364 88.1447 224.338 88.0804 224.29 88.0329C224.243 87.9854 224.179 87.9586 224.112 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 87.9584C225.419 87.9579 225.326 88.0193 225.286 88.1139C225.247 88.2085 225.268 88.3177 225.34 88.3904C225.413 88.4631 225.522 88.485 225.617 88.4458C225.711 88.4067 225.773 88.3143 225.773 88.2117C225.774 88.0722 225.661 87.9588 225.521 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 87.9584C226.827 87.9579 226.734 88.0193 226.694 88.1139C226.655 88.2085 226.676 88.3177 226.749 88.3904C226.821 88.4631 226.93 88.485 227.025 88.4458C227.12 88.4067 227.181 88.3143 227.181 88.2117C227.182 88.0722 227.069 87.9588 226.929 87.9584Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 73.2154C197.25 73.2148 197.157 73.2762 197.117 73.3708C197.078 73.4654 197.099 73.5746 197.171 73.6473C197.244 73.72 197.353 73.7419 197.448 73.7027C197.542 73.6636 197.604 73.5712 197.604 73.4686C197.605 73.3291 197.492 73.2157 197.352 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 73.2154C198.659 73.2149 198.566 73.2763 198.526 73.3709C198.487 73.4655 198.508 73.5746 198.581 73.6473C198.653 73.72 198.762 73.7419 198.857 73.7027C198.952 73.6636 199.013 73.5712 199.013 73.4686C199.014 73.4016 198.987 73.3373 198.94 73.2898C198.893 73.2423 198.828 73.2155 198.761 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 73.2154C201.475 73.2148 201.382 73.2762 201.343 73.3708C201.303 73.4654 201.325 73.5746 201.397 73.6473C201.469 73.72 201.578 73.7419 201.673 73.7027C201.768 73.6636 201.83 73.5712 201.83 73.4686C201.83 73.3291 201.717 73.2157 201.578 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 73.2154C207.109 73.2148 207.016 73.2762 206.977 73.3708C206.937 73.4654 206.958 73.5746 207.031 73.6473C207.103 73.72 207.212 73.7419 207.307 73.7027C207.402 73.6636 207.464 73.5712 207.464 73.4686C207.464 73.4016 207.437 73.3373 207.39 73.2898C207.343 73.2423 207.279 73.2155 207.212 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 73.2154C208.517 73.2149 208.424 73.2763 208.385 73.3709C208.345 73.4655 208.367 73.5746 208.439 73.6473C208.511 73.72 208.62 73.7419 208.715 73.7027C208.81 73.6636 208.872 73.5712 208.872 73.4686C208.872 73.4016 208.845 73.3373 208.798 73.2898C208.751 73.2423 208.687 73.2155 208.62 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 73.2154C211.334 73.2148 211.241 73.2762 211.201 73.3708C211.162 73.4654 211.183 73.5746 211.255 73.6473C211.328 73.72 211.437 73.7419 211.532 73.7027C211.626 73.6636 211.688 73.5712 211.688 73.4686C211.689 73.3291 211.576 73.2157 211.436 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 73.2154C219.784 73.2149 219.691 73.2763 219.651 73.3709C219.612 73.4655 219.633 73.5746 219.706 73.6473C219.778 73.72 219.887 73.7419 219.982 73.7027C220.077 73.6636 220.138 73.5712 220.138 73.4686C220.139 73.4016 220.112 73.3373 220.065 73.2898C220.018 73.2423 219.953 73.2155 219.886 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 73.2154C221.193 73.2148 221.1 73.2762 221.061 73.3708C221.021 73.4654 221.042 73.5746 221.115 73.6473C221.187 73.72 221.296 73.7419 221.391 73.7027C221.486 73.6636 221.548 73.5712 221.548 73.4686C221.548 73.3291 221.435 73.2157 221.296 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 73.2154C222.601 73.2148 222.508 73.2762 222.469 73.3708C222.429 73.4654 222.451 73.5746 222.523 73.6473C222.595 73.72 222.704 73.7419 222.799 73.7027C222.894 73.6636 222.956 73.5712 222.956 73.4686C222.956 73.3291 222.843 73.2157 222.704 73.2154Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 73.4686,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 75.8959C197.25 75.8954 197.157 75.9568 197.117 76.0514C197.078 76.146 197.099 76.2551 197.171 76.3278C197.244 76.4005 197.353 76.4224 197.448 76.3833C197.542 76.3442 197.604 76.2517 197.604 76.1492C197.605 76.0097 197.492 75.8963 197.352 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 75.8959C198.659 75.8954 198.566 75.9568 198.526 76.0514C198.487 76.146 198.508 76.2552 198.581 76.3279C198.653 76.4005 198.762 76.4224 198.857 76.3833C198.952 76.3442 199.013 76.2517 199.013 76.1492C199.014 76.0822 198.987 76.0178 198.94 75.9703C198.893 75.9228 198.828 75.8961 198.761 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 75.8959C201.475 75.8954 201.382 75.9568 201.343 76.0514C201.303 76.146 201.325 76.2551 201.397 76.3278C201.469 76.4005 201.578 76.4224 201.673 76.3833C201.768 76.3442 201.83 76.2517 201.83 76.1492C201.83 76.0097 201.717 75.8963 201.578 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 75.8959C207.109 75.8954 207.016 75.9568 206.977 76.0514C206.937 76.146 206.958 76.2551 207.031 76.3278C207.103 76.4005 207.212 76.4224 207.307 76.3833C207.402 76.3442 207.464 76.2517 207.464 76.1492C207.464 76.0822 207.437 76.0178 207.39 75.9703C207.343 75.9228 207.279 75.8961 207.212 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 75.8959C208.517 75.8954 208.424 75.9568 208.385 76.0514C208.345 76.146 208.367 76.2552 208.439 76.3279C208.511 76.4005 208.62 76.4224 208.715 76.3833C208.81 76.3442 208.872 76.2517 208.872 76.1492C208.872 76.0822 208.845 76.0178 208.798 75.9703C208.751 75.9228 208.687 75.8961 208.62 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 75.8959C211.334 75.8954 211.241 75.9568 211.201 76.0514C211.162 76.146 211.183 76.2551 211.255 76.3278C211.328 76.4005 211.437 76.4224 211.532 76.3833C211.626 76.3442 211.688 76.2517 211.688 76.1492C211.689 76.0097 211.576 75.8963 211.436 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 75.8959C219.784 75.8954 219.691 75.9568 219.651 76.0514C219.612 76.146 219.633 76.2552 219.706 76.3279C219.778 76.4005 219.887 76.4224 219.982 76.3833C220.077 76.3442 220.138 76.2517 220.138 76.1492C220.139 76.0822 220.112 76.0178 220.065 75.9703C220.018 75.9228 219.953 75.8961 219.886 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 75.8959C221.193 75.8954 221.1 75.9568 221.061 76.0514C221.021 76.146 221.042 76.2551 221.115 76.3278C221.187 76.4005 221.296 76.4224 221.391 76.3833C221.486 76.3442 221.548 76.2517 221.548 76.1492C221.548 76.0097 221.435 75.8963 221.296 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 75.8959C222.601 75.8954 222.508 75.9568 222.469 76.0514C222.429 76.146 222.451 76.2551 222.523 76.3278C222.595 76.4005 222.704 76.4224 222.799 76.3833C222.894 76.3442 222.956 76.2517 222.956 76.1492C222.956 76.0097 222.843 75.8963 222.704 75.8959Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 76.1492,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 77.2362C195.841 77.2357 195.749 77.2971 195.709 77.3917C195.67 77.4863 195.691 77.5954 195.763 77.6681C195.836 77.7408 195.945 77.7627 196.039 77.7236C196.134 77.6845 196.196 77.592 196.196 77.4895C196.196 77.3499 196.084 77.2365 195.944 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 77.2362C197.25 77.2357 197.157 77.297 197.117 77.3916C197.078 77.4862 197.099 77.5954 197.171 77.6681C197.244 77.7408 197.353 77.7627 197.448 77.7236C197.542 77.6845 197.604 77.592 197.604 77.4895C197.605 77.3499 197.492 77.2365 197.352 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 77.2362C198.659 77.2357 198.566 77.2971 198.526 77.3917C198.487 77.4863 198.508 77.5954 198.581 77.6681C198.653 77.7408 198.762 77.7627 198.857 77.7236C198.952 77.6845 199.013 77.592 199.013 77.4895C199.014 77.4225 198.987 77.3581 198.94 77.3106C198.893 77.2631 198.828 77.2363 198.761 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 77.2362C200.067 77.2357 199.974 77.2971 199.935 77.3917C199.895 77.4863 199.916 77.5954 199.989 77.6681C200.061 77.7408 200.17 77.7627 200.265 77.7236C200.36 77.6845 200.422 77.592 200.422 77.4895C200.422 77.4225 200.395 77.3581 200.348 77.3106C200.301 77.2631 200.237 77.2363 200.17 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 77.2362C201.475 77.2357 201.383 77.297 201.343 77.3916C201.303 77.4862 201.325 77.5954 201.397 77.6681C201.469 77.7408 201.578 77.7627 201.673 77.7236C201.768 77.6845 201.83 77.592 201.83 77.4895C201.83 77.3499 201.717 77.2365 201.578 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 77.2362C202.883 77.2357 202.791 77.2971 202.751 77.3917C202.711 77.4863 202.733 77.5954 202.805 77.6681C202.878 77.7408 202.987 77.7627 203.081 77.7236C203.176 77.6845 203.238 77.592 203.238 77.4895C203.238 77.4225 203.212 77.3581 203.164 77.3106C203.117 77.2631 203.053 77.2363 202.986 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 77.2362C204.292 77.2357 204.199 77.2971 204.159 77.3917C204.12 77.4863 204.141 77.5954 204.213 77.6681C204.286 77.7408 204.395 77.7627 204.49 77.7236C204.584 77.6845 204.646 77.592 204.646 77.4895C204.646 77.4225 204.62 77.3581 204.573 77.3106C204.525 77.2631 204.461 77.2363 204.394 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 77.2362C205.701 77.2357 205.608 77.2971 205.568 77.3917C205.529 77.4863 205.55 77.5954 205.623 77.6681C205.695 77.7408 205.804 77.7627 205.899 77.7236C205.994 77.6845 206.055 77.592 206.055 77.4895C206.056 77.3499 205.943 77.2365 205.803 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 77.2362C207.109 77.2357 207.016 77.297 206.977 77.3916C206.937 77.4862 206.958 77.5954 207.031 77.6681C207.103 77.7408 207.212 77.7627 207.307 77.7236C207.402 77.6845 207.464 77.592 207.464 77.4895C207.464 77.4225 207.437 77.3581 207.39 77.3106C207.343 77.2631 207.279 77.2363 207.212 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 77.2362C208.517 77.2357 208.424 77.2971 208.385 77.3917C208.345 77.4863 208.367 77.5954 208.439 77.6681C208.511 77.7408 208.62 77.7627 208.715 77.7236C208.81 77.6845 208.872 77.592 208.872 77.4895C208.872 77.4225 208.846 77.3581 208.798 77.3106C208.751 77.2631 208.687 77.2363 208.62 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 77.2362C209.925 77.2357 209.833 77.2971 209.793 77.3917C209.753 77.4863 209.775 77.5954 209.847 77.6681C209.92 77.7408 210.029 77.7627 210.123 77.7236C210.218 77.6845 210.28 77.592 210.28 77.4895C210.28 77.4225 210.254 77.3581 210.206 77.3106C210.159 77.2631 210.095 77.2363 210.028 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 77.2362C211.334 77.2357 211.241 77.297 211.201 77.3916C211.162 77.4862 211.183 77.5954 211.255 77.6681C211.328 77.7408 211.437 77.7627 211.532 77.7236C211.626 77.6845 211.688 77.592 211.688 77.4895C211.689 77.3499 211.576 77.2365 211.436 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 77.2362C212.742 77.2357 212.649 77.2971 212.609 77.3917C212.57 77.4863 212.591 77.5954 212.664 77.6681C212.736 77.7408 212.845 77.7627 212.94 77.7236C213.035 77.6845 213.096 77.592 213.096 77.4895C213.097 77.4225 213.07 77.3581 213.023 77.3106C212.976 77.2631 212.911 77.2363 212.844 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 77.2362C214.151 77.2357 214.058 77.2971 214.019 77.3917C213.979 77.4863 214 77.5954 214.073 77.6681C214.145 77.7408 214.254 77.7627 214.349 77.7236C214.444 77.6845 214.506 77.592 214.506 77.4895C214.506 77.4225 214.479 77.3581 214.432 77.3106C214.385 77.2631 214.321 77.2363 214.254 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 77.2362C215.559 77.2357 215.466 77.2971 215.427 77.3917C215.387 77.4863 215.409 77.5954 215.481 77.6681C215.553 77.7408 215.662 77.7627 215.757 77.7236C215.852 77.6845 215.914 77.592 215.914 77.4895C215.914 77.3499 215.801 77.2365 215.662 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 77.2362C216.967 77.2357 216.875 77.2971 216.835 77.3917C216.795 77.4863 216.817 77.5954 216.889 77.6681C216.962 77.7408 217.071 77.7627 217.165 77.7236C217.26 77.6845 217.322 77.592 217.322 77.4895C217.322 77.4225 217.296 77.3581 217.248 77.3106C217.201 77.2631 217.137 77.2363 217.07 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 77.2362C218.377 77.2357 218.284 77.2971 218.244 77.3917C218.205 77.4863 218.226 77.5954 218.298 77.6681C218.371 77.7408 218.48 77.7627 218.575 77.7236C218.669 77.6845 218.731 77.592 218.731 77.4895C218.732 77.3499 218.619 77.2365 218.479 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 77.2362C219.784 77.2357 219.691 77.2971 219.651 77.3917C219.612 77.4863 219.633 77.5954 219.706 77.6681C219.778 77.7408 219.887 77.7627 219.982 77.7236C220.077 77.6845 220.138 77.592 220.138 77.4895C220.139 77.4225 220.112 77.3581 220.065 77.3106C220.018 77.2631 219.953 77.2363 219.886 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 77.2362C221.193 77.2357 221.1 77.297 221.061 77.3916C221.021 77.4862 221.042 77.5954 221.115 77.6681C221.187 77.7408 221.296 77.7627 221.391 77.7236C221.486 77.6845 221.548 77.592 221.548 77.4895C221.548 77.3499 221.435 77.2365 221.296 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 77.2362C222.601 77.2357 222.508 77.297 222.469 77.3916C222.429 77.4862 222.451 77.5954 222.523 77.6681C222.595 77.7408 222.704 77.7627 222.799 77.7236C222.894 77.6845 222.956 77.592 222.956 77.4895C222.956 77.3499 222.843 77.2365 222.704 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 77.2362C224.009 77.2357 223.917 77.2971 223.877 77.3917C223.837 77.4863 223.859 77.5954 223.931 77.6681C224.004 77.7408 224.113 77.7627 224.207 77.7236C224.302 77.6845 224.364 77.592 224.364 77.4895C224.364 77.4225 224.338 77.3581 224.29 77.3106C224.243 77.2631 224.179 77.2363 224.112 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 77.2362C225.419 77.2357 225.326 77.2971 225.286 77.3917C225.247 77.4863 225.268 77.5954 225.34 77.6681C225.413 77.7408 225.522 77.7627 225.617 77.7236C225.711 77.6845 225.773 77.592 225.773 77.4895C225.774 77.3499 225.661 77.2365 225.521 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 77.2362C226.827 77.2357 226.734 77.2971 226.694 77.3917C226.655 77.4863 226.676 77.5954 226.749 77.6681C226.821 77.7408 226.93 77.7627 227.025 77.7236C227.12 77.6845 227.181 77.592 227.181 77.4895C227.182 77.3499 227.069 77.2365 226.929 77.2362Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 71.8751C195.841 71.8746 195.749 71.936 195.709 72.0306C195.67 72.1252 195.691 72.2343 195.763 72.307C195.836 72.3797 195.945 72.4016 196.039 72.3625C196.134 72.3233 196.196 72.2309 196.196 72.1283C196.196 71.9888 196.084 71.8754 195.944 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 71.8751C197.25 71.8745 197.157 71.9359 197.117 72.0305C197.078 72.1251 197.099 72.2343 197.171 72.307C197.244 72.3797 197.353 72.4016 197.448 72.3625C197.542 72.3233 197.604 72.2309 197.604 72.1283C197.605 71.9888 197.492 71.8754 197.352 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 71.8751C198.659 71.8746 198.566 71.936 198.526 72.0306C198.487 72.1252 198.508 72.2343 198.581 72.307C198.653 72.3797 198.762 72.4016 198.857 72.3625C198.952 72.3233 199.013 72.2309 199.013 72.1283C199.014 72.0613 198.987 71.997 198.94 71.9495C198.893 71.902 198.828 71.8752 198.761 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 71.8751C200.067 71.8746 199.974 71.936 199.935 72.0306C199.895 72.1252 199.916 72.2343 199.989 72.307C200.061 72.3797 200.17 72.4016 200.265 72.3625C200.36 72.3233 200.422 72.2309 200.422 72.1283C200.422 72.0613 200.395 71.997 200.348 71.9495C200.301 71.902 200.237 71.8752 200.17 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 71.8751C201.475 71.8745 201.383 71.9359 201.343 72.0305C201.303 72.1251 201.325 72.2343 201.397 72.307C201.469 72.3797 201.578 72.4016 201.673 72.3625C201.768 72.3233 201.83 72.2309 201.83 72.1283C201.83 71.9888 201.717 71.8754 201.578 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 71.8751C202.883 71.8746 202.791 71.936 202.751 72.0306C202.711 72.1252 202.733 72.2343 202.805 72.307C202.878 72.3797 202.987 72.4016 203.081 72.3625C203.176 72.3233 203.238 72.2309 203.238 72.1283C203.238 72.0613 203.212 71.997 203.164 71.9495C203.117 71.902 203.053 71.8752 202.986 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 71.8751C204.292 71.8746 204.199 71.936 204.159 72.0306C204.12 72.1252 204.141 72.2343 204.213 72.307C204.286 72.3797 204.395 72.4016 204.49 72.3625C204.584 72.3233 204.646 72.2309 204.646 72.1283C204.646 72.0613 204.62 71.997 204.573 71.9495C204.525 71.902 204.461 71.8752 204.394 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 71.8751C205.701 71.8746 205.608 71.936 205.568 72.0306C205.529 72.1252 205.55 72.2343 205.623 72.307C205.695 72.3797 205.804 72.4016 205.899 72.3625C205.994 72.3233 206.055 72.2309 206.055 72.1283C206.056 71.9888 205.943 71.8754 205.803 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 71.8751C207.109 71.8745 207.016 71.9359 206.977 72.0305C206.937 72.1251 206.958 72.2343 207.031 72.307C207.103 72.3797 207.212 72.4016 207.307 72.3625C207.402 72.3233 207.464 72.2309 207.464 72.1283C207.464 72.0613 207.437 71.997 207.39 71.9495C207.343 71.902 207.279 71.8752 207.212 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 71.8751C208.517 71.8746 208.424 71.936 208.385 72.0306C208.345 72.1252 208.367 72.2343 208.439 72.307C208.511 72.3797 208.62 72.4016 208.715 72.3625C208.81 72.3233 208.872 72.2309 208.872 72.1283C208.872 72.0613 208.846 71.997 208.798 71.9495C208.751 71.902 208.687 71.8752 208.62 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 71.8751C209.925 71.8746 209.833 71.936 209.793 72.0306C209.753 72.1252 209.775 72.2343 209.847 72.307C209.92 72.3797 210.029 72.4016 210.123 72.3625C210.218 72.3233 210.28 72.2309 210.28 72.1283C210.28 72.0613 210.254 71.997 210.206 71.9495C210.159 71.902 210.095 71.8752 210.028 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 71.8751C211.334 71.8745 211.241 71.9359 211.201 72.0305C211.162 72.1251 211.183 72.2343 211.255 72.307C211.328 72.3797 211.437 72.4016 211.532 72.3625C211.626 72.3233 211.688 72.2309 211.688 72.1283C211.689 71.9888 211.576 71.8754 211.436 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 71.8751C212.742 71.8746 212.649 71.936 212.609 72.0306C212.57 72.1252 212.591 72.2343 212.664 72.307C212.736 72.3797 212.845 72.4016 212.94 72.3625C213.035 72.3233 213.096 72.2309 213.096 72.1283C213.097 72.0613 213.07 71.997 213.023 71.9495C212.976 71.902 212.911 71.8752 212.844 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 71.8751C214.151 71.8746 214.058 71.936 214.019 72.0306C213.979 72.1252 214 72.2343 214.073 72.307C214.145 72.3797 214.254 72.4016 214.349 72.3625C214.444 72.3233 214.506 72.2309 214.506 72.1283C214.506 72.0613 214.479 71.997 214.432 71.9495C214.385 71.902 214.321 71.8752 214.254 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 71.8751C215.559 71.8746 215.466 71.936 215.427 72.0306C215.387 72.1252 215.409 72.2343 215.481 72.307C215.553 72.3797 215.662 72.4016 215.757 72.3625C215.852 72.3233 215.914 72.2309 215.914 72.1283C215.914 71.9888 215.801 71.8754 215.662 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 71.8751C216.967 71.8746 216.875 71.936 216.835 72.0306C216.795 72.1252 216.817 72.2343 216.889 72.307C216.962 72.3797 217.071 72.4016 217.165 72.3625C217.26 72.3233 217.322 72.2309 217.322 72.1283C217.322 72.0613 217.296 71.997 217.248 71.9495C217.201 71.902 217.137 71.8752 217.07 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 71.8751C218.377 71.8746 218.284 71.936 218.244 72.0306C218.205 72.1252 218.226 72.2343 218.298 72.307C218.371 72.3797 218.48 72.4016 218.575 72.3625C218.669 72.3233 218.731 72.2309 218.731 72.1283C218.732 71.9888 218.619 71.8754 218.479 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 71.8751C219.784 71.8746 219.691 71.936 219.651 72.0306C219.612 72.1252 219.633 72.2343 219.706 72.307C219.778 72.3797 219.887 72.4016 219.982 72.3625C220.077 72.3233 220.138 72.2309 220.138 72.1283C220.139 72.0613 220.112 71.997 220.065 71.9495C220.018 71.902 219.953 71.8752 219.886 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 71.8751C221.193 71.8745 221.1 71.9359 221.061 72.0305C221.021 72.1251 221.042 72.2343 221.115 72.307C221.187 72.3797 221.296 72.4016 221.391 72.3625C221.486 72.3233 221.548 72.2309 221.548 72.1283C221.548 71.9888 221.435 71.8754 221.296 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 71.8751C222.601 71.8745 222.508 71.9359 222.469 72.0305C222.429 72.1251 222.451 72.2343 222.523 72.307C222.595 72.3797 222.704 72.4016 222.799 72.3625C222.894 72.3233 222.956 72.2309 222.956 72.1283C222.956 71.9888 222.843 71.8754 222.704 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 71.8751C224.009 71.8746 223.917 71.936 223.877 72.0306C223.837 72.1252 223.859 72.2343 223.931 72.307C224.004 72.3797 224.113 72.4016 224.207 72.3625C224.302 72.3233 224.364 72.2309 224.364 72.1283C224.364 72.0613 224.338 71.997 224.29 71.9495C224.243 71.902 224.179 71.8752 224.112 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 71.8751C225.419 71.8746 225.326 71.936 225.286 72.0306C225.247 72.1252 225.268 72.2343 225.34 72.307C225.413 72.3797 225.522 72.4016 225.617 72.3625C225.711 72.3233 225.773 72.2309 225.773 72.1283C225.773 71.9888 225.661 71.8754 225.521 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 71.8751C226.827 71.8746 226.734 71.936 226.694 72.0306C226.655 72.1252 226.676 72.2343 226.749 72.307C226.821 72.3797 226.93 72.4016 227.025 72.3625C227.12 72.3233 227.181 72.2309 227.181 72.1283C227.182 71.9888 227.069 71.8754 226.929 71.8751Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 70.5348C195.841 70.5343 195.749 70.5957 195.709 70.6903C195.67 70.7849 195.691 70.8941 195.763 70.9667C195.836 71.0394 195.945 71.0613 196.039 71.0222C196.134 70.9831 196.196 70.8906 196.196 70.7881C196.196 70.6485 196.084 70.5351 195.944 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 70.5348C197.25 70.5343 197.157 70.5957 197.117 70.6903C197.078 70.7849 197.099 70.894 197.171 70.9667C197.244 71.0394 197.353 71.0613 197.448 71.0222C197.542 70.9831 197.604 70.8906 197.604 70.7881C197.605 70.6485 197.492 70.5352 197.352 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 70.5348C198.659 70.5343 198.566 70.5957 198.526 70.6903C198.487 70.7849 198.508 70.8941 198.581 70.9667C198.653 71.0394 198.762 71.0613 198.857 71.0222C198.952 70.9831 199.013 70.8906 199.013 70.7881C199.014 70.721 198.987 70.6567 198.94 70.6092C198.893 70.5617 198.828 70.5349 198.761 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 70.5348C200.067 70.5343 199.974 70.5957 199.935 70.6903C199.895 70.7849 199.916 70.8941 199.989 70.9667C200.061 71.0394 200.17 71.0613 200.265 71.0222C200.36 70.9831 200.422 70.8906 200.422 70.7881C200.422 70.721 200.395 70.6567 200.348 70.6092C200.301 70.5617 200.237 70.5349 200.17 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 70.5348C201.475 70.5343 201.383 70.5957 201.343 70.6903C201.303 70.7849 201.325 70.894 201.397 70.9667C201.469 71.0394 201.578 71.0613 201.673 71.0222C201.768 70.9831 201.83 70.8906 201.83 70.7881C201.83 70.6485 201.717 70.5352 201.578 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 70.5348C202.883 70.5343 202.791 70.5957 202.751 70.6903C202.711 70.7849 202.733 70.8941 202.805 70.9667C202.878 71.0394 202.987 71.0613 203.081 71.0222C203.176 70.9831 203.238 70.8906 203.238 70.7881C203.238 70.721 203.212 70.6567 203.164 70.6092C203.117 70.5617 203.053 70.5349 202.986 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 70.5348C204.292 70.5343 204.199 70.5957 204.159 70.6903C204.12 70.7849 204.141 70.8941 204.213 70.9667C204.286 71.0394 204.395 71.0613 204.49 71.0222C204.584 70.9831 204.646 70.8906 204.646 70.7881C204.646 70.721 204.62 70.6567 204.573 70.6092C204.525 70.5617 204.461 70.5349 204.394 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 70.5348C205.701 70.5343 205.608 70.5957 205.568 70.6903C205.529 70.7849 205.55 70.8941 205.623 70.9667C205.695 71.0394 205.804 71.0613 205.899 71.0222C205.994 70.9831 206.055 70.8906 206.055 70.7881C206.056 70.6485 205.943 70.5351 205.803 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 70.5348C207.109 70.5343 207.016 70.5957 206.977 70.6903C206.937 70.7849 206.958 70.894 207.031 70.9667C207.103 71.0394 207.212 71.0613 207.307 71.0222C207.402 70.9831 207.464 70.8906 207.464 70.7881C207.464 70.7211 207.437 70.6567 207.39 70.6092C207.343 70.5617 207.279 70.535 207.212 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 70.5348C208.517 70.5343 208.424 70.5957 208.385 70.6903C208.345 70.7849 208.367 70.8941 208.439 70.9667C208.511 71.0394 208.62 71.0613 208.715 71.0222C208.81 70.9831 208.872 70.8906 208.872 70.7881C208.872 70.721 208.846 70.6567 208.798 70.6092C208.751 70.5617 208.687 70.5349 208.62 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 70.5348C209.925 70.5343 209.833 70.5957 209.793 70.6903C209.753 70.7849 209.775 70.8941 209.847 70.9667C209.92 71.0394 210.029 71.0613 210.123 71.0222C210.218 70.9831 210.28 70.8906 210.28 70.7881C210.28 70.721 210.254 70.6567 210.206 70.6092C210.159 70.5617 210.095 70.5349 210.028 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 70.5348C211.334 70.5343 211.241 70.5957 211.201 70.6903C211.162 70.7849 211.183 70.894 211.255 70.9667C211.328 71.0394 211.437 71.0613 211.532 71.0222C211.626 70.9831 211.688 70.8906 211.688 70.7881C211.689 70.6485 211.576 70.5352 211.436 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 70.5348C212.742 70.5343 212.649 70.5957 212.609 70.6903C212.57 70.7849 212.591 70.8941 212.664 70.9667C212.736 71.0394 212.845 71.0613 212.94 71.0222C213.035 70.9831 213.096 70.8906 213.096 70.7881C213.097 70.721 213.07 70.6567 213.023 70.6092C212.976 70.5617 212.911 70.5349 212.844 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 70.5348C214.151 70.5343 214.058 70.5957 214.019 70.6903C213.979 70.7849 214 70.8941 214.073 70.9667C214.145 71.0394 214.254 71.0613 214.349 71.0222C214.444 70.9831 214.506 70.8906 214.506 70.7881C214.506 70.721 214.479 70.6567 214.432 70.6092C214.385 70.5617 214.321 70.5349 214.254 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 70.5348C215.559 70.5343 215.466 70.5957 215.427 70.6903C215.387 70.7849 215.409 70.8941 215.481 70.9667C215.553 71.0394 215.662 71.0613 215.757 71.0222C215.852 70.9831 215.914 70.8906 215.914 70.7881C215.914 70.6485 215.801 70.5351 215.662 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 70.5348C216.967 70.5343 216.875 70.5957 216.835 70.6903C216.795 70.7849 216.817 70.8941 216.889 70.9667C216.962 71.0394 217.071 71.0613 217.165 71.0222C217.26 70.9831 217.322 70.8906 217.322 70.7881C217.322 70.721 217.296 70.6567 217.248 70.6092C217.201 70.5617 217.137 70.5349 217.07 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 70.5348C218.377 70.5343 218.284 70.5957 218.244 70.6903C218.205 70.7849 218.226 70.8941 218.298 70.9667C218.371 71.0394 218.48 71.0613 218.575 71.0222C218.669 70.9831 218.731 70.8906 218.731 70.7881C218.732 70.6485 218.619 70.5351 218.479 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 70.5348C219.784 70.5343 219.691 70.5957 219.651 70.6903C219.612 70.7849 219.633 70.8941 219.706 70.9667C219.778 71.0394 219.887 71.0613 219.982 71.0222C220.077 70.9831 220.138 70.8906 220.138 70.7881C220.139 70.721 220.112 70.6567 220.065 70.6092C220.018 70.5617 219.953 70.5349 219.886 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 70.5348C221.193 70.5343 221.1 70.5957 221.061 70.6903C221.021 70.7849 221.042 70.894 221.115 70.9667C221.187 71.0394 221.296 71.0613 221.391 71.0222C221.486 70.9831 221.548 70.8906 221.548 70.7881C221.548 70.6485 221.435 70.5352 221.296 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 70.5348C222.601 70.5343 222.508 70.5957 222.469 70.6903C222.429 70.7849 222.451 70.894 222.523 70.9667C222.595 71.0394 222.704 71.0613 222.799 71.0222C222.894 70.9831 222.956 70.8906 222.956 70.7881C222.956 70.6485 222.843 70.5352 222.704 70.5348V70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 70.5348C224.009 70.5343 223.917 70.5957 223.877 70.6903C223.837 70.7849 223.859 70.8941 223.931 70.9667C224.004 71.0394 224.113 71.0613 224.207 71.0222C224.302 70.9831 224.364 70.8906 224.364 70.7881C224.364 70.6485 224.251 70.5351 224.112 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 70.5348C225.419 70.5343 225.326 70.5957 225.286 70.6903C225.247 70.7849 225.268 70.8941 225.34 70.9667C225.413 71.0394 225.522 71.0613 225.617 71.0222C225.711 70.9831 225.773 70.8906 225.773 70.7881C225.773 70.6485 225.661 70.5351 225.521 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 70.5348C226.827 70.5343 226.734 70.5957 226.694 70.6903C226.655 70.7849 226.676 70.8941 226.749 70.9667C226.821 71.0394 226.93 71.0613 227.025 71.0222C227.12 70.9831 227.181 70.8906 227.181 70.7881C227.182 70.6485 227.069 70.5351 226.929 70.5348Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 74.5556C197.25 74.5551 197.157 74.6165 197.117 74.7111C197.078 74.8057 197.099 74.9149 197.171 74.9876C197.244 75.0603 197.353 75.0822 197.448 75.043C197.542 75.0039 197.604 74.9115 197.604 74.8089C197.605 74.6694 197.492 74.556 197.352 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 74.5556C198.659 74.5551 198.566 74.6165 198.526 74.7112C198.487 74.8058 198.508 74.9149 198.581 74.9876C198.653 75.0603 198.762 75.0822 198.857 75.043C198.952 75.0039 199.013 74.9115 199.013 74.8089C199.014 74.7419 198.987 74.6776 198.94 74.6301C198.893 74.5826 198.828 74.5558 198.761 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 74.5556C201.475 74.5551 201.382 74.6165 201.343 74.7111C201.303 74.8057 201.325 74.9149 201.397 74.9876C201.469 75.0603 201.578 75.0822 201.673 75.043C201.768 75.0039 201.83 74.9115 201.83 74.8089C201.83 74.6694 201.717 74.556 201.578 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 74.5556C207.109 74.5551 207.016 74.6165 206.977 74.7111C206.937 74.8057 206.958 74.9149 207.031 74.9876C207.103 75.0603 207.212 75.0822 207.307 75.043C207.402 75.0039 207.464 74.9115 207.464 74.8089C207.464 74.7419 207.437 74.6776 207.39 74.6301C207.343 74.5826 207.279 74.5558 207.212 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 74.5556C208.517 74.5551 208.424 74.6165 208.385 74.7112C208.345 74.8058 208.367 74.9149 208.439 74.9876C208.511 75.0603 208.62 75.0822 208.715 75.043C208.81 75.0039 208.872 74.9115 208.872 74.8089C208.872 74.7419 208.845 74.6776 208.798 74.6301C208.751 74.5826 208.687 74.5558 208.62 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 74.5556C211.334 74.5551 211.241 74.6165 211.201 74.7111C211.162 74.8057 211.183 74.9149 211.255 74.9876C211.328 75.0603 211.437 75.0822 211.532 75.043C211.626 75.0039 211.688 74.9115 211.688 74.8089C211.689 74.6694 211.576 74.556 211.436 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 74.5556C219.784 74.5551 219.691 74.6165 219.651 74.7112C219.612 74.8058 219.633 74.9149 219.706 74.9876C219.778 75.0603 219.887 75.0822 219.982 75.043C220.077 75.0039 220.138 74.9115 220.138 74.8089C220.139 74.7419 220.112 74.6776 220.065 74.6301C220.018 74.5826 219.953 74.5558 219.886 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 74.5556C221.193 74.5551 221.1 74.6165 221.061 74.7111C221.021 74.8057 221.042 74.9149 221.115 74.9876C221.187 75.0603 221.296 75.0822 221.391 75.043C221.486 75.0039 221.548 74.9115 221.548 74.8089C221.548 74.6694 221.435 74.556 221.296 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 74.5556C222.601 74.5551 222.508 74.6165 222.469 74.7111C222.429 74.8057 222.451 74.9149 222.523 74.9876C222.595 75.0603 222.704 75.0822 222.799 75.043C222.894 75.0039 222.956 74.9115 222.956 74.8089C222.956 74.6694 222.843 74.556 222.704 74.5556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 74.8089,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 66.5139C195.841 66.5135 195.749 66.5749 195.709 66.6695C195.67 66.7641 195.691 66.8732 195.763 66.9459C195.836 67.0186 195.945 67.0405 196.039 67.0014C196.134 66.9622 196.196 66.8698 196.196 66.7672C196.196 66.6277 196.084 66.5143 195.944 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 66.5139C197.25 66.5134 197.157 66.5748 197.117 66.6694C197.078 66.764 197.099 66.8732 197.171 66.9459C197.244 67.0186 197.353 67.0405 197.448 67.0014C197.542 66.9622 197.604 66.8698 197.604 66.7672C197.605 66.6277 197.492 66.5143 197.352 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 66.5139C198.659 66.5135 198.566 66.5749 198.526 66.6695C198.487 66.7641 198.508 66.8732 198.581 66.9459C198.653 67.0186 198.762 67.0405 198.857 67.0014C198.952 66.9622 199.013 66.8698 199.013 66.7672C199.014 66.7002 198.987 66.6359 198.94 66.5884C198.893 66.5409 198.828 66.5141 198.761 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 66.5139C200.067 66.5135 199.974 66.5749 199.935 66.6695C199.895 66.7641 199.916 66.8732 199.989 66.9459C200.061 67.0186 200.17 67.0405 200.265 67.0014C200.36 66.9622 200.422 66.8698 200.422 66.7672C200.422 66.7002 200.395 66.6359 200.348 66.5884C200.301 66.5409 200.237 66.5141 200.17 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 66.5139C201.475 66.5134 201.383 66.5748 201.343 66.6694C201.303 66.764 201.325 66.8732 201.397 66.9459C201.469 67.0186 201.578 67.0405 201.673 67.0014C201.768 66.9622 201.83 66.8698 201.83 66.7672C201.83 66.6277 201.717 66.5143 201.578 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 66.5139C202.883 66.5135 202.791 66.5749 202.751 66.6695C202.711 66.7641 202.733 66.8732 202.805 66.9459C202.878 67.0186 202.987 67.0405 203.081 67.0014C203.176 66.9622 203.238 66.8698 203.238 66.7672C203.238 66.7002 203.212 66.6359 203.164 66.5884C203.117 66.5409 203.053 66.5141 202.986 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 66.5139C204.292 66.5135 204.199 66.5749 204.159 66.6695C204.12 66.7641 204.141 66.8732 204.213 66.9459C204.286 67.0186 204.395 67.0405 204.49 67.0014C204.584 66.9622 204.646 66.8698 204.646 66.7672C204.646 66.7002 204.62 66.6359 204.573 66.5884C204.525 66.5409 204.461 66.5141 204.394 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 66.5139C205.701 66.5135 205.608 66.5749 205.568 66.6695C205.529 66.7641 205.55 66.8732 205.623 66.9459C205.695 67.0186 205.804 67.0405 205.899 67.0014C205.994 66.9622 206.055 66.8698 206.055 66.7672C206.056 66.6277 205.943 66.5143 205.803 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 66.5139C207.109 66.5134 207.016 66.5748 206.977 66.6694C206.937 66.764 206.958 66.8732 207.031 66.9459C207.103 67.0186 207.212 67.0405 207.307 67.0014C207.402 66.9622 207.464 66.8698 207.464 66.7672C207.464 66.7002 207.437 66.6359 207.39 66.5884C207.343 66.5409 207.279 66.5141 207.212 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 66.5139C208.517 66.5135 208.424 66.5749 208.385 66.6695C208.345 66.7641 208.367 66.8732 208.439 66.9459C208.511 67.0186 208.62 67.0405 208.715 67.0014C208.81 66.9622 208.872 66.8698 208.872 66.7672C208.872 66.7002 208.846 66.6359 208.798 66.5884C208.751 66.5409 208.687 66.5141 208.62 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 66.5139C209.925 66.5135 209.833 66.5749 209.793 66.6695C209.753 66.7641 209.775 66.8732 209.847 66.9459C209.92 67.0186 210.029 67.0405 210.123 67.0014C210.218 66.9622 210.28 66.8698 210.28 66.7672C210.28 66.7002 210.254 66.6359 210.206 66.5884C210.159 66.5409 210.095 66.5141 210.028 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 66.5139C211.334 66.5134 211.241 66.5748 211.201 66.6694C211.162 66.764 211.183 66.8732 211.255 66.9459C211.328 67.0186 211.437 67.0405 211.532 67.0014C211.626 66.9622 211.688 66.8698 211.688 66.7672C211.689 66.6277 211.576 66.5143 211.436 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 66.5139C212.742 66.5135 212.649 66.5749 212.609 66.6695C212.57 66.7641 212.591 66.8732 212.664 66.9459C212.736 67.0186 212.845 67.0405 212.94 67.0014C213.035 66.9622 213.096 66.8698 213.096 66.7672C213.097 66.7002 213.07 66.6359 213.023 66.5884C212.976 66.5409 212.911 66.5141 212.844 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 66.5139C214.151 66.5135 214.058 66.5749 214.019 66.6695C213.979 66.7641 214 66.8732 214.073 66.9459C214.145 67.0186 214.254 67.0405 214.349 67.0014C214.444 66.9622 214.506 66.8698 214.506 66.7672C214.506 66.7002 214.479 66.6359 214.432 66.5884C214.385 66.5409 214.321 66.5141 214.254 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 66.5139C215.559 66.5135 215.466 66.5749 215.427 66.6695C215.387 66.7641 215.409 66.8732 215.481 66.9459C215.553 67.0186 215.662 67.0405 215.757 67.0014C215.852 66.9622 215.914 66.8698 215.914 66.7672C215.914 66.6277 215.801 66.5143 215.662 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 66.5139C216.967 66.5135 216.875 66.5749 216.835 66.6695C216.795 66.7641 216.817 66.8732 216.889 66.9459C216.962 67.0186 217.071 67.0405 217.165 67.0014C217.26 66.9622 217.322 66.8698 217.322 66.7672C217.322 66.7002 217.296 66.6359 217.248 66.5884C217.201 66.5409 217.137 66.5141 217.07 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 66.5139C218.377 66.5135 218.284 66.5749 218.244 66.6695C218.205 66.7641 218.226 66.8732 218.298 66.9459C218.371 67.0186 218.48 67.0405 218.575 67.0014C218.669 66.9622 218.731 66.8698 218.731 66.7672C218.732 66.6277 218.619 66.5143 218.479 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 66.5139C219.784 66.5135 219.691 66.5749 219.651 66.6695C219.612 66.7641 219.633 66.8732 219.706 66.9459C219.778 67.0186 219.887 67.0405 219.982 67.0014C220.077 66.9622 220.138 66.8698 220.138 66.7672C220.139 66.7002 220.112 66.6359 220.065 66.5884C220.018 66.5409 219.953 66.5141 219.886 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 66.5139C221.193 66.5134 221.1 66.5748 221.061 66.6694C221.021 66.764 221.042 66.8732 221.115 66.9459C221.187 67.0186 221.296 67.0405 221.391 67.0014C221.486 66.9622 221.548 66.8698 221.548 66.7672C221.548 66.6277 221.435 66.5143 221.296 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 66.5139C222.601 66.5134 222.508 66.5748 222.469 66.6694C222.429 66.764 222.451 66.8732 222.523 66.9459C222.595 67.0186 222.704 67.0405 222.799 67.0014C222.894 66.9622 222.956 66.8698 222.956 66.7672C222.956 66.6277 222.843 66.5143 222.704 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 66.5139C224.009 66.5135 223.917 66.5749 223.877 66.6695C223.837 66.7641 223.859 66.8732 223.931 66.9459C224.004 67.0186 224.113 67.0405 224.207 67.0014C224.302 66.9622 224.364 66.8698 224.364 66.7672C224.364 66.7002 224.338 66.6359 224.29 66.5884C224.243 66.5409 224.179 66.5141 224.112 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 66.5139C225.419 66.5135 225.326 66.5749 225.286 66.6695C225.247 66.7641 225.268 66.8732 225.34 66.9459C225.413 67.0186 225.522 67.0405 225.617 67.0014C225.711 66.9622 225.773 66.8698 225.773 66.7672C225.774 66.6277 225.661 66.5143 225.521 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 66.5139C226.827 66.5135 226.734 66.5749 226.694 66.6695C226.655 66.7641 226.676 66.8732 226.749 66.9459C226.821 67.0186 226.93 67.0405 227.025 67.0014C227.12 66.9622 227.181 66.8698 227.181 66.7672C227.182 66.6277 227.069 66.5143 226.929 66.5139Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 69.1945C197.25 69.194 197.157 69.2553 197.117 69.35C197.078 69.4446 197.099 69.5537 197.171 69.6264C197.244 69.6992 197.353 69.7211 197.448 69.6819C197.542 69.6428 197.604 69.5504 197.604 69.4478C197.605 69.3083 197.492 69.1948 197.352 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 69.1945C198.659 69.194 198.566 69.2554 198.526 69.35C198.487 69.4446 198.508 69.5538 198.581 69.6265C198.653 69.6992 198.762 69.7211 198.857 69.6819C198.952 69.6428 199.013 69.5503 199.013 69.4478C199.014 69.3808 198.987 69.3164 198.94 69.2689C198.893 69.2214 198.828 69.1946 198.761 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 69.1945C201.475 69.194 201.383 69.2553 201.343 69.35C201.303 69.4446 201.325 69.5537 201.397 69.6264C201.469 69.6992 201.578 69.7211 201.673 69.6819C201.768 69.6428 201.83 69.5504 201.83 69.4478C201.83 69.3083 201.717 69.1948 201.578 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 69.1945C207.109 69.194 207.016 69.2553 206.977 69.35C206.937 69.4446 206.958 69.5537 207.031 69.6264C207.103 69.6992 207.212 69.7211 207.307 69.6819C207.402 69.6428 207.464 69.5504 207.464 69.4478C207.464 69.3808 207.437 69.3164 207.39 69.2689C207.343 69.2214 207.279 69.1947 207.212 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 69.1945C208.517 69.194 208.424 69.2554 208.385 69.35C208.345 69.4446 208.367 69.5538 208.439 69.6265C208.511 69.6992 208.62 69.7211 208.715 69.6819C208.81 69.6428 208.872 69.5503 208.872 69.4478C208.872 69.3808 208.846 69.3164 208.798 69.2689C208.751 69.2214 208.687 69.1946 208.62 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 69.1945C211.334 69.194 211.241 69.2553 211.201 69.35C211.162 69.4446 211.183 69.5537 211.255 69.6264C211.328 69.6992 211.437 69.7211 211.532 69.6819C211.626 69.6428 211.688 69.5504 211.688 69.4478C211.689 69.3083 211.576 69.1948 211.436 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 69.1945C219.784 69.194 219.691 69.2554 219.651 69.35C219.612 69.4446 219.633 69.5538 219.706 69.6265C219.778 69.6992 219.887 69.7211 219.982 69.6819C220.077 69.6428 220.138 69.5503 220.138 69.4478C220.139 69.3808 220.112 69.3164 220.065 69.2689C220.018 69.2214 219.953 69.1946 219.886 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 69.1945C221.193 69.194 221.1 69.2553 221.061 69.35C221.021 69.4446 221.042 69.5537 221.115 69.6264C221.187 69.6992 221.296 69.7211 221.391 69.6819C221.486 69.6428 221.548 69.5504 221.548 69.4478C221.548 69.3083 221.435 69.1949 221.296 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 69.1945C222.601 69.194 222.508 69.2553 222.469 69.35C222.429 69.4446 222.451 69.5537 222.523 69.6264C222.595 69.6992 222.704 69.7211 222.799 69.6819C222.894 69.6428 222.956 69.5504 222.956 69.4478C222.956 69.3083 222.843 69.1949 222.704 69.1945Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 69.4478,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 65.1737C195.841 65.1732 195.749 65.2346 195.709 65.3292C195.67 65.4238 195.691 65.5329 195.763 65.6056C195.836 65.6783 195.945 65.7002 196.039 65.6611C196.134 65.622 196.196 65.5295 196.196 65.427C196.196 65.2874 196.084 65.174 195.944 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 65.1737C197.25 65.1732 197.157 65.2345 197.117 65.3291C197.078 65.4237 197.099 65.5329 197.171 65.6056C197.244 65.6783 197.353 65.7002 197.448 65.6611C197.542 65.622 197.604 65.5295 197.604 65.427C197.605 65.2874 197.492 65.174 197.352 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 65.1737C198.659 65.1732 198.566 65.2346 198.526 65.3292C198.487 65.4238 198.508 65.5329 198.581 65.6056C198.653 65.6783 198.762 65.7002 198.857 65.6611C198.952 65.622 199.013 65.5295 199.013 65.427C199.014 65.36 198.987 65.2956 198.94 65.2481C198.893 65.2006 198.828 65.1738 198.761 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 65.1737C200.067 65.1732 199.974 65.2346 199.935 65.3292C199.895 65.4238 199.916 65.5329 199.989 65.6056C200.061 65.6783 200.17 65.7002 200.265 65.6611C200.36 65.622 200.422 65.5295 200.422 65.427C200.422 65.36 200.395 65.2956 200.348 65.2481C200.301 65.2006 200.237 65.1738 200.17 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 65.1737C201.475 65.1732 201.383 65.2345 201.343 65.3291C201.303 65.4237 201.325 65.5329 201.397 65.6056C201.469 65.6783 201.578 65.7002 201.673 65.6611C201.768 65.622 201.83 65.5295 201.83 65.427C201.83 65.2874 201.717 65.174 201.578 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 65.1737C202.883 65.1732 202.791 65.2346 202.751 65.3292C202.711 65.4238 202.733 65.5329 202.805 65.6056C202.878 65.6783 202.987 65.7002 203.081 65.6611C203.176 65.622 203.238 65.5295 203.238 65.427C203.238 65.36 203.212 65.2956 203.164 65.2481C203.117 65.2006 203.053 65.1738 202.986 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 65.1737C204.292 65.1732 204.199 65.2346 204.159 65.3292C204.12 65.4238 204.141 65.5329 204.213 65.6056C204.286 65.6783 204.395 65.7002 204.49 65.6611C204.584 65.622 204.646 65.5295 204.646 65.427C204.646 65.36 204.62 65.2956 204.573 65.2481C204.525 65.2006 204.461 65.1738 204.394 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 65.1737C205.701 65.1732 205.608 65.2346 205.568 65.3292C205.529 65.4238 205.55 65.5329 205.623 65.6056C205.695 65.6783 205.804 65.7002 205.899 65.6611C205.994 65.622 206.055 65.5295 206.055 65.427C206.056 65.2874 205.943 65.174 205.803 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 65.1737C207.109 65.1732 207.016 65.2345 206.977 65.3291C206.937 65.4237 206.958 65.5329 207.031 65.6056C207.103 65.6783 207.212 65.7002 207.307 65.6611C207.402 65.622 207.464 65.5295 207.464 65.427C207.464 65.36 207.437 65.2956 207.39 65.2481C207.343 65.2006 207.279 65.1738 207.212 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 65.1737C208.517 65.1732 208.424 65.2346 208.385 65.3292C208.345 65.4238 208.367 65.5329 208.439 65.6056C208.511 65.6783 208.62 65.7002 208.715 65.6611C208.81 65.622 208.872 65.5295 208.872 65.427C208.872 65.36 208.846 65.2956 208.798 65.2481C208.751 65.2006 208.687 65.1738 208.62 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 65.1737C209.925 65.1732 209.833 65.2346 209.793 65.3292C209.753 65.4238 209.775 65.5329 209.847 65.6056C209.92 65.6783 210.029 65.7002 210.123 65.6611C210.218 65.622 210.28 65.5295 210.28 65.427C210.28 65.36 210.254 65.2956 210.206 65.2481C210.159 65.2006 210.095 65.1738 210.028 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 65.1737C211.334 65.1732 211.241 65.2345 211.201 65.3291C211.162 65.4237 211.183 65.5329 211.255 65.6056C211.328 65.6783 211.437 65.7002 211.532 65.6611C211.626 65.622 211.688 65.5295 211.688 65.427C211.689 65.2874 211.576 65.174 211.436 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 65.1737C212.742 65.1732 212.649 65.2346 212.609 65.3292C212.57 65.4238 212.591 65.5329 212.664 65.6056C212.736 65.6783 212.845 65.7002 212.94 65.6611C213.035 65.622 213.096 65.5295 213.096 65.427C213.097 65.36 213.07 65.2956 213.023 65.2481C212.976 65.2006 212.911 65.1738 212.844 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 65.1737C214.151 65.1732 214.058 65.2346 214.019 65.3292C213.979 65.4238 214 65.5329 214.073 65.6056C214.145 65.6783 214.254 65.7002 214.349 65.6611C214.444 65.622 214.506 65.5295 214.506 65.427C214.506 65.36 214.479 65.2956 214.432 65.2481C214.385 65.2006 214.321 65.1738 214.254 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 65.1737C215.559 65.1732 215.466 65.2346 215.427 65.3292C215.387 65.4238 215.409 65.5329 215.481 65.6056C215.553 65.6783 215.662 65.7002 215.757 65.6611C215.852 65.622 215.914 65.5295 215.914 65.427C215.914 65.2874 215.801 65.174 215.662 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 65.1737C216.967 65.1732 216.875 65.2346 216.835 65.3292C216.795 65.4238 216.817 65.5329 216.889 65.6056C216.962 65.6783 217.071 65.7002 217.165 65.6611C217.26 65.622 217.322 65.5295 217.322 65.427C217.322 65.36 217.296 65.2956 217.248 65.2481C217.201 65.2006 217.137 65.1738 217.07 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 65.1737C218.377 65.1732 218.284 65.2346 218.244 65.3292C218.205 65.4238 218.226 65.5329 218.298 65.6056C218.371 65.6783 218.48 65.7002 218.575 65.6611C218.669 65.622 218.731 65.5295 218.731 65.427C218.732 65.2874 218.619 65.174 218.479 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 65.1737C219.784 65.1732 219.691 65.2346 219.651 65.3292C219.612 65.4238 219.633 65.5329 219.706 65.6056C219.778 65.6783 219.887 65.7002 219.982 65.6611C220.077 65.622 220.138 65.5295 220.138 65.427C220.139 65.36 220.112 65.2956 220.065 65.2481C220.018 65.2006 219.953 65.1738 219.886 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 65.1737C221.193 65.1732 221.1 65.2345 221.061 65.3291C221.021 65.4237 221.042 65.5329 221.115 65.6056C221.187 65.6783 221.296 65.7002 221.391 65.6611C221.486 65.622 221.548 65.5295 221.548 65.427C221.548 65.2874 221.435 65.174 221.296 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 65.1737C222.601 65.1732 222.508 65.2345 222.469 65.3291C222.429 65.4237 222.451 65.5329 222.523 65.6056C222.595 65.6783 222.704 65.7002 222.799 65.6611C222.894 65.622 222.956 65.5295 222.956 65.427C222.956 65.2874 222.843 65.174 222.704 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 65.1737C224.009 65.1732 223.917 65.2346 223.877 65.3292C223.837 65.4238 223.859 65.5329 223.931 65.6056C224.004 65.6783 224.113 65.7002 224.207 65.6611C224.302 65.622 224.364 65.5295 224.364 65.427C224.364 65.36 224.338 65.2956 224.29 65.2481C224.243 65.2006 224.179 65.1738 224.112 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 65.1737C225.419 65.1732 225.326 65.2346 225.286 65.3292C225.247 65.4238 225.268 65.5329 225.34 65.6056C225.413 65.6783 225.522 65.7002 225.617 65.6611C225.711 65.622 225.773 65.5295 225.773 65.427C225.774 65.2874 225.661 65.174 225.521 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 65.1737C226.827 65.1732 226.734 65.2346 226.694 65.3292C226.655 65.4238 226.676 65.5329 226.749 65.6056C226.821 65.6783 226.93 65.7002 227.025 65.6611C227.12 65.622 227.181 65.5295 227.181 65.427C227.182 65.2874 227.069 65.174 226.929 65.1737Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 67.8542C197.25 67.8537 197.157 67.9151 197.117 68.0097C197.078 68.1043 197.099 68.2135 197.171 68.2862C197.244 68.3589 197.353 68.3808 197.448 68.3417C197.542 68.3025 197.604 68.2101 197.604 68.1075C197.605 67.968 197.492 67.8546 197.352 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 67.8542C198.659 67.8537 198.566 67.9151 198.526 68.0097C198.487 68.1043 198.508 68.2135 198.581 68.2862C198.653 68.3589 198.762 68.3808 198.857 68.3417C198.952 68.3025 199.013 68.2101 199.013 68.1075C199.014 68.0405 198.987 67.9762 198.94 67.9287C198.893 67.8812 198.828 67.8544 198.761 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 67.8542C201.475 67.8537 201.383 67.9151 201.343 68.0097C201.303 68.1043 201.325 68.2135 201.397 68.2862C201.469 68.3589 201.578 68.3808 201.673 68.3417C201.768 68.3025 201.83 68.2101 201.83 68.1075C201.83 67.968 201.717 67.8546 201.578 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 67.8542C207.109 67.8537 207.016 67.9151 206.977 68.0097C206.937 68.1043 206.958 68.2135 207.031 68.2862C207.103 68.3589 207.212 68.3808 207.307 68.3417C207.402 68.3025 207.464 68.2101 207.464 68.1075C207.464 68.0405 207.437 67.9762 207.39 67.9287C207.343 67.8812 207.279 67.8544 207.212 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 67.8542C208.517 67.8537 208.424 67.9151 208.385 68.0097C208.345 68.1043 208.367 68.2135 208.439 68.2862C208.511 68.3589 208.62 68.3808 208.715 68.3417C208.81 68.3025 208.872 68.2101 208.872 68.1075C208.872 68.0405 208.846 67.9762 208.798 67.9287C208.751 67.8812 208.687 67.8544 208.62 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 67.8542C211.334 67.8537 211.241 67.9151 211.201 68.0097C211.162 68.1043 211.183 68.2135 211.255 68.2862C211.328 68.3589 211.437 68.3808 211.532 68.3417C211.626 68.3025 211.688 68.2101 211.688 68.1075C211.689 67.968 211.576 67.8546 211.436 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 67.8542C219.784 67.8537 219.691 67.9151 219.651 68.0097C219.612 68.1043 219.633 68.2135 219.706 68.2862C219.778 68.3589 219.887 68.3808 219.982 68.3417C220.077 68.3025 220.138 68.2101 220.138 68.1075C220.139 68.0405 220.112 67.9762 220.065 67.9287C220.018 67.8812 219.953 67.8544 219.886 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 67.8542C221.193 67.8537 221.1 67.9151 221.061 68.0097C221.021 68.1043 221.042 68.2135 221.115 68.2862C221.187 68.3589 221.296 68.3808 221.391 68.3417C221.486 68.3025 221.548 68.2101 221.548 68.1075C221.548 67.968 221.435 67.8546 221.296 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 67.8542C222.601 67.8537 222.508 67.9151 222.469 68.0097C222.429 68.1043 222.451 68.2135 222.523 68.2862C222.595 68.3589 222.704 68.3808 222.799 68.3417C222.894 68.3025 222.956 68.2101 222.956 68.1075C222.956 67.968 222.843 67.8546 222.704 67.8542Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 68.1075,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 78.5764C195.841 78.5759 195.749 78.6373 195.709 78.7319C195.67 78.8265 195.691 78.9357 195.763 79.0084C195.836 79.0811 195.945 79.103 196.039 79.0638C196.134 79.0247 196.196 78.9323 196.196 78.8297C196.196 78.6902 196.084 78.5768 195.944 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 78.5764C197.25 78.5759 197.157 78.6373 197.117 78.7319C197.078 78.8265 197.099 78.9357 197.171 79.0084C197.244 79.0811 197.353 79.103 197.448 79.0638C197.542 79.0247 197.604 78.9323 197.604 78.8297C197.605 78.6902 197.492 78.5768 197.352 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 78.5764C198.659 78.5759 198.566 78.6373 198.526 78.7319C198.487 78.8265 198.508 78.9357 198.581 79.0084C198.653 79.0811 198.762 79.103 198.857 79.0638C198.952 79.0247 199.013 78.9323 199.013 78.8297C199.014 78.7627 198.987 78.6984 198.94 78.6509C198.893 78.6034 198.828 78.5766 198.761 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 78.5764C200.067 78.5759 199.974 78.6373 199.935 78.7319C199.895 78.8265 199.916 78.9357 199.989 79.0084C200.061 79.0811 200.17 79.103 200.265 79.0638C200.36 79.0247 200.422 78.9323 200.422 78.8297C200.422 78.7627 200.395 78.6984 200.348 78.6509C200.301 78.6034 200.237 78.5766 200.17 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 78.5764C201.475 78.5759 201.383 78.6373 201.343 78.7319C201.303 78.8265 201.325 78.9357 201.397 79.0084C201.469 79.0811 201.578 79.103 201.673 79.0638C201.768 79.0247 201.83 78.9323 201.83 78.8297C201.83 78.6902 201.717 78.5768 201.578 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 78.5764C202.883 78.5759 202.791 78.6373 202.751 78.7319C202.711 78.8265 202.733 78.9357 202.805 79.0084C202.878 79.0811 202.987 79.103 203.081 79.0638C203.176 79.0247 203.238 78.9323 203.238 78.8297C203.238 78.7627 203.212 78.6984 203.164 78.6509C203.117 78.6034 203.053 78.5766 202.986 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 78.5764C204.292 78.5759 204.199 78.6373 204.159 78.7319C204.12 78.8265 204.141 78.9357 204.213 79.0084C204.286 79.0811 204.395 79.103 204.49 79.0638C204.584 79.0247 204.646 78.9323 204.646 78.8297C204.646 78.7627 204.62 78.6984 204.573 78.6509C204.525 78.6034 204.461 78.5766 204.394 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 78.5764C205.701 78.5759 205.608 78.6373 205.568 78.7319C205.529 78.8265 205.55 78.9357 205.623 79.0084C205.695 79.0811 205.804 79.103 205.899 79.0638C205.994 79.0247 206.055 78.9323 206.055 78.8297C206.056 78.6902 205.943 78.5768 205.803 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 78.5764C207.109 78.5759 207.016 78.6373 206.977 78.7319C206.937 78.8265 206.958 78.9357 207.031 79.0084C207.103 79.0811 207.212 79.103 207.307 79.0638C207.402 79.0247 207.464 78.9323 207.464 78.8297C207.464 78.7627 207.437 78.6984 207.39 78.6509C207.343 78.6034 207.279 78.5766 207.212 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 78.5764C208.517 78.5759 208.424 78.6373 208.385 78.7319C208.345 78.8265 208.367 78.9357 208.439 79.0084C208.511 79.0811 208.62 79.103 208.715 79.0638C208.81 79.0247 208.872 78.9323 208.872 78.8297C208.872 78.7627 208.846 78.6984 208.798 78.6509C208.751 78.6034 208.687 78.5766 208.62 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 78.5764C209.925 78.5759 209.833 78.6373 209.793 78.7319C209.753 78.8265 209.775 78.9357 209.847 79.0084C209.92 79.0811 210.029 79.103 210.123 79.0638C210.218 79.0247 210.28 78.9323 210.28 78.8297C210.28 78.7627 210.254 78.6984 210.206 78.6509C210.159 78.6034 210.095 78.5766 210.028 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 78.5764C211.334 78.5759 211.241 78.6373 211.201 78.7319C211.162 78.8265 211.183 78.9357 211.255 79.0084C211.328 79.0811 211.437 79.103 211.532 79.0638C211.626 79.0247 211.688 78.9323 211.688 78.8297C211.689 78.6902 211.576 78.5768 211.436 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 78.5764C212.742 78.5759 212.649 78.6373 212.609 78.7319C212.57 78.8265 212.591 78.9357 212.664 79.0084C212.736 79.0811 212.845 79.103 212.94 79.0638C213.035 79.0247 213.096 78.9323 213.096 78.8297C213.097 78.7627 213.07 78.6984 213.023 78.6509C212.976 78.6034 212.911 78.5766 212.844 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 78.5764C214.151 78.5759 214.058 78.6373 214.019 78.7319C213.979 78.8265 214 78.9357 214.073 79.0084C214.145 79.0811 214.254 79.103 214.349 79.0638C214.444 79.0247 214.506 78.9323 214.506 78.8297C214.506 78.7627 214.479 78.6984 214.432 78.6509C214.385 78.6034 214.321 78.5766 214.254 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 78.5764C215.559 78.5759 215.466 78.6373 215.427 78.7319C215.387 78.8265 215.409 78.9357 215.481 79.0084C215.553 79.0811 215.662 79.103 215.757 79.0638C215.852 79.0247 215.914 78.9323 215.914 78.8297C215.914 78.6902 215.801 78.5768 215.662 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 78.5764C216.967 78.5759 216.875 78.6373 216.835 78.7319C216.795 78.8265 216.817 78.9357 216.889 79.0084C216.962 79.0811 217.071 79.103 217.165 79.0638C217.26 79.0247 217.322 78.9323 217.322 78.8297C217.322 78.7627 217.296 78.6984 217.248 78.6509C217.201 78.6034 217.137 78.5766 217.07 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 78.5764C218.377 78.5759 218.284 78.6373 218.244 78.7319C218.205 78.8265 218.226 78.9357 218.298 79.0084C218.371 79.0811 218.48 79.103 218.575 79.0638C218.669 79.0247 218.731 78.9323 218.731 78.8297C218.732 78.6902 218.619 78.5768 218.479 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 78.5764C219.784 78.5759 219.691 78.6373 219.651 78.7319C219.612 78.8265 219.633 78.9357 219.706 79.0084C219.778 79.0811 219.887 79.103 219.982 79.0638C220.077 79.0247 220.138 78.9323 220.138 78.8297C220.139 78.7627 220.112 78.6984 220.065 78.6509C220.018 78.6034 219.953 78.5766 219.886 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 78.5764C221.193 78.5759 221.1 78.6373 221.061 78.7319C221.021 78.8265 221.042 78.9357 221.115 79.0084C221.187 79.0811 221.296 79.103 221.391 79.0638C221.486 79.0247 221.548 78.9323 221.548 78.8297C221.548 78.6902 221.435 78.5768 221.296 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 78.5764C222.601 78.5759 222.508 78.6373 222.469 78.7319C222.429 78.8265 222.451 78.9357 222.523 79.0084C222.595 79.0811 222.704 79.103 222.799 79.0638C222.894 79.0247 222.956 78.9323 222.956 78.8297C222.956 78.6902 222.843 78.5768 222.704 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 78.5764C224.009 78.5759 223.917 78.6373 223.877 78.7319C223.837 78.8265 223.859 78.9357 223.931 79.0084C224.004 79.0811 224.113 79.103 224.207 79.0638C224.302 79.0247 224.364 78.9323 224.364 78.8297C224.364 78.7627 224.338 78.6984 224.29 78.6509C224.243 78.6034 224.179 78.5766 224.112 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 78.5764C225.419 78.5759 225.326 78.6373 225.286 78.7319C225.247 78.8265 225.268 78.9357 225.34 79.0084C225.413 79.0811 225.522 79.103 225.617 79.0638C225.711 79.0247 225.773 78.9323 225.773 78.8297C225.774 78.6902 225.661 78.5768 225.521 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 78.5764C226.827 78.5759 226.734 78.6373 226.694 78.7319C226.655 78.8265 226.676 78.9357 226.749 79.0084C226.821 79.0811 226.93 79.103 227.025 79.0638C227.12 79.0247 227.181 78.9323 227.181 78.8297C227.182 78.6902 227.069 78.5768 226.929 78.5764Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 100.021C195.841 100.02 195.749 100.082 195.709 100.176C195.67 100.271 195.691 100.38 195.763 100.453C195.836 100.526 195.945 100.547 196.039 100.508C196.134 100.469 196.196 100.377 196.196 100.274C196.196 100.135 196.084 100.021 195.944 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 100.021C197.25 100.02 197.157 100.082 197.117 100.176C197.078 100.271 197.099 100.38 197.171 100.453C197.244 100.526 197.353 100.547 197.448 100.508C197.542 100.469 197.604 100.377 197.604 100.274C197.605 100.135 197.492 100.021 197.352 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 100.021C198.659 100.02 198.566 100.082 198.526 100.176C198.487 100.271 198.508 100.38 198.581 100.453C198.653 100.526 198.762 100.547 198.857 100.508C198.952 100.469 199.013 100.377 199.013 100.274C199.014 100.207 198.987 100.143 198.94 100.095C198.893 100.048 198.828 100.021 198.761 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 100.021C200.067 100.02 199.974 100.082 199.935 100.176C199.895 100.271 199.916 100.38 199.989 100.453C200.061 100.526 200.17 100.547 200.265 100.508C200.36 100.469 200.422 100.377 200.422 100.274C200.422 100.207 200.395 100.143 200.348 100.095C200.301 100.048 200.237 100.021 200.17 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 100.021C201.475 100.02 201.383 100.082 201.343 100.176C201.303 100.271 201.325 100.38 201.397 100.453C201.469 100.526 201.578 100.547 201.673 100.508C201.768 100.469 201.83 100.377 201.83 100.274C201.83 100.135 201.717 100.021 201.578 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 100.021C202.883 100.02 202.791 100.082 202.751 100.176C202.711 100.271 202.733 100.38 202.805 100.453C202.878 100.526 202.987 100.547 203.081 100.508C203.176 100.469 203.238 100.377 203.238 100.274C203.238 100.207 203.212 100.143 203.164 100.095C203.117 100.048 203.053 100.021 202.986 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 100.021C204.292 100.02 204.199 100.082 204.159 100.176C204.12 100.271 204.141 100.38 204.213 100.453C204.286 100.526 204.395 100.547 204.49 100.508C204.584 100.469 204.646 100.377 204.646 100.274C204.646 100.207 204.62 100.143 204.573 100.095C204.525 100.048 204.461 100.021 204.394 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 100.021C205.701 100.02 205.608 100.082 205.568 100.176C205.529 100.271 205.55 100.38 205.623 100.453C205.695 100.526 205.804 100.547 205.899 100.508C205.994 100.469 206.055 100.377 206.055 100.274C206.056 100.135 205.943 100.021 205.803 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 100.021C207.109 100.02 207.016 100.082 206.977 100.176C206.937 100.271 206.958 100.38 207.031 100.453C207.103 100.526 207.212 100.547 207.307 100.508C207.402 100.469 207.464 100.377 207.464 100.274C207.464 100.207 207.437 100.143 207.39 100.095C207.343 100.048 207.279 100.021 207.212 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 100.021C208.517 100.02 208.424 100.082 208.385 100.176C208.345 100.271 208.367 100.38 208.439 100.453C208.511 100.526 208.62 100.547 208.715 100.508C208.81 100.469 208.872 100.377 208.872 100.274C208.872 100.207 208.846 100.143 208.798 100.095C208.751 100.048 208.687 100.021 208.62 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 100.021C209.925 100.02 209.833 100.082 209.793 100.176C209.753 100.271 209.775 100.38 209.847 100.453C209.92 100.526 210.029 100.547 210.123 100.508C210.218 100.469 210.28 100.377 210.28 100.274C210.28 100.207 210.254 100.143 210.206 100.095C210.159 100.048 210.095 100.021 210.028 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 100.021C211.334 100.02 211.241 100.082 211.201 100.176C211.162 100.271 211.183 100.38 211.255 100.453C211.328 100.526 211.437 100.547 211.532 100.508C211.626 100.469 211.688 100.377 211.688 100.274C211.689 100.135 211.576 100.021 211.436 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 100.021C212.742 100.02 212.649 100.082 212.609 100.176C212.57 100.271 212.591 100.38 212.664 100.453C212.736 100.526 212.845 100.547 212.94 100.508C213.035 100.469 213.096 100.377 213.096 100.274C213.097 100.207 213.07 100.143 213.023 100.095C212.976 100.048 212.911 100.021 212.844 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 100.021C214.151 100.02 214.058 100.082 214.019 100.176C213.979 100.271 214 100.38 214.073 100.453C214.145 100.526 214.254 100.547 214.349 100.508C214.444 100.469 214.506 100.377 214.506 100.274C214.506 100.207 214.479 100.143 214.432 100.095C214.385 100.048 214.321 100.021 214.254 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 100.021C215.559 100.02 215.466 100.082 215.427 100.176C215.387 100.271 215.409 100.38 215.481 100.453C215.553 100.526 215.662 100.547 215.757 100.508C215.852 100.469 215.914 100.377 215.914 100.274C215.914 100.135 215.801 100.021 215.662 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 100.021C216.967 100.02 216.875 100.082 216.835 100.176C216.795 100.271 216.817 100.38 216.889 100.453C216.962 100.526 217.071 100.547 217.165 100.508C217.26 100.469 217.322 100.377 217.322 100.274C217.322 100.207 217.296 100.143 217.248 100.095C217.201 100.048 217.137 100.021 217.07 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 100.021C218.377 100.02 218.284 100.082 218.244 100.176C218.205 100.271 218.226 100.38 218.298 100.453C218.371 100.526 218.48 100.547 218.575 100.508C218.669 100.469 218.731 100.377 218.731 100.274C218.732 100.135 218.619 100.021 218.479 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 100.021C219.784 100.02 219.691 100.082 219.651 100.176C219.612 100.271 219.633 100.38 219.706 100.453C219.778 100.526 219.887 100.547 219.982 100.508C220.077 100.469 220.138 100.377 220.138 100.274C220.139 100.207 220.112 100.143 220.065 100.095C220.018 100.048 219.953 100.021 219.886 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 100.021C221.193 100.02 221.1 100.082 221.061 100.176C221.021 100.271 221.042 100.38 221.115 100.453C221.187 100.526 221.296 100.547 221.391 100.508C221.486 100.469 221.548 100.377 221.548 100.274C221.548 100.135 221.435 100.021 221.296 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 100.021C222.601 100.02 222.508 100.082 222.469 100.176C222.429 100.271 222.451 100.38 222.523 100.453C222.595 100.526 222.704 100.547 222.799 100.508C222.894 100.469 222.956 100.377 222.956 100.274C222.956 100.135 222.843 100.021 222.704 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 100.021C224.009 100.02 223.917 100.082 223.877 100.176C223.837 100.271 223.859 100.38 223.931 100.453C224.004 100.526 224.113 100.547 224.207 100.508C224.302 100.469 224.364 100.377 224.364 100.274C224.364 100.207 224.338 100.143 224.29 100.095C224.243 100.048 224.179 100.021 224.112 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 100.021C225.419 100.02 225.326 100.082 225.286 100.176C225.247 100.271 225.268 100.38 225.34 100.453C225.413 100.526 225.522 100.547 225.617 100.508C225.711 100.469 225.773 100.377 225.773 100.274C225.774 100.135 225.661 100.021 225.521 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 100.021C226.827 100.02 226.734 100.082 226.694 100.176C226.655 100.271 226.676 100.38 226.749 100.453C226.821 100.526 226.93 100.547 227.025 100.508C227.12 100.469 227.181 100.377 227.181 100.274C227.182 100.135 227.069 100.021 226.929 100.021Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 102.701C197.25 102.701 197.157 102.762 197.117 102.857C197.078 102.952 197.099 103.061 197.171 103.133C197.244 103.206 197.353 103.228 197.448 103.189C197.542 103.15 197.604 103.057 197.604 102.955C197.605 102.815 197.492 102.702 197.352 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 102.701C198.659 102.701 198.566 102.762 198.526 102.857C198.487 102.952 198.508 103.061 198.581 103.133C198.653 103.206 198.762 103.228 198.857 103.189C198.952 103.15 199.013 103.057 199.013 102.955C199.014 102.888 198.987 102.823 198.94 102.776C198.893 102.728 198.828 102.702 198.761 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 102.701C201.475 102.701 201.383 102.762 201.343 102.857C201.303 102.952 201.325 103.061 201.397 103.133C201.469 103.206 201.578 103.228 201.673 103.189C201.768 103.15 201.83 103.057 201.83 102.955C201.83 102.815 201.717 102.702 201.578 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 102.701C207.109 102.701 207.016 102.762 206.977 102.857C206.937 102.952 206.958 103.061 207.031 103.133C207.103 103.206 207.212 103.228 207.307 103.189C207.402 103.15 207.464 103.057 207.464 102.955C207.464 102.888 207.437 102.823 207.39 102.776C207.343 102.728 207.279 102.702 207.212 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 102.701C208.517 102.701 208.424 102.762 208.385 102.857C208.345 102.952 208.367 103.061 208.439 103.133C208.511 103.206 208.62 103.228 208.715 103.189C208.81 103.15 208.872 103.057 208.872 102.955C208.872 102.888 208.846 102.823 208.798 102.776C208.751 102.728 208.687 102.702 208.62 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 102.701C211.334 102.701 211.241 102.762 211.201 102.857C211.162 102.952 211.183 103.061 211.255 103.133C211.328 103.206 211.437 103.228 211.532 103.189C211.626 103.15 211.688 103.057 211.688 102.955C211.689 102.815 211.576 102.702 211.436 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 102.701C219.784 102.701 219.691 102.762 219.651 102.857C219.612 102.952 219.633 103.061 219.706 103.133C219.778 103.206 219.887 103.228 219.982 103.189C220.077 103.15 220.138 103.057 220.138 102.955C220.139 102.888 220.112 102.823 220.065 102.776C220.018 102.728 219.953 102.702 219.886 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 102.701C221.193 102.701 221.1 102.762 221.061 102.857C221.021 102.952 221.042 103.061 221.115 103.133C221.187 103.206 221.296 103.228 221.391 103.189C221.486 103.15 221.548 103.057 221.548 102.955C221.548 102.815 221.435 102.702 221.296 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 102.701C222.601 102.701 222.508 102.762 222.469 102.857C222.429 102.952 222.451 103.061 222.523 103.133C222.595 103.206 222.704 103.228 222.799 103.189C222.894 103.15 222.956 103.057 222.956 102.955C222.956 102.815 222.843 102.702 222.704 102.701Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 102.955,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 101.361C195.841 101.361 195.749 101.422 195.709 101.517C195.67 101.611 195.691 101.72 195.763 101.793C195.836 101.866 195.945 101.888 196.039 101.849C196.134 101.809 196.196 101.717 196.196 101.614C196.196 101.475 196.084 101.362 195.944 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 101.361C197.25 101.361 197.157 101.422 197.117 101.517C197.078 101.611 197.099 101.72 197.171 101.793C197.244 101.866 197.353 101.888 197.448 101.849C197.542 101.809 197.604 101.717 197.604 101.614C197.605 101.475 197.492 101.362 197.352 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 101.361C198.659 101.361 198.566 101.422 198.526 101.517C198.487 101.611 198.508 101.72 198.581 101.793C198.653 101.866 198.762 101.888 198.857 101.849C198.952 101.809 199.013 101.717 199.013 101.614C199.014 101.547 198.987 101.483 198.94 101.436C198.893 101.388 198.828 101.361 198.761 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 101.361C200.067 101.361 199.974 101.422 199.935 101.517C199.895 101.611 199.916 101.72 199.989 101.793C200.061 101.866 200.17 101.888 200.265 101.849C200.36 101.809 200.422 101.717 200.422 101.614C200.422 101.547 200.395 101.483 200.348 101.436C200.301 101.388 200.237 101.361 200.17 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 101.361C201.475 101.361 201.383 101.422 201.343 101.517C201.303 101.611 201.325 101.72 201.397 101.793C201.469 101.866 201.578 101.888 201.673 101.849C201.768 101.809 201.83 101.717 201.83 101.614C201.83 101.475 201.717 101.362 201.578 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 101.361C202.883 101.361 202.791 101.422 202.751 101.517C202.711 101.611 202.733 101.72 202.805 101.793C202.878 101.866 202.987 101.888 203.081 101.849C203.176 101.809 203.238 101.717 203.238 101.614C203.238 101.547 203.212 101.483 203.164 101.436C203.117 101.388 203.053 101.361 202.986 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 101.361C204.292 101.361 204.199 101.422 204.159 101.517C204.12 101.611 204.141 101.72 204.213 101.793C204.286 101.866 204.395 101.888 204.49 101.849C204.584 101.809 204.646 101.717 204.646 101.614C204.646 101.547 204.62 101.483 204.573 101.436C204.525 101.388 204.461 101.361 204.394 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 101.361C205.701 101.361 205.608 101.422 205.568 101.517C205.529 101.611 205.55 101.72 205.623 101.793C205.695 101.866 205.804 101.888 205.899 101.849C205.994 101.809 206.055 101.717 206.055 101.614C206.056 101.475 205.943 101.362 205.803 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 101.361C207.109 101.361 207.016 101.422 206.977 101.517C206.937 101.611 206.958 101.72 207.031 101.793C207.103 101.866 207.212 101.888 207.307 101.849C207.402 101.809 207.464 101.717 207.464 101.614C207.464 101.547 207.437 101.483 207.39 101.436C207.343 101.388 207.279 101.361 207.212 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 101.361C208.517 101.361 208.424 101.422 208.385 101.517C208.345 101.611 208.367 101.72 208.439 101.793C208.511 101.866 208.62 101.888 208.715 101.849C208.81 101.809 208.872 101.717 208.872 101.614C208.872 101.547 208.846 101.483 208.798 101.436C208.751 101.388 208.687 101.361 208.62 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 101.361C209.925 101.361 209.833 101.422 209.793 101.517C209.753 101.611 209.775 101.72 209.847 101.793C209.92 101.866 210.029 101.888 210.123 101.849C210.218 101.809 210.28 101.717 210.28 101.614C210.28 101.547 210.254 101.483 210.206 101.436C210.159 101.388 210.095 101.361 210.028 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 101.361C211.334 101.361 211.241 101.422 211.201 101.517C211.162 101.611 211.183 101.72 211.255 101.793C211.328 101.866 211.437 101.888 211.532 101.849C211.626 101.809 211.688 101.717 211.688 101.614C211.689 101.475 211.576 101.362 211.436 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 101.361C212.742 101.361 212.649 101.422 212.609 101.517C212.57 101.611 212.591 101.72 212.664 101.793C212.736 101.866 212.845 101.888 212.94 101.849C213.035 101.809 213.096 101.717 213.096 101.614C213.097 101.547 213.07 101.483 213.023 101.436C212.976 101.388 212.911 101.361 212.844 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 101.361C214.151 101.361 214.058 101.422 214.019 101.517C213.979 101.611 214 101.72 214.073 101.793C214.145 101.866 214.254 101.888 214.349 101.849C214.444 101.809 214.506 101.717 214.506 101.614C214.506 101.547 214.479 101.483 214.432 101.436C214.385 101.388 214.321 101.361 214.254 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 101.361C215.559 101.361 215.466 101.422 215.427 101.517C215.387 101.611 215.409 101.72 215.481 101.793C215.553 101.866 215.662 101.888 215.757 101.849C215.852 101.809 215.914 101.717 215.914 101.614C215.914 101.475 215.801 101.362 215.662 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 101.361C216.967 101.361 216.875 101.422 216.835 101.517C216.795 101.611 216.817 101.72 216.889 101.793C216.962 101.866 217.071 101.888 217.165 101.849C217.26 101.809 217.322 101.717 217.322 101.614C217.322 101.547 217.296 101.483 217.248 101.436C217.201 101.388 217.137 101.361 217.07 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 101.361C218.377 101.361 218.284 101.422 218.244 101.517C218.205 101.611 218.226 101.72 218.298 101.793C218.371 101.866 218.48 101.888 218.575 101.849C218.669 101.809 218.731 101.717 218.731 101.614C218.732 101.475 218.619 101.362 218.479 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 101.361C219.784 101.361 219.691 101.422 219.651 101.517C219.612 101.611 219.633 101.72 219.706 101.793C219.778 101.866 219.887 101.888 219.982 101.849C220.077 101.809 220.138 101.717 220.138 101.614C220.139 101.547 220.112 101.483 220.065 101.436C220.018 101.388 219.953 101.361 219.886 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 101.361C221.193 101.361 221.1 101.422 221.061 101.517C221.021 101.611 221.042 101.72 221.115 101.793C221.187 101.866 221.296 101.888 221.391 101.849C221.486 101.809 221.548 101.717 221.548 101.614C221.548 101.475 221.435 101.362 221.296 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 101.361C222.601 101.361 222.508 101.422 222.469 101.517C222.429 101.611 222.451 101.72 222.523 101.793C222.595 101.866 222.704 101.888 222.799 101.849C222.894 101.809 222.956 101.717 222.956 101.614C222.956 101.475 222.843 101.362 222.704 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 101.361C224.009 101.361 223.917 101.422 223.877 101.517C223.837 101.611 223.859 101.72 223.931 101.793C224.004 101.866 224.113 101.888 224.207 101.849C224.302 101.809 224.364 101.717 224.364 101.614C224.364 101.547 224.338 101.483 224.29 101.436C224.243 101.388 224.179 101.361 224.112 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 101.361C225.419 101.361 225.326 101.422 225.286 101.517C225.247 101.611 225.268 101.72 225.34 101.793C225.413 101.866 225.522 101.888 225.617 101.849C225.711 101.809 225.773 101.717 225.773 101.614C225.774 101.475 225.661 101.362 225.521 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 101.361C226.827 101.361 226.734 101.422 226.694 101.517C226.655 101.611 226.676 101.72 226.749 101.793C226.821 101.866 226.93 101.888 227.025 101.849C227.12 101.809 227.181 101.717 227.181 101.614C227.182 101.475 227.069 101.362 226.929 101.361Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 105.382C195.841 105.382 195.749 105.443 195.709 105.538C195.67 105.632 195.691 105.741 195.763 105.814C195.836 105.887 195.945 105.909 196.039 105.869C196.134 105.83 196.196 105.738 196.196 105.635C196.196 105.496 196.084 105.382 195.944 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 105.382C197.25 105.382 197.157 105.443 197.117 105.538C197.078 105.632 197.099 105.741 197.171 105.814C197.244 105.887 197.353 105.909 197.448 105.869C197.542 105.83 197.604 105.738 197.604 105.635C197.605 105.496 197.492 105.382 197.352 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 105.382C198.659 105.382 198.566 105.443 198.526 105.538C198.487 105.632 198.508 105.741 198.581 105.814C198.653 105.887 198.762 105.909 198.857 105.869C198.952 105.83 199.013 105.738 199.013 105.635C199.014 105.568 198.987 105.504 198.94 105.456C198.893 105.409 198.828 105.382 198.761 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 105.382C200.067 105.382 199.974 105.443 199.935 105.538C199.895 105.632 199.916 105.741 199.989 105.814C200.061 105.887 200.17 105.909 200.265 105.869C200.36 105.83 200.422 105.738 200.422 105.635C200.422 105.568 200.395 105.504 200.348 105.456C200.301 105.409 200.237 105.382 200.17 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 105.382C201.475 105.382 201.383 105.443 201.343 105.538C201.303 105.632 201.325 105.741 201.397 105.814C201.469 105.887 201.578 105.909 201.673 105.869C201.768 105.83 201.83 105.738 201.83 105.635C201.83 105.496 201.717 105.382 201.578 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 105.382C202.883 105.382 202.791 105.443 202.751 105.538C202.711 105.632 202.733 105.741 202.805 105.814C202.878 105.887 202.987 105.909 203.081 105.869C203.176 105.83 203.238 105.738 203.238 105.635C203.238 105.568 203.212 105.504 203.164 105.456C203.117 105.409 203.053 105.382 202.986 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 105.382C204.292 105.382 204.199 105.443 204.159 105.538C204.12 105.632 204.141 105.741 204.213 105.814C204.286 105.887 204.395 105.909 204.49 105.869C204.584 105.83 204.646 105.738 204.646 105.635C204.646 105.568 204.62 105.504 204.573 105.456C204.525 105.409 204.461 105.382 204.394 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 105.382C205.701 105.382 205.608 105.443 205.568 105.538C205.529 105.632 205.55 105.741 205.623 105.814C205.695 105.887 205.804 105.909 205.899 105.869C205.994 105.83 206.055 105.738 206.055 105.635C206.056 105.496 205.943 105.382 205.803 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 105.382C207.109 105.382 207.016 105.443 206.977 105.538C206.937 105.632 206.958 105.741 207.031 105.814C207.103 105.887 207.212 105.909 207.307 105.869C207.402 105.83 207.464 105.738 207.464 105.635C207.464 105.568 207.437 105.504 207.39 105.456C207.343 105.409 207.279 105.382 207.212 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 105.382C208.517 105.382 208.424 105.443 208.385 105.538C208.345 105.632 208.367 105.741 208.439 105.814C208.511 105.887 208.62 105.909 208.715 105.869C208.81 105.83 208.872 105.738 208.872 105.635C208.872 105.568 208.846 105.504 208.798 105.456C208.751 105.409 208.687 105.382 208.62 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 105.382C209.925 105.382 209.833 105.443 209.793 105.538C209.753 105.632 209.775 105.741 209.847 105.814C209.92 105.887 210.029 105.909 210.123 105.869C210.218 105.83 210.28 105.738 210.28 105.635C210.28 105.568 210.254 105.504 210.206 105.456C210.159 105.409 210.095 105.382 210.028 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 105.382C211.334 105.382 211.241 105.443 211.201 105.538C211.162 105.632 211.183 105.741 211.255 105.814C211.328 105.887 211.437 105.909 211.532 105.869C211.626 105.83 211.688 105.738 211.688 105.635C211.689 105.496 211.576 105.382 211.436 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 105.382C212.742 105.382 212.649 105.443 212.609 105.538C212.57 105.632 212.591 105.741 212.664 105.814C212.736 105.887 212.845 105.909 212.94 105.869C213.035 105.83 213.096 105.738 213.096 105.635C213.097 105.568 213.07 105.504 213.023 105.456C212.976 105.409 212.911 105.382 212.844 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 105.382C214.151 105.382 214.058 105.443 214.019 105.538C213.979 105.632 214 105.741 214.073 105.814C214.145 105.887 214.254 105.909 214.349 105.869C214.444 105.83 214.506 105.738 214.506 105.635C214.506 105.568 214.479 105.504 214.432 105.456C214.385 105.409 214.321 105.382 214.254 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 105.382C215.559 105.382 215.466 105.443 215.427 105.538C215.387 105.632 215.409 105.741 215.481 105.814C215.553 105.887 215.662 105.909 215.757 105.869C215.852 105.83 215.914 105.738 215.914 105.635C215.914 105.496 215.801 105.382 215.662 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 105.382C216.967 105.382 216.875 105.443 216.835 105.538C216.795 105.632 216.817 105.741 216.889 105.814C216.962 105.887 217.071 105.909 217.165 105.869C217.26 105.83 217.322 105.738 217.322 105.635C217.322 105.568 217.296 105.504 217.248 105.456C217.201 105.409 217.137 105.382 217.07 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 105.382C218.377 105.382 218.284 105.443 218.244 105.538C218.205 105.632 218.226 105.741 218.298 105.814C218.371 105.887 218.48 105.909 218.575 105.869C218.669 105.83 218.731 105.738 218.731 105.635C218.732 105.496 218.619 105.382 218.479 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 105.382C219.784 105.382 219.691 105.443 219.651 105.538C219.612 105.632 219.633 105.741 219.706 105.814C219.778 105.887 219.887 105.909 219.982 105.869C220.077 105.83 220.138 105.738 220.138 105.635C220.139 105.568 220.112 105.504 220.065 105.456C220.018 105.409 219.953 105.382 219.886 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 105.382C221.193 105.382 221.1 105.443 221.061 105.538C221.021 105.632 221.042 105.741 221.115 105.814C221.187 105.887 221.296 105.909 221.391 105.869C221.486 105.83 221.548 105.738 221.548 105.635C221.548 105.496 221.435 105.382 221.296 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 105.382C222.601 105.382 222.508 105.443 222.469 105.538C222.429 105.632 222.451 105.741 222.523 105.814C222.595 105.887 222.704 105.909 222.799 105.869C222.894 105.83 222.956 105.738 222.956 105.635C222.956 105.496 222.843 105.382 222.704 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 105.382C224.009 105.382 223.917 105.443 223.877 105.538C223.837 105.632 223.859 105.741 223.931 105.814C224.004 105.887 224.113 105.909 224.207 105.869C224.302 105.83 224.364 105.738 224.364 105.635C224.364 105.496 224.251 105.382 224.112 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 105.382C225.419 105.382 225.326 105.443 225.286 105.538C225.247 105.632 225.268 105.741 225.34 105.814C225.413 105.887 225.522 105.909 225.617 105.869C225.711 105.83 225.773 105.738 225.773 105.635C225.773 105.496 225.661 105.382 225.521 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 105.382C226.827 105.382 226.734 105.443 226.694 105.538C226.655 105.632 226.676 105.741 226.749 105.814C226.821 105.887 226.93 105.909 227.025 105.869C227.12 105.83 227.181 105.738 227.181 105.635C227.182 105.496 227.069 105.382 226.929 105.382Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 97.3404C197.25 97.3399 197.157 97.4013 197.117 97.4959C197.078 97.5905 197.099 97.6996 197.171 97.7723C197.244 97.845 197.353 97.8669 197.448 97.8278C197.542 97.7886 197.604 97.6962 197.604 97.5937C197.605 97.4541 197.492 97.3407 197.352 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 97.3404C198.659 97.3399 198.566 97.4013 198.526 97.4959C198.487 97.5905 198.508 97.6996 198.581 97.7723C198.653 97.845 198.762 97.8669 198.857 97.8278C198.952 97.7886 199.013 97.6962 199.013 97.5937C199.014 97.5266 198.987 97.4623 198.94 97.4148C198.893 97.3673 198.828 97.3405 198.761 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 97.3404C201.475 97.3399 201.382 97.4013 201.343 97.4959C201.303 97.5905 201.325 97.6996 201.397 97.7723C201.469 97.845 201.578 97.8669 201.673 97.8278C201.768 97.7886 201.83 97.6962 201.83 97.5937C201.83 97.4541 201.717 97.3407 201.578 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 97.3404C207.109 97.3399 207.016 97.4013 206.977 97.4959C206.937 97.5905 206.958 97.6996 207.031 97.7723C207.103 97.845 207.212 97.8669 207.307 97.8278C207.402 97.7886 207.464 97.6962 207.464 97.5937C207.464 97.5266 207.437 97.4623 207.39 97.4148C207.343 97.3673 207.279 97.3405 207.212 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 97.3404C208.517 97.3399 208.424 97.4013 208.385 97.4959C208.345 97.5905 208.367 97.6996 208.439 97.7723C208.511 97.845 208.62 97.8669 208.715 97.8278C208.81 97.7886 208.872 97.6962 208.872 97.5937C208.872 97.5266 208.845 97.4623 208.798 97.4148C208.751 97.3673 208.687 97.3405 208.62 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 97.3404C211.334 97.3399 211.241 97.4013 211.201 97.4959C211.162 97.5905 211.183 97.6996 211.255 97.7723C211.328 97.845 211.437 97.8669 211.532 97.8278C211.626 97.7886 211.688 97.6962 211.688 97.5937C211.689 97.4541 211.576 97.3407 211.436 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 97.3404C219.784 97.3399 219.691 97.4013 219.651 97.4959C219.612 97.5905 219.633 97.6996 219.706 97.7723C219.778 97.845 219.887 97.8669 219.982 97.8278C220.077 97.7886 220.138 97.6962 220.138 97.5937C220.139 97.5266 220.112 97.4623 220.065 97.4148C220.018 97.3673 219.953 97.3405 219.886 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 97.3404C221.193 97.3399 221.1 97.4013 221.061 97.4959C221.021 97.5905 221.042 97.6996 221.115 97.7723C221.187 97.845 221.296 97.8669 221.391 97.8278C221.486 97.7886 221.548 97.6962 221.548 97.5937C221.548 97.4541 221.435 97.3407 221.296 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 97.3404C222.601 97.3399 222.508 97.4013 222.469 97.4959C222.429 97.5905 222.451 97.6996 222.523 97.7723C222.595 97.845 222.704 97.8669 222.799 97.8278C222.894 97.7886 222.956 97.6962 222.956 97.5937C222.956 97.4541 222.843 97.3407 222.704 97.3404Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 97.5937,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 104.042C195.841 104.041 195.749 104.103 195.709 104.197C195.67 104.292 195.691 104.401 195.763 104.474C195.836 104.546 195.945 104.568 196.039 104.529C196.134 104.49 196.196 104.398 196.196 104.295C196.196 104.156 196.084 104.042 195.944 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 104.042C197.25 104.041 197.157 104.103 197.117 104.197C197.078 104.292 197.099 104.401 197.171 104.474C197.244 104.546 197.353 104.568 197.448 104.529C197.542 104.49 197.604 104.398 197.604 104.295C197.605 104.156 197.492 104.042 197.352 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 104.042C198.659 104.041 198.566 104.103 198.526 104.197C198.487 104.292 198.508 104.401 198.581 104.474C198.653 104.546 198.762 104.568 198.857 104.529C198.952 104.49 199.013 104.398 199.013 104.295C199.014 104.228 198.987 104.164 198.94 104.116C198.893 104.069 198.828 104.042 198.761 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 104.042C200.067 104.041 199.974 104.103 199.935 104.197C199.895 104.292 199.916 104.401 199.989 104.474C200.061 104.546 200.17 104.568 200.265 104.529C200.36 104.49 200.422 104.398 200.422 104.295C200.422 104.228 200.395 104.164 200.348 104.116C200.301 104.069 200.237 104.042 200.17 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 104.042C201.475 104.041 201.383 104.103 201.343 104.197C201.303 104.292 201.325 104.401 201.397 104.474C201.469 104.546 201.578 104.568 201.673 104.529C201.768 104.49 201.83 104.398 201.83 104.295C201.83 104.156 201.717 104.042 201.578 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 104.042C202.883 104.041 202.791 104.103 202.751 104.197C202.711 104.292 202.733 104.401 202.805 104.474C202.878 104.546 202.987 104.568 203.081 104.529C203.176 104.49 203.238 104.398 203.238 104.295C203.238 104.228 203.212 104.164 203.164 104.116C203.117 104.069 203.053 104.042 202.986 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 104.042C204.292 104.041 204.199 104.103 204.159 104.197C204.12 104.292 204.141 104.401 204.213 104.474C204.286 104.546 204.395 104.568 204.49 104.529C204.584 104.49 204.646 104.398 204.646 104.295C204.646 104.228 204.62 104.164 204.573 104.116C204.525 104.069 204.461 104.042 204.394 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 104.042C205.701 104.041 205.608 104.103 205.568 104.197C205.529 104.292 205.55 104.401 205.623 104.474C205.695 104.546 205.804 104.568 205.899 104.529C205.994 104.49 206.055 104.398 206.055 104.295C206.056 104.156 205.943 104.042 205.803 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 104.042C207.109 104.041 207.016 104.103 206.977 104.197C206.937 104.292 206.958 104.401 207.031 104.474C207.103 104.546 207.212 104.568 207.307 104.529C207.402 104.49 207.464 104.398 207.464 104.295C207.464 104.228 207.437 104.164 207.39 104.116C207.343 104.069 207.279 104.042 207.212 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 104.042C208.517 104.041 208.424 104.103 208.385 104.197C208.345 104.292 208.367 104.401 208.439 104.474C208.511 104.546 208.62 104.568 208.715 104.529C208.81 104.49 208.872 104.398 208.872 104.295C208.872 104.228 208.846 104.164 208.798 104.116C208.751 104.069 208.687 104.042 208.62 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 104.042C209.925 104.041 209.833 104.103 209.793 104.197C209.753 104.292 209.775 104.401 209.847 104.474C209.92 104.546 210.029 104.568 210.123 104.529C210.218 104.49 210.28 104.398 210.28 104.295C210.28 104.228 210.254 104.164 210.206 104.116C210.159 104.069 210.095 104.042 210.028 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 104.042C211.334 104.041 211.241 104.103 211.201 104.197C211.162 104.292 211.183 104.401 211.255 104.474C211.328 104.546 211.437 104.568 211.532 104.529C211.626 104.49 211.688 104.398 211.688 104.295C211.689 104.156 211.576 104.042 211.436 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 104.042C212.742 104.041 212.649 104.103 212.609 104.197C212.57 104.292 212.591 104.401 212.664 104.474C212.736 104.546 212.845 104.568 212.94 104.529C213.035 104.49 213.096 104.398 213.096 104.295C213.097 104.228 213.07 104.164 213.023 104.116C212.976 104.069 212.911 104.042 212.844 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 104.042C214.151 104.041 214.058 104.103 214.019 104.197C213.979 104.292 214 104.401 214.073 104.474C214.145 104.546 214.254 104.568 214.349 104.529C214.444 104.49 214.506 104.398 214.506 104.295C214.506 104.228 214.479 104.164 214.432 104.116C214.385 104.069 214.321 104.042 214.254 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 104.042C215.559 104.041 215.466 104.103 215.427 104.197C215.387 104.292 215.409 104.401 215.481 104.474C215.553 104.546 215.662 104.568 215.757 104.529C215.852 104.49 215.914 104.398 215.914 104.295C215.914 104.156 215.801 104.042 215.662 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 104.042C216.967 104.041 216.875 104.103 216.835 104.197C216.795 104.292 216.817 104.401 216.889 104.474C216.962 104.546 217.071 104.568 217.165 104.529C217.26 104.49 217.322 104.398 217.322 104.295C217.322 104.228 217.296 104.164 217.248 104.116C217.201 104.069 217.137 104.042 217.07 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 104.042C218.377 104.041 218.284 104.103 218.244 104.197C218.205 104.292 218.226 104.401 218.298 104.474C218.371 104.546 218.48 104.568 218.575 104.529C218.669 104.49 218.731 104.398 218.731 104.295C218.732 104.156 218.619 104.042 218.479 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 104.042C219.784 104.041 219.691 104.103 219.651 104.197C219.612 104.292 219.633 104.401 219.706 104.474C219.778 104.546 219.887 104.568 219.982 104.529C220.077 104.49 220.138 104.398 220.138 104.295C220.139 104.228 220.112 104.164 220.065 104.116C220.018 104.069 219.953 104.042 219.886 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 104.042C221.193 104.041 221.1 104.103 221.061 104.197C221.021 104.292 221.042 104.401 221.115 104.474C221.187 104.546 221.296 104.568 221.391 104.529C221.486 104.49 221.548 104.398 221.548 104.295C221.548 104.156 221.435 104.042 221.296 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 104.042C222.601 104.041 222.508 104.103 222.469 104.197C222.429 104.292 222.451 104.401 222.523 104.474C222.595 104.546 222.704 104.568 222.799 104.529C222.894 104.49 222.956 104.398 222.956 104.295C222.956 104.156 222.843 104.042 222.704 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 104.042C224.009 104.041 223.917 104.103 223.877 104.197C223.837 104.292 223.859 104.401 223.931 104.474C224.004 104.546 224.113 104.568 224.207 104.529C224.302 104.49 224.364 104.398 224.364 104.295C224.364 104.228 224.338 104.164 224.29 104.116C224.243 104.069 224.179 104.042 224.112 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 104.042C225.419 104.041 225.326 104.103 225.286 104.197C225.247 104.292 225.268 104.401 225.34 104.474C225.413 104.546 225.522 104.568 225.617 104.529C225.711 104.49 225.773 104.398 225.773 104.295C225.773 104.156 225.661 104.042 225.521 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 104.042C226.827 104.041 226.734 104.103 226.694 104.197C226.655 104.292 226.676 104.401 226.749 104.474C226.821 104.546 226.93 104.568 227.025 104.529C227.12 104.49 227.181 104.398 227.181 104.295C227.182 104.156 227.069 104.042 226.929 104.042Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 91.9792C197.25 91.9787 197.157 92.0401 197.117 92.1347C197.078 92.2293 197.099 92.3385 197.171 92.4112C197.244 92.4839 197.353 92.5058 197.448 92.4667C197.542 92.4276 197.604 92.3351 197.604 92.2325C197.605 92.093 197.492 91.9796 197.352 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 91.9792C198.659 91.9787 198.566 92.0401 198.526 92.1347C198.487 92.2294 198.508 92.3385 198.581 92.4112C198.653 92.4839 198.762 92.5058 198.857 92.4667C198.952 92.4275 199.013 92.3351 199.013 92.2325C199.014 92.1655 198.987 92.1012 198.94 92.0537C198.893 92.0062 198.828 91.9794 198.761 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 91.9792C201.475 91.9787 201.383 92.0401 201.343 92.1347C201.303 92.2293 201.325 92.3385 201.397 92.4112C201.469 92.4839 201.578 92.5058 201.673 92.4667C201.768 92.4276 201.83 92.3351 201.83 92.2325C201.83 92.093 201.717 91.9796 201.578 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 91.9792C207.109 91.9787 207.016 92.0401 206.977 92.1347C206.937 92.2293 206.958 92.3385 207.031 92.4112C207.103 92.4839 207.212 92.5058 207.307 92.4667C207.402 92.4276 207.464 92.3351 207.464 92.2325C207.464 92.1655 207.437 92.1012 207.39 92.0537C207.343 92.0062 207.279 91.9794 207.212 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 91.9792C208.517 91.9787 208.424 92.0401 208.385 92.1347C208.345 92.2294 208.367 92.3385 208.439 92.4112C208.511 92.4839 208.62 92.5058 208.715 92.4667C208.81 92.4275 208.872 92.3351 208.872 92.2325C208.872 92.1655 208.846 92.1012 208.798 92.0537C208.751 92.0062 208.687 91.9794 208.62 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 91.9792C211.334 91.9787 211.241 92.0401 211.201 92.1347C211.162 92.2293 211.183 92.3385 211.255 92.4112C211.328 92.4839 211.437 92.5058 211.532 92.4667C211.626 92.4276 211.688 92.3351 211.688 92.2325C211.689 92.093 211.576 91.9796 211.436 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 91.9792C219.784 91.9787 219.691 92.0401 219.651 92.1347C219.612 92.2294 219.633 92.3385 219.706 92.4112C219.778 92.4839 219.887 92.5058 219.982 92.4667C220.077 92.4275 220.138 92.3351 220.138 92.2325C220.139 92.1655 220.112 92.1012 220.065 92.0537C220.018 92.0062 219.953 91.9794 219.886 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 91.9792C221.193 91.9787 221.1 92.0401 221.061 92.1347C221.021 92.2293 221.042 92.3385 221.115 92.4112C221.187 92.4839 221.296 92.5058 221.391 92.4667C221.486 92.4276 221.548 92.3351 221.548 92.2325C221.548 92.093 221.435 91.9796 221.296 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 91.9792C222.601 91.9787 222.508 92.0401 222.469 92.1347C222.429 92.2293 222.451 92.3385 222.523 92.4112C222.595 92.4839 222.704 92.5058 222.799 92.4667C222.894 92.4276 222.956 92.3351 222.956 92.2325C222.956 92.093 222.843 91.9796 222.704 91.9792Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 92.2325,
    rx: 0.25207,
    ry: 0.253302,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 94.6598C195.841 94.6593 195.749 94.7207 195.709 94.8153C195.67 94.9099 195.691 95.0191 195.763 95.0918C195.836 95.1645 195.945 95.1864 196.039 95.1472C196.134 95.1081 196.196 95.0156 196.196 94.9131C196.196 94.7735 196.084 94.6602 195.944 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 94.6598C197.25 94.6593 197.157 94.7207 197.117 94.8153C197.078 94.9099 197.099 95.019 197.171 95.0917C197.244 95.1645 197.353 95.1864 197.448 95.1472C197.542 95.1081 197.604 95.0156 197.604 94.9131C197.605 94.7736 197.492 94.6602 197.352 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 94.6598C198.659 94.6593 198.566 94.7207 198.526 94.8153C198.487 94.9099 198.508 95.0191 198.581 95.0918C198.653 95.1645 198.762 95.1864 198.857 95.1472C198.952 95.1081 199.013 95.0156 199.013 94.9131C199.014 94.8461 198.987 94.7817 198.94 94.7342C198.893 94.6867 198.828 94.66 198.761 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 94.6598C200.067 94.6593 199.974 94.7207 199.935 94.8153C199.895 94.9099 199.916 95.0191 199.989 95.0918C200.061 95.1645 200.17 95.1864 200.265 95.1472C200.36 95.1081 200.422 95.0156 200.422 94.9131C200.422 94.8461 200.395 94.7817 200.348 94.7342C200.301 94.6867 200.237 94.66 200.17 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 94.6598C201.475 94.6593 201.383 94.7207 201.343 94.8153C201.303 94.9099 201.325 95.019 201.397 95.0917C201.469 95.1645 201.578 95.1864 201.673 95.1472C201.768 95.1081 201.83 95.0156 201.83 94.9131C201.83 94.7736 201.717 94.6602 201.578 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 94.6598C202.883 94.6593 202.791 94.7207 202.751 94.8153C202.711 94.9099 202.733 95.0191 202.805 95.0918C202.878 95.1645 202.987 95.1864 203.081 95.1472C203.176 95.1081 203.238 95.0156 203.238 94.9131C203.238 94.8461 203.212 94.7817 203.164 94.7342C203.117 94.6867 203.053 94.66 202.986 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 94.6598C204.292 94.6593 204.199 94.7207 204.159 94.8153C204.12 94.9099 204.141 95.0191 204.213 95.0918C204.286 95.1645 204.395 95.1864 204.49 95.1472C204.584 95.1081 204.646 95.0156 204.646 94.9131C204.646 94.8461 204.62 94.7817 204.573 94.7342C204.525 94.6867 204.461 94.66 204.394 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 94.6598C205.701 94.6593 205.608 94.7207 205.568 94.8153C205.529 94.9099 205.55 95.0191 205.623 95.0918C205.695 95.1645 205.804 95.1864 205.899 95.1472C205.994 95.1081 206.055 95.0156 206.055 94.9131C206.056 94.7735 205.943 94.6602 205.803 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 94.6598C207.109 94.6593 207.016 94.7207 206.977 94.8153C206.937 94.9099 206.958 95.019 207.031 95.0917C207.103 95.1645 207.212 95.1864 207.307 95.1472C207.402 95.1081 207.464 95.0156 207.464 94.9131C207.464 94.8461 207.437 94.7817 207.39 94.7342C207.343 94.6868 207.279 94.66 207.212 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 94.6598C208.517 94.6593 208.424 94.7207 208.385 94.8153C208.345 94.9099 208.367 95.0191 208.439 95.0918C208.511 95.1645 208.62 95.1864 208.715 95.1472C208.81 95.1081 208.872 95.0156 208.872 94.9131C208.872 94.8461 208.846 94.7817 208.798 94.7342C208.751 94.6867 208.687 94.66 208.62 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 94.6598C209.925 94.6593 209.833 94.7207 209.793 94.8153C209.753 94.9099 209.775 95.0191 209.847 95.0918C209.92 95.1645 210.029 95.1864 210.123 95.1472C210.218 95.1081 210.28 95.0156 210.28 94.9131C210.28 94.8461 210.254 94.7817 210.206 94.7342C210.159 94.6867 210.095 94.66 210.028 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 94.6598C211.334 94.6593 211.241 94.7207 211.201 94.8153C211.162 94.9099 211.183 95.019 211.255 95.0917C211.328 95.1645 211.437 95.1864 211.532 95.1472C211.626 95.1081 211.688 95.0156 211.688 94.9131C211.689 94.7736 211.576 94.6602 211.436 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 94.6598C212.742 94.6593 212.649 94.7207 212.609 94.8153C212.57 94.9099 212.591 95.0191 212.664 95.0918C212.736 95.1645 212.845 95.1864 212.94 95.1472C213.035 95.1081 213.096 95.0156 213.096 94.9131C213.097 94.8461 213.07 94.7817 213.023 94.7342C212.976 94.6867 212.911 94.66 212.844 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 94.6598C214.151 94.6593 214.058 94.7207 214.019 94.8153C213.979 94.9099 214 95.0191 214.073 95.0918C214.145 95.1645 214.254 95.1864 214.349 95.1472C214.444 95.1081 214.506 95.0156 214.506 94.9131C214.506 94.8461 214.479 94.7817 214.432 94.7342C214.385 94.6867 214.321 94.66 214.254 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 94.6598C215.559 94.6593 215.466 94.7207 215.427 94.8153C215.387 94.9099 215.409 95.0191 215.481 95.0918C215.553 95.1645 215.662 95.1864 215.757 95.1472C215.852 95.1081 215.914 95.0156 215.914 94.9131C215.914 94.7735 215.801 94.6602 215.662 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 94.6598C216.967 94.6593 216.875 94.7207 216.835 94.8153C216.795 94.9099 216.817 95.0191 216.889 95.0918C216.962 95.1645 217.071 95.1864 217.165 95.1472C217.26 95.1081 217.322 95.0156 217.322 94.9131C217.322 94.8461 217.296 94.7817 217.248 94.7342C217.201 94.6867 217.137 94.66 217.07 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 94.6598C218.377 94.6593 218.284 94.7207 218.244 94.8153C218.205 94.9099 218.226 95.0191 218.298 95.0918C218.371 95.1645 218.48 95.1864 218.575 95.1472C218.669 95.1081 218.731 95.0156 218.731 94.9131C218.732 94.7735 218.619 94.6602 218.479 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 94.6598C219.784 94.6593 219.691 94.7207 219.651 94.8153C219.612 94.9099 219.633 95.0191 219.706 95.0918C219.778 95.1645 219.887 95.1864 219.982 95.1472C220.077 95.1081 220.138 95.0156 220.138 94.9131C220.139 94.8461 220.112 94.7817 220.065 94.7342C220.018 94.6867 219.953 94.66 219.886 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 94.6598C221.193 94.6593 221.1 94.7207 221.061 94.8153C221.021 94.9099 221.042 95.019 221.115 95.0917C221.187 95.1645 221.296 95.1864 221.391 95.1472C221.486 95.1081 221.548 95.0156 221.548 94.9131C221.548 94.7736 221.435 94.6602 221.296 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 94.6598C222.601 94.6593 222.508 94.7207 222.469 94.8153C222.429 94.9099 222.451 95.019 222.523 95.0917C222.595 95.1645 222.704 95.1864 222.799 95.1472C222.894 95.1081 222.956 95.0156 222.956 94.9131C222.956 94.7736 222.843 94.6602 222.704 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 94.6598C224.009 94.6593 223.917 94.7207 223.877 94.8153C223.837 94.9099 223.859 95.0191 223.931 95.0918C224.004 95.1645 224.113 95.1864 224.207 95.1472C224.302 95.1081 224.364 95.0156 224.364 94.9131C224.364 94.8461 224.338 94.7817 224.29 94.7342C224.243 94.6867 224.179 94.66 224.112 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 94.6598C225.419 94.6593 225.326 94.7207 225.286 94.8153C225.247 94.9099 225.268 95.0191 225.34 95.0918C225.413 95.1645 225.522 95.1864 225.617 95.1472C225.711 95.1081 225.773 95.0156 225.773 94.9131C225.773 94.7735 225.661 94.6602 225.521 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 94.6598C226.827 94.6593 226.734 94.7207 226.694 94.8153C226.655 94.9099 226.676 95.0191 226.749 95.0918C226.821 95.1645 226.93 95.1864 227.025 95.1472C227.12 95.1081 227.181 95.0156 227.181 94.9131C227.182 94.7735 227.069 94.6602 226.929 94.6598Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.944,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 96.0001C197.25 95.9996 197.157 96.061 197.117 96.1556C197.078 96.2502 197.099 96.3593 197.171 96.432C197.244 96.5047 197.353 96.5266 197.448 96.4875C197.542 96.4483 197.604 96.3559 197.604 96.2534C197.605 96.1138 197.492 96.0004 197.352 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 96.0001C198.659 95.9996 198.566 96.061 198.526 96.1556C198.487 96.2502 198.508 96.3593 198.581 96.432C198.653 96.5047 198.762 96.5266 198.857 96.4875C198.952 96.4483 199.013 96.3559 199.013 96.2534C199.014 96.1863 198.987 96.122 198.94 96.0745C198.893 96.027 198.828 96.0002 198.761 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.169,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 96.0001C201.475 95.9996 201.382 96.061 201.343 96.1556C201.303 96.2502 201.325 96.3593 201.397 96.432C201.469 96.5047 201.578 96.5266 201.673 96.4875C201.768 96.4483 201.83 96.3559 201.83 96.2534C201.83 96.1138 201.717 96.0004 201.578 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.986,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.395,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.803,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 96.0001C207.109 95.9996 207.016 96.061 206.977 96.1556C206.937 96.2502 206.958 96.3593 207.031 96.432C207.103 96.5047 207.212 96.5266 207.307 96.4875C207.402 96.4483 207.464 96.3559 207.464 96.2534C207.464 96.1864 207.437 96.122 207.39 96.0745C207.343 96.027 207.279 96.0002 207.212 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 96.0001C208.517 95.9996 208.424 96.061 208.385 96.1556C208.345 96.2502 208.367 96.3593 208.439 96.432C208.511 96.5047 208.62 96.5266 208.715 96.4875C208.81 96.4483 208.872 96.3559 208.872 96.2534C208.872 96.1863 208.845 96.122 208.798 96.0745C208.751 96.027 208.687 96.0002 208.62 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.027,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 96.0001C211.334 95.9996 211.241 96.061 211.201 96.1556C211.162 96.2502 211.183 96.3593 211.255 96.432C211.328 96.5047 211.437 96.5266 211.532 96.4875C211.626 96.4483 211.688 96.3559 211.688 96.2534C211.689 96.1138 211.576 96.0004 211.436 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.845,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.253,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.662,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.479,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 96.0001C219.784 95.9996 219.691 96.061 219.651 96.1556C219.612 96.2502 219.633 96.3593 219.706 96.432C219.778 96.5047 219.887 96.5266 219.982 96.4875C220.077 96.4483 220.138 96.3559 220.138 96.2534C220.139 96.1863 220.112 96.122 220.065 96.0745C220.018 96.027 219.953 96.0002 219.886 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 96.0001C221.193 95.9996 221.1 96.061 221.061 96.1556C221.021 96.2502 221.042 96.3593 221.115 96.432C221.187 96.5047 221.296 96.5266 221.391 96.4875C221.486 96.4483 221.548 96.3559 221.548 96.2534C221.548 96.1138 221.435 96.0004 221.296 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 96.0001C222.601 95.9996 222.508 96.061 222.469 96.1556C222.429 96.2502 222.451 96.3593 222.523 96.432C222.595 96.5047 222.704 96.5266 222.799 96.4875C222.894 96.4483 222.956 96.3559 222.956 96.2534C222.956 96.1138 222.843 96.0004 222.704 96.0001Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.112,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.521,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.929,
    cy: 96.2534,
    rx: 0.25207,
    ry: 0.253275,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 89.2987C195.841 89.2982 195.749 89.3596 195.709 89.4542C195.67 89.5488 195.691 89.6579 195.763 89.7306C195.836 89.8033 195.945 89.8252 196.039 89.7861C196.134 89.747 196.196 89.6545 196.196 89.552C196.196 89.4124 196.084 89.299 195.944 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 89.2987C197.25 89.2982 197.157 89.3596 197.117 89.4542C197.078 89.5488 197.099 89.6579 197.171 89.7306C197.244 89.8033 197.353 89.8252 197.448 89.7861C197.542 89.747 197.604 89.6546 197.604 89.552C197.605 89.4125 197.492 89.2991 197.352 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 89.2987C198.659 89.2982 198.566 89.3596 198.526 89.4542C198.487 89.5488 198.508 89.6579 198.581 89.7306C198.653 89.8033 198.762 89.8252 198.857 89.7861C198.952 89.747 199.013 89.6545 199.013 89.552C199.014 89.485 198.987 89.4206 198.94 89.3731C198.893 89.3256 198.828 89.2988 198.761 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 89.2987C200.067 89.2982 199.974 89.3596 199.935 89.4542C199.895 89.5488 199.916 89.6579 199.989 89.7306C200.061 89.8033 200.17 89.8252 200.265 89.7861C200.36 89.747 200.422 89.6545 200.422 89.552C200.422 89.485 200.395 89.4206 200.348 89.3731C200.301 89.3256 200.237 89.2988 200.17 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 89.2987C201.475 89.2982 201.383 89.3596 201.343 89.4542C201.303 89.5488 201.325 89.6579 201.397 89.7306C201.469 89.8033 201.578 89.8252 201.673 89.7861C201.768 89.747 201.83 89.6546 201.83 89.552C201.83 89.4125 201.717 89.2991 201.578 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 89.2987C202.883 89.2982 202.791 89.3596 202.751 89.4542C202.711 89.5488 202.733 89.6579 202.805 89.7306C202.878 89.8033 202.987 89.8252 203.081 89.7861C203.176 89.747 203.238 89.6545 203.238 89.552C203.238 89.485 203.212 89.4206 203.164 89.3731C203.117 89.3256 203.053 89.2988 202.986 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 89.2987C204.292 89.2982 204.199 89.3596 204.159 89.4542C204.12 89.5488 204.141 89.6579 204.213 89.7306C204.286 89.8033 204.395 89.8252 204.49 89.7861C204.584 89.747 204.646 89.6545 204.646 89.552C204.646 89.485 204.62 89.4206 204.573 89.3731C204.525 89.3256 204.461 89.2988 204.394 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 89.2987C205.701 89.2982 205.608 89.3596 205.568 89.4542C205.529 89.5488 205.55 89.6579 205.623 89.7306C205.695 89.8033 205.804 89.8252 205.899 89.7861C205.994 89.747 206.055 89.6545 206.055 89.552C206.056 89.4124 205.943 89.299 205.803 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 89.2987C207.109 89.2982 207.016 89.3596 206.977 89.4542C206.937 89.5488 206.958 89.6579 207.031 89.7306C207.103 89.8033 207.212 89.8252 207.307 89.7861C207.402 89.747 207.464 89.6546 207.464 89.552C207.464 89.485 207.437 89.4206 207.39 89.3731C207.343 89.3256 207.279 89.2989 207.212 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 89.2987C208.517 89.2982 208.424 89.3596 208.385 89.4542C208.345 89.5488 208.367 89.6579 208.439 89.7306C208.511 89.8033 208.62 89.8252 208.715 89.7861C208.81 89.747 208.872 89.6545 208.872 89.552C208.872 89.485 208.846 89.4206 208.798 89.3731C208.751 89.3256 208.687 89.2988 208.62 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 89.2987C209.925 89.2982 209.833 89.3596 209.793 89.4542C209.753 89.5488 209.775 89.6579 209.847 89.7306C209.92 89.8033 210.029 89.8252 210.123 89.7861C210.218 89.747 210.28 89.6545 210.28 89.552C210.28 89.485 210.254 89.4206 210.206 89.3731C210.159 89.3256 210.095 89.2988 210.028 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 89.2987C211.334 89.2982 211.241 89.3596 211.201 89.4542C211.162 89.5488 211.183 89.6579 211.255 89.7306C211.328 89.8033 211.437 89.8252 211.532 89.7861C211.626 89.747 211.688 89.6546 211.688 89.552C211.689 89.4125 211.576 89.2991 211.436 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 89.2987C212.742 89.2982 212.649 89.3596 212.609 89.4542C212.57 89.5488 212.591 89.6579 212.664 89.7306C212.736 89.8033 212.845 89.8252 212.94 89.7861C213.035 89.747 213.096 89.6545 213.096 89.552C213.097 89.485 213.07 89.4206 213.023 89.3731C212.976 89.3256 212.911 89.2988 212.844 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 89.2987C214.151 89.2982 214.058 89.3596 214.019 89.4542C213.979 89.5488 214 89.6579 214.073 89.7306C214.145 89.8033 214.254 89.8252 214.349 89.7861C214.444 89.747 214.506 89.6545 214.506 89.552C214.506 89.485 214.479 89.4206 214.432 89.3731C214.385 89.3256 214.321 89.2988 214.254 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 89.2987C215.559 89.2982 215.466 89.3596 215.427 89.4542C215.387 89.5488 215.409 89.6579 215.481 89.7306C215.553 89.8033 215.662 89.8252 215.757 89.7861C215.852 89.747 215.914 89.6545 215.914 89.552C215.914 89.4124 215.801 89.299 215.662 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 89.2987C216.967 89.2982 216.875 89.3596 216.835 89.4542C216.795 89.5488 216.817 89.6579 216.889 89.7306C216.962 89.8033 217.071 89.8252 217.165 89.7861C217.26 89.747 217.322 89.6545 217.322 89.552C217.322 89.485 217.296 89.4206 217.248 89.3731C217.201 89.3256 217.137 89.2988 217.07 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 89.2987C218.377 89.2982 218.284 89.3596 218.244 89.4542C218.205 89.5488 218.226 89.6579 218.298 89.7306C218.371 89.8033 218.48 89.8252 218.575 89.7861C218.669 89.747 218.731 89.6545 218.731 89.552C218.732 89.4124 218.619 89.299 218.479 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 89.2987C219.784 89.2982 219.691 89.3596 219.651 89.4542C219.612 89.5488 219.633 89.6579 219.706 89.7306C219.778 89.8033 219.887 89.8252 219.982 89.7861C220.077 89.747 220.138 89.6545 220.138 89.552C220.139 89.485 220.112 89.4206 220.065 89.3731C220.018 89.3256 219.953 89.2988 219.886 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 89.2987C221.193 89.2982 221.1 89.3596 221.061 89.4542C221.021 89.5488 221.042 89.6579 221.115 89.7306C221.187 89.8033 221.296 89.8252 221.391 89.7861C221.486 89.747 221.548 89.6546 221.548 89.552C221.548 89.4125 221.435 89.2991 221.296 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 89.2987C222.601 89.2982 222.508 89.3596 222.469 89.4542C222.429 89.5488 222.451 89.6579 222.523 89.7306C222.595 89.8033 222.704 89.8252 222.799 89.7861C222.894 89.747 222.956 89.6546 222.956 89.552C222.956 89.4125 222.843 89.2991 222.704 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 89.2987C224.009 89.2982 223.917 89.3596 223.877 89.4542C223.837 89.5488 223.859 89.6579 223.931 89.7306C224.004 89.8033 224.113 89.8252 224.207 89.7861C224.302 89.747 224.364 89.6545 224.364 89.552C224.364 89.485 224.338 89.4206 224.29 89.3731C224.243 89.3256 224.179 89.2989 224.112 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 89.2987C225.419 89.2982 225.326 89.3596 225.286 89.4542C225.247 89.5488 225.268 89.6579 225.34 89.7306C225.413 89.8033 225.522 89.8252 225.617 89.7861C225.711 89.747 225.773 89.6545 225.773 89.552C225.774 89.4124 225.661 89.299 225.521 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 89.2987C226.827 89.2982 226.734 89.3596 226.694 89.4542C226.655 89.5488 226.676 89.6579 226.749 89.7306C226.821 89.8033 226.93 89.8252 227.025 89.7861C227.12 89.747 227.181 89.6545 227.181 89.552C227.182 89.4124 227.069 89.299 226.929 89.2987Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 90.639C195.841 90.6385 195.749 90.6999 195.709 90.7945C195.67 90.8891 195.691 90.9982 195.763 91.0709C195.836 91.1436 195.945 91.1655 196.039 91.1264C196.134 91.0872 196.196 90.9948 196.196 90.8923C196.196 90.7527 196.084 90.6393 195.944 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 90.639C197.25 90.6384 197.157 90.6998 197.117 90.7944C197.078 90.889 197.099 90.9982 197.171 91.0709C197.244 91.1436 197.353 91.1655 197.448 91.1264C197.542 91.0873 197.604 90.9948 197.604 90.8923C197.605 90.7527 197.492 90.6393 197.352 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 90.639C198.659 90.6385 198.566 90.6999 198.526 90.7945C198.487 90.8891 198.508 90.9982 198.581 91.0709C198.653 91.1436 198.762 91.1655 198.857 91.1264C198.952 91.0872 199.013 90.9948 199.013 90.8923C199.014 90.8252 198.987 90.7609 198.94 90.7134C198.893 90.6659 198.828 90.6391 198.761 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 90.639C200.067 90.6385 199.974 90.6999 199.935 90.7945C199.895 90.8891 199.916 90.9982 199.989 91.0709C200.061 91.1436 200.17 91.1655 200.265 91.1264C200.36 91.0872 200.422 90.9948 200.422 90.8923C200.422 90.8252 200.395 90.7609 200.348 90.7134C200.301 90.6659 200.237 90.6391 200.17 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 90.639C201.475 90.6384 201.383 90.6998 201.343 90.7944C201.303 90.889 201.325 90.9982 201.397 91.0709C201.469 91.1436 201.578 91.1655 201.673 91.1264C201.768 91.0873 201.83 90.9948 201.83 90.8923C201.83 90.7527 201.717 90.6393 201.578 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 90.639C202.883 90.6385 202.791 90.6999 202.751 90.7945C202.711 90.8891 202.733 90.9982 202.805 91.0709C202.878 91.1436 202.987 91.1655 203.081 91.1264C203.176 91.0872 203.238 90.9948 203.238 90.8923C203.238 90.8252 203.212 90.7609 203.164 90.7134C203.117 90.6659 203.053 90.6391 202.986 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 90.639C204.292 90.6385 204.199 90.6999 204.159 90.7945C204.12 90.8891 204.141 90.9982 204.213 91.0709C204.286 91.1436 204.395 91.1655 204.49 91.1264C204.584 91.0872 204.646 90.9948 204.646 90.8923C204.646 90.8252 204.62 90.7609 204.573 90.7134C204.525 90.6659 204.461 90.6391 204.394 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 90.639C205.701 90.6385 205.608 90.6999 205.568 90.7945C205.529 90.8891 205.55 90.9982 205.623 91.0709C205.695 91.1436 205.804 91.1655 205.899 91.1264C205.994 91.0872 206.055 90.9948 206.055 90.8923C206.056 90.7527 205.943 90.6393 205.803 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 90.639C207.109 90.6384 207.016 90.6998 206.977 90.7944C206.937 90.889 206.958 90.9982 207.031 91.0709C207.103 91.1436 207.212 91.1655 207.307 91.1264C207.402 91.0873 207.464 90.9948 207.464 90.8923C207.464 90.8253 207.437 90.7609 207.39 90.7134C207.343 90.6659 207.279 90.6391 207.212 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 90.639C208.517 90.6385 208.424 90.6999 208.385 90.7945C208.345 90.8891 208.367 90.9982 208.439 91.0709C208.511 91.1436 208.62 91.1655 208.715 91.1264C208.81 91.0872 208.872 90.9948 208.872 90.8923C208.872 90.8252 208.846 90.7609 208.798 90.7134C208.751 90.6659 208.687 90.6391 208.62 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 90.639C209.925 90.6385 209.833 90.6999 209.793 90.7945C209.753 90.8891 209.775 90.9982 209.847 91.0709C209.92 91.1436 210.029 91.1655 210.123 91.1264C210.218 91.0872 210.28 90.9948 210.28 90.8923C210.28 90.8252 210.254 90.7609 210.206 90.7134C210.159 90.6659 210.095 90.6391 210.028 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 90.639C211.334 90.6384 211.241 90.6998 211.201 90.7944C211.162 90.889 211.183 90.9982 211.255 91.0709C211.328 91.1436 211.437 91.1655 211.532 91.1264C211.626 91.0873 211.688 90.9948 211.688 90.8923C211.689 90.7527 211.576 90.6393 211.436 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 90.639C212.742 90.6385 212.649 90.6999 212.609 90.7945C212.57 90.8891 212.591 90.9982 212.664 91.0709C212.736 91.1436 212.845 91.1655 212.94 91.1264C213.035 91.0872 213.096 90.9948 213.096 90.8923C213.097 90.8252 213.07 90.7609 213.023 90.7134C212.976 90.6659 212.911 90.6391 212.844 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 90.639C214.151 90.6385 214.058 90.6999 214.019 90.7945C213.979 90.8891 214 90.9982 214.073 91.0709C214.145 91.1436 214.254 91.1655 214.349 91.1264C214.444 91.0872 214.506 90.9948 214.506 90.8923C214.506 90.8252 214.479 90.7609 214.432 90.7134C214.385 90.6659 214.321 90.6391 214.254 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 90.639C215.559 90.6385 215.466 90.6999 215.427 90.7945C215.387 90.8891 215.409 90.9982 215.481 91.0709C215.553 91.1436 215.662 91.1655 215.757 91.1264C215.852 91.0872 215.914 90.9948 215.914 90.8923C215.914 90.7527 215.801 90.6393 215.662 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 90.639C216.967 90.6385 216.875 90.6999 216.835 90.7945C216.795 90.8891 216.817 90.9982 216.889 91.0709C216.962 91.1436 217.071 91.1655 217.165 91.1264C217.26 91.0872 217.322 90.9948 217.322 90.8923C217.322 90.8252 217.296 90.7609 217.248 90.7134C217.201 90.6659 217.137 90.6391 217.07 90.639V90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 90.639C218.377 90.6385 218.284 90.6999 218.244 90.7945C218.205 90.8891 218.226 90.9982 218.298 91.0709C218.371 91.1436 218.48 91.1655 218.575 91.1264C218.669 91.0872 218.731 90.9948 218.731 90.8923C218.732 90.7527 218.619 90.6393 218.479 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 90.639C219.784 90.6385 219.691 90.6999 219.651 90.7945C219.612 90.8891 219.633 90.9982 219.706 91.0709C219.778 91.1436 219.887 91.1655 219.982 91.1264C220.077 91.0872 220.138 90.9948 220.138 90.8923C220.139 90.8252 220.112 90.7609 220.065 90.7134C220.018 90.6659 219.953 90.6391 219.886 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 90.639C221.193 90.6384 221.1 90.6998 221.061 90.7944C221.021 90.889 221.042 90.9982 221.115 91.0709C221.187 91.1436 221.296 91.1655 221.391 91.1264C221.486 91.0873 221.548 90.9948 221.548 90.8923C221.548 90.7527 221.435 90.6393 221.296 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 90.639C222.601 90.6384 222.508 90.6998 222.469 90.7944C222.429 90.889 222.451 90.9982 222.523 91.0709C222.595 91.1436 222.704 91.1655 222.799 91.1264C222.894 91.0873 222.956 90.9948 222.956 90.8923C222.956 90.7527 222.843 90.6393 222.704 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 90.639C224.009 90.6385 223.917 90.6999 223.877 90.7945C223.837 90.8891 223.859 90.9982 223.931 91.0709C224.004 91.1436 224.113 91.1655 224.207 91.1264C224.302 91.0872 224.364 90.9948 224.364 90.8923C224.364 90.8252 224.338 90.7609 224.29 90.7134C224.243 90.6659 224.179 90.6391 224.112 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 90.639C225.419 90.6385 225.326 90.6999 225.286 90.7945C225.247 90.8891 225.268 90.9982 225.34 91.0709C225.413 91.1436 225.522 91.1655 225.617 91.1264C225.711 91.0872 225.773 90.9948 225.773 90.8923C225.774 90.7527 225.661 90.6393 225.521 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 90.639C226.827 90.6385 226.734 90.6999 226.694 90.7945C226.655 90.8891 226.676 90.9982 226.749 91.0709C226.821 91.1436 226.93 91.1655 227.025 91.1264C227.12 91.0872 227.181 90.9948 227.181 90.8923C227.182 90.7527 227.069 90.6393 226.929 90.639Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 93.3195C195.841 93.319 195.749 93.3804 195.709 93.4751C195.67 93.5697 195.691 93.6788 195.763 93.7515C195.836 93.8242 195.945 93.8461 196.039 93.8069C196.134 93.7678 196.196 93.6754 196.196 93.5728C196.196 93.4333 196.084 93.3199 195.944 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 93.3195C197.25 93.319 197.157 93.3804 197.117 93.475C197.078 93.5696 197.099 93.6788 197.171 93.7515C197.244 93.8242 197.353 93.8461 197.448 93.8069C197.542 93.7678 197.604 93.6754 197.604 93.5728C197.605 93.4333 197.492 93.3199 197.352 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 93.3195C198.659 93.319 198.566 93.3804 198.526 93.4751C198.487 93.5697 198.508 93.6788 198.581 93.7515C198.653 93.8242 198.762 93.8461 198.857 93.8069C198.952 93.7678 199.013 93.6754 199.013 93.5728C199.014 93.5058 198.987 93.4415 198.94 93.394C198.893 93.3465 198.828 93.3197 198.761 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 93.3195C200.067 93.319 199.974 93.3804 199.935 93.4751C199.895 93.5697 199.916 93.6788 199.989 93.7515C200.061 93.8242 200.17 93.8461 200.265 93.8069C200.36 93.7678 200.422 93.6754 200.422 93.5728C200.422 93.5058 200.395 93.4415 200.348 93.394C200.301 93.3465 200.237 93.3197 200.17 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 93.3195C201.475 93.319 201.383 93.3804 201.343 93.475C201.303 93.5696 201.325 93.6788 201.397 93.7515C201.469 93.8242 201.578 93.8461 201.673 93.8069C201.768 93.7678 201.83 93.6754 201.83 93.5728C201.83 93.4333 201.717 93.3199 201.578 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 93.3195C202.883 93.319 202.791 93.3804 202.751 93.4751C202.711 93.5697 202.733 93.6788 202.805 93.7515C202.878 93.8242 202.987 93.8461 203.081 93.8069C203.176 93.7678 203.238 93.6754 203.238 93.5728C203.238 93.5058 203.212 93.4415 203.164 93.394C203.117 93.3465 203.053 93.3197 202.986 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 93.3195C204.292 93.319 204.199 93.3804 204.159 93.4751C204.12 93.5697 204.141 93.6788 204.213 93.7515C204.286 93.8242 204.395 93.8461 204.49 93.8069C204.584 93.7678 204.646 93.6754 204.646 93.5728C204.646 93.5058 204.62 93.4415 204.573 93.394C204.525 93.3465 204.461 93.3197 204.394 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 93.3195C205.701 93.319 205.608 93.3804 205.568 93.4751C205.529 93.5697 205.55 93.6788 205.623 93.7515C205.695 93.8242 205.804 93.8461 205.899 93.8069C205.994 93.7678 206.055 93.6754 206.055 93.5728C206.056 93.4333 205.943 93.3199 205.803 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 93.3195C207.109 93.319 207.016 93.3804 206.977 93.475C206.937 93.5696 206.958 93.6788 207.031 93.7515C207.103 93.8242 207.212 93.8461 207.307 93.8069C207.402 93.7678 207.464 93.6754 207.464 93.5728C207.464 93.5058 207.437 93.4415 207.39 93.394C207.343 93.3465 207.279 93.3197 207.212 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 93.3195C208.517 93.319 208.424 93.3804 208.385 93.4751C208.345 93.5697 208.367 93.6788 208.439 93.7515C208.511 93.8242 208.62 93.8461 208.715 93.8069C208.81 93.7678 208.872 93.6754 208.872 93.5728C208.872 93.5058 208.846 93.4415 208.798 93.394C208.751 93.3465 208.687 93.3197 208.62 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 93.3195C209.925 93.319 209.833 93.3804 209.793 93.4751C209.753 93.5697 209.775 93.6788 209.847 93.7515C209.92 93.8242 210.029 93.8461 210.123 93.8069C210.218 93.7678 210.28 93.6754 210.28 93.5728C210.28 93.5058 210.254 93.4415 210.206 93.394C210.159 93.3465 210.095 93.3197 210.028 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 93.3195C211.334 93.319 211.241 93.3804 211.201 93.475C211.162 93.5696 211.183 93.6788 211.255 93.7515C211.328 93.8242 211.437 93.8461 211.532 93.8069C211.626 93.7678 211.688 93.6754 211.688 93.5728C211.689 93.4333 211.576 93.3199 211.436 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 93.3195C212.742 93.319 212.649 93.3804 212.609 93.4751C212.57 93.5697 212.591 93.6788 212.664 93.7515C212.736 93.8242 212.845 93.8461 212.94 93.8069C213.035 93.7678 213.096 93.6754 213.096 93.5728C213.097 93.5058 213.07 93.4415 213.023 93.394C212.976 93.3465 212.911 93.3197 212.844 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 93.3195C214.151 93.319 214.058 93.3804 214.019 93.4751C213.979 93.5697 214 93.6788 214.073 93.7515C214.145 93.8242 214.254 93.8461 214.349 93.8069C214.444 93.7678 214.506 93.6754 214.506 93.5728C214.506 93.5058 214.479 93.4415 214.432 93.394C214.385 93.3465 214.321 93.3197 214.254 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 93.3195C215.559 93.319 215.466 93.3804 215.427 93.4751C215.387 93.5697 215.409 93.6788 215.481 93.7515C215.553 93.8242 215.662 93.8461 215.757 93.8069C215.852 93.7678 215.914 93.6754 215.914 93.5728C215.914 93.4333 215.801 93.3199 215.662 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 93.3195C216.967 93.319 216.875 93.3804 216.835 93.4751C216.795 93.5697 216.817 93.6788 216.889 93.7515C216.962 93.8242 217.071 93.8461 217.165 93.8069C217.26 93.7678 217.322 93.6754 217.322 93.5728C217.322 93.5058 217.296 93.4415 217.248 93.394C217.201 93.3465 217.137 93.3197 217.07 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 93.3195C218.377 93.319 218.284 93.3804 218.244 93.4751C218.205 93.5697 218.226 93.6788 218.298 93.7515C218.371 93.8242 218.48 93.8461 218.575 93.8069C218.669 93.7678 218.731 93.6754 218.731 93.5728C218.732 93.4333 218.619 93.3199 218.479 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 93.3195C219.784 93.319 219.691 93.3804 219.651 93.4751C219.612 93.5697 219.633 93.6788 219.706 93.7515C219.778 93.8242 219.887 93.8461 219.982 93.8069C220.077 93.7678 220.138 93.6754 220.138 93.5728C220.139 93.5058 220.112 93.4415 220.065 93.394C220.018 93.3465 219.953 93.3197 219.886 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 93.3195C221.193 93.319 221.1 93.3804 221.061 93.475C221.021 93.5696 221.042 93.6788 221.115 93.7515C221.187 93.8242 221.296 93.8461 221.391 93.8069C221.486 93.7678 221.548 93.6754 221.548 93.5728C221.548 93.4333 221.435 93.3199 221.296 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 93.3195C222.601 93.319 222.508 93.3804 222.469 93.475C222.429 93.5696 222.451 93.6788 222.523 93.7515C222.595 93.8242 222.704 93.8461 222.799 93.8069C222.894 93.7678 222.956 93.6754 222.956 93.5728C222.956 93.4333 222.843 93.3199 222.704 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 93.3195C224.009 93.319 223.917 93.3804 223.877 93.4751C223.837 93.5697 223.859 93.6788 223.931 93.7515C224.004 93.8242 224.113 93.8461 224.207 93.8069C224.302 93.7678 224.364 93.6754 224.364 93.5728C224.364 93.5058 224.338 93.4415 224.29 93.394C224.243 93.3465 224.179 93.3197 224.112 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 93.3195C225.419 93.319 225.326 93.3804 225.286 93.4751C225.247 93.5697 225.268 93.6788 225.34 93.7515C225.413 93.8242 225.522 93.8461 225.617 93.8069C225.711 93.7678 225.773 93.6754 225.773 93.5728C225.773 93.4333 225.661 93.3199 225.521 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 93.3195C226.827 93.319 226.734 93.3804 226.694 93.4751C226.655 93.5697 226.676 93.6788 226.749 93.7515C226.821 93.8242 226.93 93.8461 227.025 93.8069C227.12 93.7678 227.181 93.6754 227.181 93.5728C227.182 93.4333 227.069 93.3199 226.929 93.3195Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.944 98.6807C195.841 98.6802 195.749 98.7416 195.709 98.8362C195.67 98.9308 195.691 99.0399 195.763 99.1126C195.836 99.1853 195.945 99.2072 196.039 99.1681C196.134 99.1289 196.196 99.0365 196.196 98.934C196.196 98.7944 196.084 98.681 195.944 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 98.6807C197.25 98.6801 197.157 98.7415 197.117 98.8361C197.078 98.9307 197.099 99.0399 197.171 99.1126C197.244 99.1853 197.353 99.2072 197.448 99.1681C197.542 99.129 197.604 99.0365 197.604 98.934C197.604 98.867 197.578 98.8026 197.531 98.7551C197.483 98.7076 197.419 98.6808 197.352 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 98.6807C198.659 98.6802 198.566 98.7416 198.526 98.8362C198.487 98.9308 198.508 99.0399 198.581 99.1126C198.653 99.1853 198.762 99.2072 198.857 99.1681C198.952 99.1289 199.013 99.0365 199.013 98.934C199.014 98.8669 198.987 98.8026 198.94 98.7551C198.893 98.7076 198.828 98.6808 198.761 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 98.6807C200.067 98.6802 199.974 98.7416 199.935 98.8362C199.895 98.9308 199.916 99.0399 199.989 99.1126C200.061 99.1853 200.17 99.2072 200.265 99.1681C200.36 99.1289 200.422 99.0365 200.422 98.934C200.422 98.8669 200.395 98.8026 200.348 98.7551C200.301 98.7076 200.237 98.6808 200.17 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.578 98.6807C201.475 98.6801 201.383 98.7415 201.343 98.8361C201.303 98.9307 201.325 99.0399 201.397 99.1126C201.469 99.1853 201.578 99.2072 201.673 99.1681C201.768 99.129 201.83 99.0365 201.83 98.934C201.83 98.867 201.804 98.8026 201.756 98.7551C201.709 98.7076 201.645 98.6808 201.578 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.986 98.6807C202.883 98.6802 202.791 98.7416 202.751 98.8362C202.711 98.9308 202.733 99.0399 202.805 99.1126C202.878 99.1853 202.987 99.2072 203.081 99.1681C203.176 99.1289 203.238 99.0365 203.238 98.934C203.238 98.8669 203.212 98.8026 203.164 98.7551C203.117 98.7076 203.053 98.6808 202.986 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.394 98.6807C204.292 98.6802 204.199 98.7416 204.159 98.8362C204.12 98.9308 204.141 99.0399 204.213 99.1126C204.286 99.1853 204.395 99.2072 204.49 99.1681C204.584 99.1289 204.646 99.0365 204.646 98.934C204.646 98.8669 204.62 98.8026 204.573 98.7551C204.525 98.7076 204.461 98.6808 204.394 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.803 98.6807C205.701 98.6802 205.608 98.7416 205.568 98.8362C205.529 98.9308 205.55 99.0399 205.623 99.1126C205.695 99.1853 205.804 99.2072 205.899 99.1681C205.994 99.1289 206.055 99.0365 206.055 98.934C206.056 98.7944 205.943 98.681 205.803 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.212 98.6807C207.109 98.6801 207.016 98.7415 206.977 98.8361C206.937 98.9307 206.958 99.0399 207.031 99.1126C207.103 99.1853 207.212 99.2072 207.307 99.1681C207.402 99.129 207.464 99.0365 207.464 98.934C207.464 98.8669 207.437 98.8026 207.39 98.7551C207.343 98.7076 207.279 98.6808 207.212 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 98.6807C208.517 98.6802 208.424 98.7416 208.385 98.8362C208.345 98.9308 208.367 99.0399 208.439 99.1126C208.511 99.1853 208.62 99.2072 208.715 99.1681C208.81 99.1289 208.872 99.0365 208.872 98.934C208.872 98.8669 208.846 98.8026 208.798 98.7551C208.751 98.7076 208.687 98.6808 208.62 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.028 98.6807C209.925 98.6802 209.833 98.7416 209.793 98.8362C209.753 98.9308 209.775 99.0399 209.847 99.1126C209.92 99.1853 210.029 99.2072 210.123 99.1681C210.218 99.1289 210.28 99.0365 210.28 98.934C210.28 98.8669 210.254 98.8026 210.206 98.7551C210.159 98.7076 210.095 98.6808 210.028 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 98.6807C211.334 98.6801 211.241 98.7415 211.201 98.8361C211.162 98.9307 211.183 99.0399 211.255 99.1126C211.328 99.1853 211.437 99.2072 211.532 99.1681C211.626 99.129 211.688 99.0365 211.688 98.934C211.688 98.867 211.662 98.8026 211.615 98.7551C211.567 98.7076 211.503 98.6808 211.436 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 98.6807C212.742 98.6802 212.649 98.7416 212.609 98.8362C212.57 98.9308 212.591 99.0399 212.664 99.1126C212.736 99.1853 212.845 99.2072 212.94 99.1681C213.035 99.1289 213.096 99.0365 213.096 98.934C213.097 98.8669 213.07 98.8026 213.023 98.7551C212.976 98.7076 212.911 98.6808 212.844 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 98.6807C214.151 98.6802 214.058 98.7416 214.019 98.8362C213.979 98.9308 214 99.0399 214.073 99.1126C214.145 99.1853 214.254 99.2072 214.349 99.1681C214.444 99.1289 214.506 99.0365 214.506 98.934C214.506 98.8669 214.479 98.8026 214.432 98.7551C214.385 98.7076 214.321 98.6808 214.254 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.662 98.6807C215.559 98.6802 215.466 98.7416 215.427 98.8362C215.387 98.9308 215.409 99.0399 215.481 99.1126C215.553 99.1853 215.662 99.2072 215.757 99.1681C215.852 99.1289 215.914 99.0365 215.914 98.934C215.914 98.7944 215.801 98.681 215.662 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07 98.6807C216.967 98.6802 216.875 98.7416 216.835 98.8362C216.795 98.9308 216.817 99.0399 216.889 99.1126C216.962 99.1853 217.071 99.2072 217.165 99.1681C217.26 99.1289 217.322 99.0365 217.322 98.934C217.322 98.8669 217.296 98.8026 217.248 98.7551C217.201 98.7076 217.137 98.6808 217.07 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.479 98.6807C218.377 98.6802 218.284 98.7416 218.244 98.8362C218.205 98.9308 218.226 99.0399 218.298 99.1126C218.371 99.1853 218.48 99.2072 218.575 99.1681C218.669 99.1289 218.731 99.0365 218.731 98.934C218.732 98.7944 218.619 98.681 218.479 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886 98.6807C219.784 98.6802 219.691 98.7416 219.651 98.8362C219.612 98.9308 219.633 99.0399 219.706 99.1126C219.778 99.1853 219.887 99.2072 219.982 99.1681C220.077 99.1289 220.138 99.0365 220.138 98.934C220.139 98.8669 220.112 98.8026 220.065 98.7551C220.018 98.7076 219.953 98.6808 219.886 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 98.6807C221.193 98.6801 221.1 98.7415 221.061 98.8361C221.021 98.9307 221.042 99.0399 221.115 99.1126C221.187 99.1853 221.296 99.2072 221.391 99.1681C221.486 99.129 221.548 99.0365 221.548 98.934C221.548 98.7944 221.435 98.681 221.296 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.704 98.6807C222.601 98.6801 222.508 98.7415 222.469 98.8361C222.429 98.9307 222.451 99.0399 222.523 99.1126C222.595 99.1853 222.704 99.2072 222.799 99.1681C222.894 99.129 222.956 99.0365 222.956 98.934C222.956 98.7944 222.843 98.681 222.704 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.112 98.6807C224.009 98.6802 223.917 98.7416 223.877 98.8362C223.837 98.9308 223.859 99.0399 223.931 99.1126C224.004 99.1853 224.113 99.2072 224.207 99.1681C224.302 99.1289 224.364 99.0365 224.364 98.934C224.364 98.8669 224.338 98.8026 224.29 98.7551C224.243 98.7076 224.179 98.6808 224.112 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.521 98.6807C225.419 98.6802 225.326 98.7416 225.286 98.8362C225.247 98.9308 225.268 99.0399 225.34 99.1126C225.413 99.1853 225.522 99.2072 225.617 99.1681C225.711 99.1289 225.773 99.0365 225.773 98.934C225.774 98.7944 225.661 98.681 225.521 98.6807Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.929 98.6807C226.827 98.6802 226.734 98.7416 226.694 98.8362C226.655 98.9308 226.676 99.0399 226.749 99.1126C226.821 99.1853 226.93 99.2072 227.025 99.1681C227.12 99.1289 227.181 99.0365 227.181 98.934C227.182 98.7944 227.069 98.681 226.929 98.6807Z",
    fill: "#0084F0"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.892 46.9755L221.737 46.9212L198.895 41.5417C198.674 41.4904 198.449 41.4618 198.223 41.4564H198.091C197.865 41.458 197.639 41.4867 197.419 41.5417L174.577 46.9212L174.422 46.9755C171.054 48.1554 168.791 51.5942 168.791 55.5377V81.8681C168.791 86.4945 170.39 90.9424 173.542 95.08C175.936 98.216 179.235 101.181 183.337 103.882C186.906 106.227 190.467 107.958 192.823 108.99C193.897 109.464 194.947 109.891 195.952 110.271C197.226 110.752 197.566 110.877 198.192 110.877C198.668 110.875 199.138 110.766 199.567 110.558C201.22 109.968 207.067 107.764 212.977 103.875C217.087 101.174 220.377 98.2161 222.772 95.072C225.924 90.9349 227.523 86.4945 227.523 81.8601V55.5377C227.523 51.5942 225.26 48.1554 221.892 46.9755H221.892Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193.425 87.9675L180.575 75.0545C180.22 74.697 180.22 74.12 180.575 73.7625L185.339 68.9756C185.509 68.8043 185.74 68.708 185.981 68.708C186.223 68.708 186.454 68.8043 186.624 68.9756L193.425 75.8096C193.595 75.9809 193.827 76.0772 194.068 76.0772C194.309 76.0772 194.541 75.9809 194.711 75.8096L208.861 61.5903C209.031 61.419 209.263 61.3227 209.504 61.3227C209.745 61.3227 209.977 61.419 210.147 61.5903L214.911 66.3772C215.266 66.7347 215.266 67.3117 214.911 67.6693L194.711 87.9675C194.541 88.1388 194.309 88.2351 194.068 88.2351C193.827 88.2351 193.595 88.1388 193.425 87.9675Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M203.439 49.9281C205.043 49.6782 206.684 49.8981 208.165 50.5612",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.234 95.3092C188.999 97.2052 192.086 98.5814 195.344 99.3703",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.163 87.694C129.163 77.6593 122.655 69.1565 113.651 66.2018C112.406 54.8985 102.873 46.1062 91.2929 46.1062C84.2475 46.1062 77.961 49.3621 73.8353 54.456C71.4539 53.4273 68.8867 52.8979 66.2926 52.9005C58.0926 52.9005 51.1009 58.0892 48.3847 65.3765C37.672 67.1101 29.4883 76.44 29.4883 87.694C29.4883 100.181 39.5619 110.304 51.9884 110.304V110.326H108.262V110.241C119.941 109.416 129.163 99.6402 129.163 87.694Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 86.9866L81.2975 61.888C80.8068 61.3077 80.0854 60.973 79.3255 60.973C78.5655 60.973 77.8441 61.3077 77.3534 61.888L56.0711 86.9866C54.6378 88.677 55.8332 91.2787 58.0431 91.2787H71.0482V118.319H87.6029V91.2787H100.608C102.818 91.2787 104.013 88.6769 102.58 86.9866Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.076 159.737L153.61 125.157C154.361 120.434 157.64 116.502 162.152 114.916L176.045 134.755L180.066 161.941L148.076 159.737L148.076 159.737Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 114,
    width: 33,
    height: 48
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.076 159.737L153.61 125.157C154.361 120.434 157.64 116.502 162.152 114.916L176.045 134.755L180.066 161.941L148.076 159.737L148.076 159.737Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.675 138.429L169.758 156.981L165.707 165.799L148.076 152.882",
    fill: "#004389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.675 138.429L169.758 156.981L165.707 165.799L148.076 152.882",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.076 159.737L153.61 125.157C154.361 120.434 157.64 116.502 162.152 114.916V114.916L176.045 134.755L180.066 161.941L148.076 159.737L148.076 159.737Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.019 130.711L167.819 162.86H210.229L200.755 109.405C200.755 109.405 177.724 108.129 161.638 115.109",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 109,
    width: 50,
    height: 54
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.018 130.711L167.818 162.86H210.228L200.754 109.405C200.754 109.405 177.723 108.129 161.637 115.109",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5_6810)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.598,
    cy: 110.773,
    rx: 15.0512,
    ry: 10.7502,
    transform: "rotate(-47.0173 180.598 110.773)",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.19,
    cy: 110.685,
    rx: 12.5371,
    ry: 8.96164,
    transform: "rotate(-47.0182 180.19 110.685)",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.034 139.974C170.595 134.252 175.159 128.92 181.227 128.066C187.295 127.213 192.571 131.161 193.01 136.883C193.449 142.606 188.885 147.938 182.817 148.791C176.749 149.645 171.473 145.697 171.034 139.974ZM173.389 139.643C173.734 144.14 177.879 147.241 182.647 146.571C187.415 145.9 191.001 141.711 190.656 137.214C190.31 132.718 186.165 129.616 181.397 130.287C176.629 130.957 173.044 135.146 173.389 139.643Z",
    fill: "#004389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.227 128.066L181.338 128.858L181.338 128.858L181.227 128.066ZM171.034 139.974L171.832 139.913L171.832 139.913L171.034 139.974ZM193.01 136.883L193.808 136.822V136.822L193.01 136.883ZM182.817 148.791L182.706 147.999H182.706L182.817 148.791ZM182.647 146.571L182.758 147.363H182.758L182.647 146.571ZM173.389 139.643L174.186 139.582V139.582L173.389 139.643ZM190.656 137.214L191.453 137.153V137.153L190.656 137.214ZM181.397 130.287L181.509 131.079L181.397 130.287ZM181.115 127.274C174.675 128.18 169.762 133.848 170.236 140.035L171.832 139.913C171.428 134.655 175.643 129.659 181.338 128.858L181.115 127.274ZM193.808 136.822C193.329 130.586 187.586 126.364 181.115 127.274L181.338 128.858C187.004 128.061 191.813 131.735 192.212 136.944L193.808 136.822ZM182.929 149.584C189.37 148.678 194.283 143.01 193.808 136.822L192.212 136.944C192.616 142.202 188.401 147.198 182.706 147.999L182.929 149.584ZM170.236 140.035C170.715 146.272 176.458 150.494 182.929 149.584L182.706 147.999C177.041 148.796 172.232 145.122 171.832 139.913L170.236 140.035ZM182.536 145.779C178.17 146.393 174.492 143.565 174.186 139.582L172.591 139.704C172.976 144.715 177.588 148.09 182.758 147.363L182.536 145.779ZM189.858 137.276C190.167 141.307 186.931 145.16 182.536 145.779L182.758 147.363C187.899 146.64 191.834 142.115 191.453 137.153L189.858 137.276ZM181.509 131.079C185.874 130.465 189.552 133.293 189.858 137.276L191.453 137.153C191.069 132.143 186.456 128.767 181.286 129.495L181.509 131.079ZM174.186 139.582C173.877 135.55 177.114 131.697 181.509 131.079L181.286 129.495C176.145 130.218 172.21 134.743 172.591 139.704L174.186 139.582Z",
    fill: "#143C9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.167 136.656C178.817 136.565 179.306 135.994 179.259 135.38C179.212 134.767 178.647 134.344 177.996 134.436C177.346 134.527 176.857 135.098 176.904 135.712C176.952 136.325 177.517 136.748 178.167 136.656Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.355 133.401C184.705 133.492 184.216 134.063 184.263 134.677C184.31 135.29 184.875 135.713 185.525 135.621C186.176 135.53 186.665 134.959 186.617 134.345C186.57 133.732 186.005 133.309 185.355 133.401Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.827 136.961C185.288 137.037 184.882 137.509 184.917 138.017H184.916L184.917 138.022C185.033 139.53 183.831 140.933 182.232 141.158C180.666 141.378 179.302 140.386 179.137 138.928C179.139 138.896 179.138 138.863 179.135 138.83C179.096 138.319 178.625 137.967 178.083 138.043C177.542 138.119 177.134 138.595 177.173 139.106L177.166 139.107L177.166 139.112C177.361 141.642 179.691 143.386 182.374 143.009C185.056 142.631 187.071 140.279 186.879 137.75L186.879 137.748L186.879 137.747L186.879 137.746L186.879 137.741H186.878C186.835 137.234 186.366 136.885 185.827 136.961Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M164.019 130.711L167.819 162.86H210.229L200.755 109.405C200.755 109.405 177.724 108.129 161.638 115.109",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M186.242 110.483L182.444 98.3464L173.068 104.204L173.016 105.323L172.539 115.666",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 98,
    width: 15,
    height: 18
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.243 110.483L182.445 98.3463L173.069 104.204L173.017 105.323L172.54 115.666",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.185 118.615C180.04 109.794 174.139 107.656 178.272 103.009C182.404 98.3613 168.157 102.803 168.157 102.803L168.123 114.272",
    fill: "#004389"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M186.242 110.483L182.444 98.3464L173.068 104.204L173.016 105.323L172.539 115.666",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M181.296 97.3785L181.119 93.558L175.663 86.6235L164.861 90.2548C163.43 106.28 169.809 112.81 178.764 104.546",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 86,
    width: 18,
    height: 23
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.296 97.3784L181.119 93.558L175.663 86.6234L164.861 90.2548C163.43 106.28 169.809 112.81 178.764 104.546",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.39 102.068C173.511 102.699 173.169 103.327 172.574 103.569L173.39 102.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39 102.068C173.511 102.699 173.169 103.327 172.574 103.569",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M181.296 97.3785L181.119 93.558L175.663 86.6235L164.861 90.2548C163.43 106.28 169.809 112.81 178.764 104.546",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M179.917 98.2123C173.298 94.2084 175.209 90.1883 175.209 90.1883C150.866 106.821 152.792 78.2065 170.86 82.222C170.86 82.222 182.479 73.021 182.219 85.9738C191.824 86.2493 181.412 103.639 179.917 98.2123Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.192 96.5643C183.457 90.5102 189.158 98.9597 180.263 101.767L177.192 96.5643Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.192 96.5643C183.457 90.5102 189.158 98.9597 180.263 101.767",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M168.763 163.411H120.036L108.269 134.193C107.769 132.951 108.5 131.945 109.902 131.945H153.55C154.953 131.945 156.495 132.951 156.995 134.193L168.763 163.411Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M188.189 161.12H118.524L119.701 163.411H191.903L191.631 162.881C191.131 161.909 189.59 161.12 188.189 161.12Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M167.666 163.411H118.94L107.172 134.193C106.672 132.951 107.403 131.945 108.806 131.945H152.453C153.856 131.945 155.398 132.951 155.899 134.193L167.666 163.411Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.735,
    cy: 146.666,
    rx: 3.33172,
    ry: 4.9478,
    transform: "rotate(-59.2443 135.735 146.666)",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.363 120.176L208.329 152.146H225.808L212.256 116.325C210.756 112.177 206.821 109.411 202.41 109.405L197.646 109.276",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 109,
    width: 29,
    height: 44
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.364 120.176L208.33 152.146H225.809L212.257 116.325C210.757 112.177 206.822 109.411 202.411 109.405L197.647 109.276",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.933 144.601C213.046 144.686 224.505 146.551 226.961 149.434C229.416 152.317 226.961 154.607 226.961 154.607L203.089 152.146",
    fill: "#004389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.933 144.601C213.046 144.686 224.505 146.551 226.961 149.434C229.416 152.317 226.961 154.607 226.961 154.607L203.089 152.146",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M200.363 120.176L208.329 152.146H225.808L212.256 116.325C210.756 112.177 206.821 109.411 202.41 109.405L197.646 109.276",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M167.385 150.362C167.385 150.362 168.004 153.565 175.478 147.467C175.478 147.467 173.213 152.859 176.745 153.214C176.745 153.214 178.849 154.33 180.021 153.968C180.021 153.968 182.923 155.273 184.205 155.17C184.205 155.17 185.228 153.576 182.543 152.809L183.36 151.388C183.36 151.388 190.784 151.607 191.895 151.517L217.543 162.242C221.176 163.761 225.329 161.875 226.595 158.131C227.918 154.219 225.512 150.033 221.479 149.23C211.381 147.219 194.396 144.019 190.761 144.093C186.785 144.174 178.879 142.613 176.376 143.084C174.282 143.478 167.385 150.362 167.385 150.362Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5_6810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 142,
    width: 60,
    height: 21
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.386 150.362C167.386 150.362 168.005 153.565 175.478 147.467C175.478 147.467 173.214 152.859 176.746 153.214C176.746 153.214 178.85 154.33 180.022 153.968C180.022 153.968 182.924 155.273 184.206 155.17C184.206 155.17 185.229 153.576 182.544 152.809L183.361 151.388C183.361 151.388 190.785 151.607 191.896 151.517L217.544 162.242C221.177 163.761 225.33 161.875 226.596 158.131C227.919 154.219 225.513 150.033 221.48 149.23C211.382 147.219 194.397 144.019 190.762 144.093C186.786 144.174 178.88 142.613 176.377 143.084C174.283 143.478 167.386 150.362 167.386 150.362Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5_6810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.729 144.669C230.622 153.487 221.847 162.86 221.847 162.86L233.435 161.12L231.635 147.678",
    fill: "#004389"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.385 150.362C167.385 150.362 168.004 153.565 175.478 147.467C175.478 147.467 173.213 152.859 176.745 153.214C176.745 153.214 178.849 154.33 180.021 153.968C180.021 153.968 182.923 155.273 184.205 155.17C184.205 155.17 185.228 153.576 182.543 152.809L183.36 151.388C183.36 151.388 190.784 151.607 191.895 151.517L217.543 162.242C221.176 163.761 225.329 161.875 226.595 158.131V158.131C227.918 154.219 225.512 150.033 221.479 149.23C211.381 147.219 194.396 144.019 190.761 144.093C186.785 144.174 178.879 142.613 176.376 143.084C174.282 143.478 167.385 150.362 167.385 150.362Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.696,
    cy: 147.338,
    rx: 5.11466,
    ry: 6.55569,
    transform: "rotate(-49.4728 135.696 147.338)",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.047 143.766L124.632 147.144L126.12 139.465L117.535 136.087L116.047 143.766Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M125.134 154.073L127.805 152.013L124.94 148.853L122.269 150.913L125.134 154.073Z",
    fill: "#004389",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163.664 86.7726C163.79 87.3061 164.214 87.7333 164.706 87.9704C165.199 88.2074 165.754 88.2765 166.3 88.2922",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.809 97.2033C181.052 97.7426 180.956 98.374 180.563 98.8168",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9 86.2154C181.461 85.9543 182.088 85.8723 182.697 85.9806",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M211.611 133.578L212.286 133.917",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M191.855 149.749C192.036 150.274 192.078 150.838 191.978 151.384",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M149.494 153.603L151.859 155.635",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6421 80.9397C81.361 81.5716 80.3076 82.5854 79.627 83.8412",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M122.263 92.2288L121.055 93.3794",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M186.807 55.0071L185.036 56.7775",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M193.888 126.71V128.923",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M129.639 118.664L126.569 121.351",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.0fc46495fc53c75ee25cda555289a579.svg";
export { ForwardRef as ReactComponent };